(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["PropelAuth"] = factory(require("react"));
	else
		root["PropelAuth"] = factory(root["React"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_react__) {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/@propelauth/javascript/dist/javascript.min.js":
/*!********************************************************************!*\
  !*** ./node_modules/@propelauth/javascript/dist/javascript.min.js ***!
  \********************************************************************/
/***/ (function(__unused_webpack_module, exports) {

!function(e,t){ true?t(exports):0}(this,(function(e){"use strict";function t(e){return new Promise(((t,s)=>{const o=new XMLHttpRequest;o.onreadystatechange=function(){if(o.readyState===XMLHttpRequest.DONE){const r=o.status;if(r>=200&&r<300)try{const n=(e=o.responseText,JSON.parse(e,(function(e,t){if("org_id"===e)this.orgId=t;else if("org_name"===e)this.orgName=t;else if("url_safe_org_name"===e)this.urlSafeOrgName=t;else if("user_role"===e)this.userAssignedRole=t;else if("inherited_user_roles_plus_current_role"===e)this.userInheritedRolesPlusCurrentRole=t;else if("user_permissions"===e)this.userPermissions=t;else if("access_token"===e)this.accessToken=t;else if("expires_at_seconds"===e)this.expiresAtSeconds=t;else if("org_id_to_org_member_info"===e)this.orgIdToOrgMemberInfo=t,this.orgHelper=(n=t,{getOrg:e=>n.hasOwnProperty(e)?n[e]:void 0,getOrgIds:()=>Object.keys(n),getOrgs:()=>Object.values(n),getOrgByName(e){for(const t of Object.values(n))if(t.orgName===e||t.urlSafeOrgName===e)return t}}),this.accessHelper=function(e){function t(t,n){const s=e[t];return void 0!==s&&s.userAssignedRole===n}function n(t,n){const s=e[t];return void 0!==s&&s.userInheritedRolesPlusCurrentRole.includes(n)}function s(t,n){const s=e[t];return void 0!==s&&s.userPermissions.includes(n)}function o(t,n){const s=e[t];return void 0!==s&&n.every((e=>s.userPermissions.includes(e)))}return{isRole:t,isAtLeastRole:n,hasPermission:s,hasAllPermissions:o,getAccessHelperWithOrgId:function(e){return{isRole:n=>t(e,n),isAtLeastRole:t=>n(e,t),hasPermission:t=>s(e,t),hasAllPermissions:t=>o(e,t)}}}}(t);else if("user_id"===e)this.userId=t;else if("email_confirmed"===e)this.emailConfirmed=t;else if("first_name"===e)this.firstName=t;else if("last_name"===e)this.lastName=t;else if("picture_url"===e)this.pictureUrl=t;else if("mfa_enabled"===e)this.mfaEnabled=t;else if("has_password"===e)this.hasPassword=t;else if("created_at"===e)this.createdAt=t;else if("last_active_at"===e)this.lastActiveAt=t;else{if("legacy_user_id"!==e)return t;this.legacyUserId=t}var n})));t(n)}catch(e){console.error("Unable to process authentication response",e),s({status:500,message:"Unable to process authentication response"})}else 401===r?t(null):0===r?(n(),s({status:503,message:"Unable to process authentication response"})):s({status:r,message:o.responseText})}var e},o.open("get",`${e}/api/v1/refresh_token`),o.withCredentials=!0,o.ontimeout=function(){s({status:408,message:"Request timed out"})},o.send(null)}))}function n(){console.error("Request to PropelAuth failed due to a CORS error. There are a few likely causes: \n 1. In the Frontend Integration section of your dashboard, make sure your requests are coming either the specified Application URL or localhost with a matching port.\n 2. Make sure your server is hosted on HTTPS in production.")}function s(){return Date.now()/1e3}function o(){return"undefined"!=typeof localStorage}function r(e){if(!o())return null;const t=localStorage.getItem(e);if(!t)return null;const n=parseInt(t,10);return Number.isNaN(n)?null:n}const i="__PROPEL_AUTH_LOGGED_IN_AT",a="__PROPEL_AUTH_LOGGED_OUT_AT";e.createClient=function(e){!function(e){try{const t=new URL(e.authUrl);e.authUrl=t.origin}catch(e){throw console.error("Invalid authUrl",e),new Error("Unable to initialize auth client")}void 0===e.enableBackgroundTokenRefresh&&(e.enableBackgroundTokenRefresh=!0)}(e);const l={initialLoadFinished:!1,authenticationInfo:null,observers:[],lastLoggedInAtMessage:r(i),lastLoggedOutAtMessage:r(a),authUrl:e.authUrl,refreshInterval:null,lastRefresh:null};function u(e){for(let t=0;t<l.observers.length;t++){const n=l.observers[t];n&&n(e)}}function c(e){var t;const n=null===(t=l.authenticationInfo)||void 0===t?void 0:t.accessToken;l.authenticationInfo=e;const o=null==e?void 0:e.accessToken;!function(e,t){return!e&&(t||!l.initialLoadFinished)}(o,n)?function(e,t){return!t&&e}(o,n)&&(u(!0),function(){const e=s();l.lastLoggedInAtMessage=e,localStorage.setItem(i,String(e))}()):(u(!1),function(){const e=s();l.lastLoggedOutAtMessage=e,localStorage.setItem(a,String(e))}()),l.lastRefresh=s(),l.initialLoadFinished=!0}async function d(e){try{const e=await t(l.authUrl);return c(e),e}catch(t){if(e)return l.authenticationInfo;throw c(null),t}}const f={addLoggedInChangeObserver(e){l.observers.includes(e)?console.error("Observer has been attached already."):e?l.observers.push(e):console.error("Cannot add a null observer")},removeLoggedInChangeObserver(e){const t=l.observers.indexOf(e);-1===t?console.error("Cannot find observer to remove"):l.observers.splice(t,1)},async getAuthenticationInfoOrNull(e){const t=s();if(e)return await d(!1);if(l.authenticationInfo){if(t+240>l.authenticationInfo.expiresAtSeconds){const e=t<l.authenticationInfo.expiresAtSeconds;return await d(e)}return l.authenticationInfo}return await d(!1)},redirectToSignupPage(e){let t="";if(e&&e.postSignupRedirectUrl){const n=window?window.btoa:btoa;t=new URLSearchParams({rt:n(e.postSignupRedirectUrl)}).toString()}window.location.href=`${l.authUrl}/signup?${t}`},redirectToLoginPage(e){let t="";if(e&&e.postLoginRedirectUrl){const n=window?window.btoa:btoa;t=new URLSearchParams({rt:n(e.postLoginRedirectUrl)}).toString()}window.location.href=`${l.authUrl}/login?${t}`},redirectToAccountPage(){window.location.href=`${l.authUrl}/account`},redirectToOrgPage(e){window.location.href=e?`${l.authUrl}/org?id=${e}`:`${l.authUrl}/org`},redirectToCreateOrgPage(){window.location.href=`${l.authUrl}/create_org`},async logout(e){const t=await(s=l.authUrl,new Promise(((e,t)=>{const o=new XMLHttpRequest;o.onreadystatechange=function(){if(o.readyState===XMLHttpRequest.DONE){const s=o.status;if(s>=200&&s<300){const t=JSON.parse(o.responseText);e(t)}else 0===s?(n(),t({status:503,message:"Unable to process authentication response"})):(console.error("Logout error",o.status,o.responseText),t({status:s,message:o.responseText}))}},o.open("post",`${s}/api/v1/logout`),o.withCredentials=!0,o.ontimeout=function(){t({status:408,message:"Request timed out"})},o.send(null)})));var s;c(null),e&&(window.location.href=t.redirect_to)},destroy(){l.observers=[],window.removeEventListener("storage",g),l.refreshInterval&&clearInterval(l.refreshInterval)}},g=async function(){if(!o())return;const e=r(a),t=r(i);e&&(!l.lastLoggedOutAtMessage||e>l.lastLoggedOutAtMessage)&&(l.lastLoggedOutAtMessage=e,l.authenticationInfo&&await d(!0)),t&&(!l.lastLoggedInAtMessage||t>l.lastLoggedInAtMessage)&&(l.lastLoggedInAtMessage=t,l.authenticationInfo||await d(!0))},h=async function(){l.lastRefresh&&s()>l.lastRefresh+240?await d(!0):await f.getAuthenticationInfoOrNull()};return"undefined"!=typeof window&&(window.addEventListener("storage",g),window.addEventListener("online",h),window.addEventListener("focus",h),e.enableBackgroundTokenRefresh&&(f.getAuthenticationInfoOrNull(),l.refreshInterval=window.setInterval(f.getAuthenticationInfoOrNull,6e4))),f}}));
//# sourceMappingURL=javascript.min.js.map


/***/ }),

/***/ "./node_modules/@propelauth/js-apis/dist/browser/cjs/index.js":
/*!********************************************************************!*\
  !*** ./node_modules/@propelauth/js-apis/dist/browser/cjs/index.js ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/resources/commons/types/OrgId.ts
var init_OrgId = __esm({
  "src/resources/commons/types/OrgId.ts"() {
    "use strict";
  }
});

// src/resources/commons/types/UserId.ts
var init_UserId = __esm({
  "src/resources/commons/types/UserId.ts"() {
    "use strict";
  }
});

// src/resources/commons/types/LoginStateResponse.ts
var init_LoginStateResponse = __esm({
  "src/resources/commons/types/LoginStateResponse.ts"() {
    "use strict";
  }
});

// src/resources/commons/types/LoginStateEnum.ts
var LoginStateEnum;
var init_LoginStateEnum = __esm({
  "src/resources/commons/types/LoginStateEnum.ts"() {
    "use strict";
    LoginStateEnum = {
      LoginRequired: "LoginRequired",
      TwoFactorRequired: "TwoFactorRequired",
      ConfirmEmailRequired: "ConfirmEmailRequired",
      UserMetadataRequired: "UserMetadataRequired",
      OrgCreationRequired: "OrgCreationRequired",
      UpdatePasswordRequired: "UpdatePasswordRequired",
      Finished: "Finished"
    };
  }
});

// src/resources/commons/types/EncodedUserIdAndToken.ts
var init_EncodedUserIdAndToken = __esm({
  "src/resources/commons/types/EncodedUserIdAndToken.ts"() {
    "use strict";
  }
});

// src/resources/commons/types/GenericError.ts
var init_GenericError = __esm({
  "src/resources/commons/types/GenericError.ts"() {
    "use strict";
  }
});

// src/resources/commons/types/index.ts
var init_types = __esm({
  "src/resources/commons/types/index.ts"() {
    "use strict";
    init_OrgId();
    init_UserId();
    init_LoginStateResponse();
    init_LoginStateEnum();
    init_EncodedUserIdAndToken();
    init_GenericError();
  }
});

// src/resources/commons/errors/Forbidden.ts
var init_Forbidden = __esm({
  "src/resources/commons/errors/Forbidden.ts"() {
    "use strict";
  }
});

// src/resources/commons/errors/index.ts
var init_errors = __esm({
  "src/resources/commons/errors/index.ts"() {
    "use strict";
    init_Forbidden();
  }
});

// src/resources/commons/index.ts
var commons_exports = {};
__export(commons_exports, {
  LoginStateEnum: () => LoginStateEnum
});
var init_commons = __esm({
  "src/resources/commons/index.ts"() {
    "use strict";
    init_types();
    init_errors();
  }
});

// src/resources/config/types/AuthConfigurationResponse.ts
var init_AuthConfigurationResponse = __esm({
  "src/resources/config/types/AuthConfigurationResponse.ts"() {
    "use strict";
  }
});

// src/resources/config/types/index.ts
var init_types2 = __esm({
  "src/resources/config/types/index.ts"() {
    "use strict";
    init_AuthConfigurationResponse();
  }
});

// src/core/utils/addNonEnumerableProperty.ts
function addNonEnumerableProperty(object2, key, value) {
  const copy = { ...object2 };
  Object.defineProperty(copy, key, {
    enumerable: false,
    writable: true
  });
  copy[key] = value;
  return copy;
}
var init_addNonEnumerableProperty = __esm({
  "src/core/utils/addNonEnumerableProperty.ts"() {
    "use strict";
  }
});

// src/core/utils/index.ts
var init_utils = __esm({
  "src/core/utils/index.ts"() {
    "use strict";
    init_addNonEnumerableProperty();
  }
});

// src/core/schemas/builders/schema-utils/types.ts
var OPTIONAL_BRAND;
var init_types3 = __esm({
  "src/core/schemas/builders/schema-utils/types.ts"() {
    "use strict";
    OPTIONAL_BRAND = void 0;
  }
});

// src/core/schemas/builders/schema-utils/getSchemaUtils.ts
function getSchemaUtils(schema) {
  return {
    optional: () => optional(schema),
    transform: (transformer) => transform(schema, transformer)
  };
}
function optional(schema) {
  const baseSchema = {
    parse: (raw, opts) => raw != null ? schema.parse(raw, opts) : void 0,
    json: (parsed, opts) => parsed != null ? schema.json(parsed, opts) : void 0
  };
  return {
    ...OPTIONAL_BRAND,
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
function transform(schema, transformer) {
  const baseSchema = {
    parse: async (raw, opts) => {
      const postTransformParsed = await schema.parse(raw, opts);
      return transformer.parse(postTransformParsed, opts);
    },
    json: async (parsed, opts) => {
      const preTransformParsed = await transformer.json(parsed, opts);
      return schema.json(preTransformParsed, opts);
    }
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
var init_getSchemaUtils = __esm({
  "src/core/schemas/builders/schema-utils/getSchemaUtils.ts"() {
    "use strict";
    init_types3();
  }
});

// src/core/schemas/builders/schema-utils/index.ts
var init_schema_utils = __esm({
  "src/core/schemas/builders/schema-utils/index.ts"() {
    "use strict";
    init_getSchemaUtils();
    init_types3();
  }
});

// src/core/schemas/builders/date/date.ts
function date() {
  const baseSchema = {
    parse: (raw) => new Date(raw),
    json: (date2) => date2.toISOString()
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
var init_date = __esm({
  "src/core/schemas/builders/date/date.ts"() {
    "use strict";
    init_schema_utils();
  }
});

// src/core/schemas/builders/date/index.ts
var init_date2 = __esm({
  "src/core/schemas/builders/date/index.ts"() {
    "use strict";
    init_date();
  }
});

// src/core/schemas/builders/identity/identity.ts
function identity() {
  const baseSchema = {
    parse: (raw) => raw,
    json: (parsed) => parsed
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
var init_identity = __esm({
  "src/core/schemas/builders/identity/identity.ts"() {
    "use strict";
    init_schema_utils();
  }
});

// src/core/schemas/builders/identity/createIdentitySchemaCreator.ts
function createIdentitySchemaCreator() {
  return () => identity();
}
var init_createIdentitySchemaCreator = __esm({
  "src/core/schemas/builders/identity/createIdentitySchemaCreator.ts"() {
    "use strict";
    init_identity();
  }
});

// src/core/schemas/builders/identity/index.ts
var init_identity2 = __esm({
  "src/core/schemas/builders/identity/index.ts"() {
    "use strict";
    init_createIdentitySchemaCreator();
    init_identity();
  }
});

// src/core/schemas/builders/enum/enum.ts
function enum_(_values) {
  return createIdentitySchemaCreator()();
}
var init_enum = __esm({
  "src/core/schemas/builders/enum/enum.ts"() {
    "use strict";
    init_identity2();
  }
});

// src/core/schemas/builders/enum/index.ts
var init_enum2 = __esm({
  "src/core/schemas/builders/enum/index.ts"() {
    "use strict";
    init_enum();
  }
});

// src/core/schemas/builders/lazy/lazy.ts
function lazy(getter) {
  const baseSchema = constructLazyBaseSchema(getter);
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
function constructLazyBaseSchema(getter) {
  return {
    parse: async (raw) => (await getMemoizedSchema(getter)).parse(raw),
    json: async (parsed) => (await getMemoizedSchema(getter)).json(parsed)
  };
}
async function getMemoizedSchema(getter) {
  const castedGetter = getter;
  if (castedGetter.__zurg_memoized == null) {
    castedGetter.__zurg_memoized = await getter();
  }
  return castedGetter.__zurg_memoized;
}
var init_lazy = __esm({
  "src/core/schemas/builders/lazy/lazy.ts"() {
    "use strict";
    init_schema_utils();
  }
});

// src/core/schemas/utils/entries.ts
function entries(object2) {
  return Object.entries(object2);
}
var init_entries = __esm({
  "src/core/schemas/utils/entries.ts"() {
    "use strict";
  }
});

// src/core/schemas/utils/filterObject.ts
function filterObject(obj, keysToInclude) {
  const keysToIncludeSet = new Set(keysToInclude);
  return Object.entries(obj).reduce((acc, [key, value]) => {
    if (keysToIncludeSet.has(key)) {
      acc[key] = value;
    }
    return acc;
  }, {});
}
var init_filterObject = __esm({
  "src/core/schemas/utils/filterObject.ts"() {
    "use strict";
  }
});

// src/core/schemas/utils/keys.ts
function keys(object2) {
  return Object.keys(object2);
}
var init_keys = __esm({
  "src/core/schemas/utils/keys.ts"() {
    "use strict";
  }
});

// src/core/schemas/utils/partition.ts
function partition(items, predicate) {
  const trueItems = [], falseItems = [];
  for (const item of items) {
    if (predicate(item)) {
      trueItems.push(item);
    } else {
      falseItems.push(item);
    }
  }
  return [trueItems, falseItems];
}
var init_partition = __esm({
  "src/core/schemas/utils/partition.ts"() {
    "use strict";
  }
});

// src/core/schemas/builders/object-like/types.ts
var OBJECT_LIKE_BRAND;
var init_types4 = __esm({
  "src/core/schemas/builders/object-like/types.ts"() {
    "use strict";
    OBJECT_LIKE_BRAND = void 0;
  }
});

// src/core/schemas/builders/object-like/getObjectLikeUtils.ts
function getObjectLikeUtils(schema) {
  return {
    withProperties: (properties) => withProperties(schema, properties)
  };
}
function withProperties(objectLike, properties) {
  const objectSchema = {
    ...OBJECT_LIKE_BRAND,
    parse: async (raw, opts) => {
      const parsedObject = await objectLike.parse(raw, opts);
      const additionalProperties = Object.entries(properties).reduce((processed, [key, value]) => {
        return {
          ...processed,
          [key]: typeof value === "function" ? value(parsedObject) : value
        };
      }, {});
      return {
        ...parsedObject,
        ...additionalProperties
      };
    },
    json: (parsed, opts) => {
      const addedPropertyKeys = new Set(Object.keys(properties));
      const parsedWithoutAddedProperties = Object.entries(parsed).reduce(
        (filtered, [key, value]) => {
          if (!addedPropertyKeys.has(key)) {
            filtered[key] = value;
          }
          return filtered;
        },
        {}
      );
      return objectLike.json(parsedWithoutAddedProperties, opts);
    }
  };
  return {
    ...objectSchema,
    ...getSchemaUtils(objectSchema),
    ...getObjectLikeUtils(objectSchema)
  };
}
var init_getObjectLikeUtils = __esm({
  "src/core/schemas/builders/object-like/getObjectLikeUtils.ts"() {
    "use strict";
    init_schema_utils();
    init_types4();
  }
});

// src/core/schemas/builders/object-like/index.ts
var init_object_like = __esm({
  "src/core/schemas/builders/object-like/index.ts"() {
    "use strict";
    init_getObjectLikeUtils();
    init_types4();
  }
});

// src/core/schemas/builders/object/property.ts
function property(rawKey, valueSchema) {
  return {
    rawKey,
    valueSchema,
    isProperty: true
  };
}
function isProperty(maybeProperty) {
  return maybeProperty.isProperty;
}
var init_property = __esm({
  "src/core/schemas/builders/object/property.ts"() {
    "use strict";
  }
});

// src/core/schemas/builders/object/object.ts
function object(schemas) {
  const baseSchema = {
    ...OBJECT_LIKE_BRAND,
    _getRawProperties: () => Promise.resolve(
      Object.entries(schemas).map(
        ([parsedKey, propertySchema]) => isProperty(propertySchema) ? propertySchema.rawKey : parsedKey
      )
    ),
    _getParsedProperties: () => Promise.resolve(keys(schemas)),
    parse: async (raw, { skipUnknownKeysOnParse = false } = {}) => {
      const rawKeyToProperty = {};
      for (const [parsedKey, schemaOrObjectProperty] of entries(schemas)) {
        const rawKey = isProperty(schemaOrObjectProperty) ? schemaOrObjectProperty.rawKey : parsedKey;
        const property2 = {
          rawKey,
          parsedKey,
          valueSchema: isProperty(schemaOrObjectProperty) ? schemaOrObjectProperty.valueSchema : schemaOrObjectProperty
        };
        rawKeyToProperty[rawKey] = property2;
      }
      const parsed = {};
      for (const [rawKey, rawPropertyValue] of Object.entries(raw)) {
        const property2 = rawKeyToProperty[rawKey];
        if (property2 != null) {
          const value = await property2.valueSchema.parse(rawPropertyValue);
          parsed[property2.parsedKey] = value;
        } else if (!skipUnknownKeysOnParse && rawPropertyValue != null) {
          parsed[rawKey] = rawPropertyValue;
        }
      }
      return parsed;
    },
    json: async (parsed, { includeUnknownKeysOnJson = false } = {}) => {
      const raw = {};
      for (const [parsedKey, parsedPropertyValue] of entries(parsed)) {
        const schemaOrObjectProperty = schemas[parsedKey];
        if (schemaOrObjectProperty != null) {
          if (isProperty(schemaOrObjectProperty)) {
            const value = await schemaOrObjectProperty.valueSchema.json(parsedPropertyValue);
            raw[schemaOrObjectProperty.rawKey] = value;
          } else {
            const value = await schemaOrObjectProperty.json(parsedPropertyValue);
            raw[parsedKey] = value;
          }
        } else if (includeUnknownKeysOnJson && parsedPropertyValue != null) {
          raw[parsedKey] = parsedPropertyValue;
        }
      }
      return raw;
    }
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema),
    ...getObjectLikeUtils(baseSchema),
    ...getObjectUtils(baseSchema)
  };
}
function getObjectUtils(schema) {
  return {
    extend: (extension) => {
      const baseSchema = {
        ...OBJECT_LIKE_BRAND,
        _getParsedProperties: async () => [
          ...await schema._getParsedProperties(),
          ...await extension._getParsedProperties()
        ],
        _getRawProperties: async () => [
          ...await schema._getRawProperties(),
          ...await extension._getRawProperties()
        ],
        parse: async (raw, opts) => {
          const rawExtensionPropertiesSet = new Set(await extension._getRawProperties());
          const [extensionProperties, otherProperties] = partition(
            keys(raw),
            (key) => rawExtensionPropertiesSet.has(key)
          );
          return {
            ...await schema.parse(filterObject(raw, otherProperties), opts),
            ...await extension.parse(filterObject(raw, extensionProperties), opts)
          };
        },
        json: async (parsed, opts) => {
          const parsedExtensionPropertiesSet = new Set(await extension._getParsedProperties());
          const [extensionProperties, otherProperties] = partition(
            keys(parsed),
            (key) => parsedExtensionPropertiesSet.has(key)
          );
          return {
            ...await schema.json(filterObject(parsed, otherProperties), opts),
            ...await extension.json(filterObject(parsed, extensionProperties), opts)
          };
        }
      };
      return {
        ...baseSchema,
        ...getSchemaUtils(baseSchema),
        ...getObjectLikeUtils(baseSchema),
        ...getObjectUtils(baseSchema)
      };
    }
  };
}
var init_object = __esm({
  "src/core/schemas/builders/object/object.ts"() {
    "use strict";
    init_entries();
    init_filterObject();
    init_keys();
    init_partition();
    init_object_like();
    init_schema_utils();
    init_property();
  }
});

// src/core/schemas/builders/object/index.ts
var init_object2 = __esm({
  "src/core/schemas/builders/object/index.ts"() {
    "use strict";
    init_object();
    init_property();
  }
});

// src/core/schemas/builders/lazy/lazyObject.ts
function lazyObject(getter) {
  const baseSchema = {
    ...OBJECT_LIKE_BRAND,
    ...constructLazyBaseSchema(getter),
    _getRawProperties: async () => (await getMemoizedSchema(getter))._getRawProperties(),
    _getParsedProperties: async () => (await getMemoizedSchema(getter))._getParsedProperties()
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema),
    ...getObjectLikeUtils(baseSchema),
    ...getObjectUtils(baseSchema)
  };
}
var init_lazyObject = __esm({
  "src/core/schemas/builders/lazy/lazyObject.ts"() {
    "use strict";
    init_object2();
    init_object_like();
    init_schema_utils();
    init_lazy();
  }
});

// src/core/schemas/builders/lazy/index.ts
var init_lazy2 = __esm({
  "src/core/schemas/builders/lazy/index.ts"() {
    "use strict";
    init_lazy();
    init_lazyObject();
  }
});

// src/core/schemas/builders/list/list.ts
function list(schema) {
  const baseSchema = {
    parse: (raw, opts) => Promise.all(raw.map((item) => schema.parse(item, opts))),
    json: (parsed, opts) => Promise.all(parsed.map((item) => schema.json(item, opts)))
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
var init_list = __esm({
  "src/core/schemas/builders/list/list.ts"() {
    "use strict";
    init_schema_utils();
  }
});

// src/core/schemas/builders/list/index.ts
var init_list2 = __esm({
  "src/core/schemas/builders/list/index.ts"() {
    "use strict";
    init_list();
  }
});

// src/core/schemas/builders/literals/stringLiteral.ts
function stringLiteral(_value) {
  return createIdentitySchemaCreator()();
}
var init_stringLiteral = __esm({
  "src/core/schemas/builders/literals/stringLiteral.ts"() {
    "use strict";
    init_identity2();
  }
});

// src/core/schemas/builders/literals/index.ts
var init_literals = __esm({
  "src/core/schemas/builders/literals/index.ts"() {
    "use strict";
    init_stringLiteral();
  }
});

// src/core/schemas/builders/primitives/any.ts
var any;
var init_any = __esm({
  "src/core/schemas/builders/primitives/any.ts"() {
    "use strict";
    init_identity2();
    any = createIdentitySchemaCreator();
  }
});

// src/core/schemas/builders/primitives/boolean.ts
var boolean;
var init_boolean = __esm({
  "src/core/schemas/builders/primitives/boolean.ts"() {
    "use strict";
    init_identity2();
    boolean = createIdentitySchemaCreator();
  }
});

// src/core/schemas/builders/primitives/number.ts
var number;
var init_number = __esm({
  "src/core/schemas/builders/primitives/number.ts"() {
    "use strict";
    init_identity2();
    number = createIdentitySchemaCreator();
  }
});

// src/core/schemas/builders/primitives/string.ts
var string;
var init_string = __esm({
  "src/core/schemas/builders/primitives/string.ts"() {
    "use strict";
    init_identity2();
    string = createIdentitySchemaCreator();
  }
});

// src/core/schemas/builders/primitives/unknown.ts
var unknown;
var init_unknown = __esm({
  "src/core/schemas/builders/primitives/unknown.ts"() {
    "use strict";
    init_identity2();
    unknown = createIdentitySchemaCreator();
  }
});

// src/core/schemas/builders/primitives/index.ts
var init_primitives = __esm({
  "src/core/schemas/builders/primitives/index.ts"() {
    "use strict";
    init_any();
    init_boolean();
    init_number();
    init_string();
    init_unknown();
  }
});

// src/core/schemas/builders/record/record.ts
function record(keySchema, valueSchema) {
  const baseSchema = {
    parse: (raw, opts) => {
      return entries(raw).reduce(async (parsedPromise, [key, value]) => {
        const parsed = await parsedPromise;
        const parsedKey = await keySchema.parse(key, opts);
        parsed[parsedKey] = await valueSchema.parse(value, opts);
        return parsedPromise;
      }, Promise.resolve({}));
    },
    json: (parsed, opts) => {
      return entries(parsed).reduce(async (rawPromise, [key, value]) => {
        const raw = await rawPromise;
        const rawKey = await keySchema.json(key, opts);
        raw[rawKey] = await valueSchema.json(value, opts);
        return rawPromise;
      }, Promise.resolve({}));
    }
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
var init_record = __esm({
  "src/core/schemas/builders/record/record.ts"() {
    "use strict";
    init_entries();
    init_schema_utils();
  }
});

// src/core/schemas/builders/record/index.ts
var init_record2 = __esm({
  "src/core/schemas/builders/record/index.ts"() {
    "use strict";
    init_record();
  }
});

// src/core/schemas/builders/set/set.ts
function set(schema) {
  const baseSchema = {
    parse: async (raw, opts) => new Set(await Promise.all(raw.map((item) => schema.parse(item, opts)))),
    json: (parsed, opts) => Promise.all([...parsed].map((item) => schema.json(item, opts)))
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema)
  };
}
var init_set = __esm({
  "src/core/schemas/builders/set/set.ts"() {
    "use strict";
    init_schema_utils();
  }
});

// src/core/schemas/builders/set/index.ts
var init_set2 = __esm({
  "src/core/schemas/builders/set/index.ts"() {
    "use strict";
    init_set();
  }
});

// src/core/schemas/builders/union/discriminant.ts
function discriminant(parsedDiscriminant, rawDiscriminant) {
  return {
    parsedDiscriminant,
    rawDiscriminant
  };
}
var init_discriminant = __esm({
  "src/core/schemas/builders/union/discriminant.ts"() {
    "use strict";
  }
});

// src/core/schemas/builders/union/union.ts
function union(discriminant2, union2) {
  const rawDiscriminant = typeof discriminant2 === "string" ? discriminant2 : discriminant2.rawDiscriminant;
  const parsedDiscriminant = typeof discriminant2 === "string" ? discriminant2 : discriminant2.parsedDiscriminant;
  const baseSchema = {
    ...OBJECT_LIKE_BRAND,
    parse: async (raw, opts) => {
      const { [rawDiscriminant]: discriminantValue, ...additionalProperties } = raw;
      const additionalPropertySchemas = union2[discriminantValue];
      if (additionalPropertySchemas == null) {
        return {
          ...additionalProperties,
          [parsedDiscriminant]: discriminantValue
        };
      }
      return {
        ...await additionalPropertySchemas.parse(additionalProperties, opts),
        [parsedDiscriminant]: discriminantValue
      };
    },
    json: async (parsed, opts) => {
      const { [parsedDiscriminant]: discriminantValue, ...additionalProperties } = parsed;
      const additionalPropertySchemas = union2[discriminantValue];
      if (additionalPropertySchemas == null) {
        return {
          ...additionalProperties,
          [rawDiscriminant]: discriminantValue
        };
      }
      return {
        ...await additionalPropertySchemas.json(additionalProperties, opts),
        [rawDiscriminant]: discriminantValue
      };
    }
  };
  return {
    ...baseSchema,
    ...getSchemaUtils(baseSchema),
    ...getObjectLikeUtils(baseSchema)
  };
}
var init_union = __esm({
  "src/core/schemas/builders/union/union.ts"() {
    "use strict";
    init_object_like();
    init_schema_utils();
  }
});

// src/core/schemas/builders/union/index.ts
var init_union2 = __esm({
  "src/core/schemas/builders/union/index.ts"() {
    "use strict";
    init_discriminant();
    init_union();
  }
});

// src/core/schemas/builders/index.ts
var init_builders = __esm({
  "src/core/schemas/builders/index.ts"() {
    "use strict";
    init_date2();
    init_enum2();
    init_identity2();
    init_lazy2();
    init_list2();
    init_literals();
    init_object2();
    init_object_like();
    init_primitives();
    init_record2();
    init_schema_utils();
    init_set2();
    init_union2();
  }
});

// src/core/schemas/index.ts
var schemas_exports = {};
__export(schemas_exports, {
  OBJECT_LIKE_BRAND: () => OBJECT_LIKE_BRAND,
  OPTIONAL_BRAND: () => OPTIONAL_BRAND,
  any: () => any,
  boolean: () => boolean,
  createIdentitySchemaCreator: () => createIdentitySchemaCreator,
  date: () => date,
  discriminant: () => discriminant,
  enum_: () => enum_,
  getObjectLikeUtils: () => getObjectLikeUtils,
  getObjectUtils: () => getObjectUtils,
  getSchemaUtils: () => getSchemaUtils,
  identity: () => identity,
  isProperty: () => isProperty,
  lazy: () => lazy,
  lazyObject: () => lazyObject,
  list: () => list,
  number: () => number,
  object: () => object,
  optional: () => optional,
  property: () => property,
  record: () => record,
  set: () => set,
  string: () => string,
  stringLiteral: () => stringLiteral,
  transform: () => transform,
  union: () => union,
  unknown: () => unknown,
  withProperties: () => withProperties
});
var init_schemas = __esm({
  "src/core/schemas/index.ts"() {
    "use strict";
    init_builders();
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/bind.js
var require_bind = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/bind.js"(exports, module2) {
    "use strict";
    module2.exports = function bind(fn, thisArg) {
      return function wrap() {
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i];
        }
        return fn.apply(thisArg, args);
      };
    };
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/utils.js
var require_utils = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/utils.js"(exports, module2) {
    "use strict";
    var bind = require_bind();
    var toString = Object.prototype.toString;
    var kindOf = function(cache) {
      return function(thing) {
        var str = toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
      };
    }(/* @__PURE__ */ Object.create(null));
    function kindOfTest(type) {
      type = type.toLowerCase();
      return function isKindOf(thing) {
        return kindOf(thing) === type;
      };
    }
    function isArray(val) {
      return Array.isArray(val);
    }
    function isUndefined(val) {
      return typeof val === "undefined";
    }
    function isBuffer(val) {
      return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
    }
    var isArrayBuffer = kindOfTest("ArrayBuffer");
    function isArrayBufferView(val) {
      var result;
      if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
        result = ArrayBuffer.isView(val);
      } else {
        result = val && val.buffer && isArrayBuffer(val.buffer);
      }
      return result;
    }
    function isString(val) {
      return typeof val === "string";
    }
    function isNumber(val) {
      return typeof val === "number";
    }
    function isObject(val) {
      return val !== null && typeof val === "object";
    }
    function isPlainObject(val) {
      if (kindOf(val) !== "object") {
        return false;
      }
      var prototype = Object.getPrototypeOf(val);
      return prototype === null || prototype === Object.prototype;
    }
    var isDate = kindOfTest("Date");
    var isFile = kindOfTest("File");
    var isBlob = kindOfTest("Blob");
    var isFileList = kindOfTest("FileList");
    function isFunction(val) {
      return toString.call(val) === "[object Function]";
    }
    function isStream(val) {
      return isObject(val) && isFunction(val.pipe);
    }
    function isFormData(thing) {
      var pattern = "[object FormData]";
      return thing && (typeof FormData === "function" && thing instanceof FormData || toString.call(thing) === pattern || isFunction(thing.toString) && thing.toString() === pattern);
    }
    var isURLSearchParams = kindOfTest("URLSearchParams");
    function trim(str) {
      return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    function isStandardBrowserEnv() {
      if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
        return false;
      }
      return typeof window !== "undefined" && typeof document !== "undefined";
    }
    function forEach(obj, fn) {
      if (obj === null || typeof obj === "undefined") {
        return;
      }
      if (typeof obj !== "object") {
        obj = [obj];
      }
      if (isArray(obj)) {
        for (var i = 0, l = obj.length; i < l; i++) {
          fn.call(null, obj[i], i, obj);
        }
      } else {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn.call(null, obj[key], key, obj);
          }
        }
      }
    }
    function merge() {
      var result = {};
      function assignValue(val, key) {
        if (isPlainObject(result[key]) && isPlainObject(val)) {
          result[key] = merge(result[key], val);
        } else if (isPlainObject(val)) {
          result[key] = merge({}, val);
        } else if (isArray(val)) {
          result[key] = val.slice();
        } else {
          result[key] = val;
        }
      }
      for (var i = 0, l = arguments.length; i < l; i++) {
        forEach(arguments[i], assignValue);
      }
      return result;
    }
    function extend(a, b, thisArg) {
      forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") {
          a[key] = bind(val, thisArg);
        } else {
          a[key] = val;
        }
      });
      return a;
    }
    function stripBOM(content) {
      if (content.charCodeAt(0) === 65279) {
        content = content.slice(1);
      }
      return content;
    }
    function inherits(constructor, superConstructor, props, descriptors) {
      constructor.prototype = Object.create(superConstructor.prototype, descriptors);
      constructor.prototype.constructor = constructor;
      props && Object.assign(constructor.prototype, props);
    }
    function toFlatObject(sourceObj, destObj, filter) {
      var props;
      var i;
      var prop;
      var merged = {};
      destObj = destObj || {};
      do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while (i-- > 0) {
          prop = props[i];
          if (!merged[prop]) {
            destObj[prop] = sourceObj[prop];
            merged[prop] = true;
          }
        }
        sourceObj = Object.getPrototypeOf(sourceObj);
      } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
      return destObj;
    }
    function endsWith(str, searchString, position) {
      str = String(str);
      if (position === void 0 || position > str.length) {
        position = str.length;
      }
      position -= searchString.length;
      var lastIndex = str.indexOf(searchString, position);
      return lastIndex !== -1 && lastIndex === position;
    }
    function toArray(thing) {
      if (!thing)
        return null;
      var i = thing.length;
      if (isUndefined(i))
        return null;
      var arr = new Array(i);
      while (i-- > 0) {
        arr[i] = thing[i];
      }
      return arr;
    }
    var isTypedArray = function(TypedArray) {
      return function(thing) {
        return TypedArray && thing instanceof TypedArray;
      };
    }(typeof Uint8Array !== "undefined" && Object.getPrototypeOf(Uint8Array));
    module2.exports = {
      isArray,
      isArrayBuffer,
      isBuffer,
      isFormData,
      isArrayBufferView,
      isString,
      isNumber,
      isObject,
      isPlainObject,
      isUndefined,
      isDate,
      isFile,
      isBlob,
      isFunction,
      isStream,
      isURLSearchParams,
      isStandardBrowserEnv,
      forEach,
      merge,
      extend,
      trim,
      stripBOM,
      inherits,
      toFlatObject,
      kindOf,
      kindOfTest,
      endsWith,
      toArray,
      isTypedArray,
      isFileList
    };
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/buildURL.js
var require_buildURL = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/buildURL.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    function encode(val) {
      return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }
    module2.exports = function buildURL(url, params, paramsSerializer) {
      if (!params) {
        return url;
      }
      var serializedParams;
      if (paramsSerializer) {
        serializedParams = paramsSerializer(params);
      } else if (utils.isURLSearchParams(params)) {
        serializedParams = params.toString();
      } else {
        var parts = [];
        utils.forEach(params, function serialize(val, key) {
          if (val === null || typeof val === "undefined") {
            return;
          }
          if (utils.isArray(val)) {
            key = key + "[]";
          } else {
            val = [val];
          }
          utils.forEach(val, function parseValue(v) {
            if (utils.isDate(v)) {
              v = v.toISOString();
            } else if (utils.isObject(v)) {
              v = JSON.stringify(v);
            }
            parts.push(encode(key) + "=" + encode(v));
          });
        });
        serializedParams = parts.join("&");
      }
      if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) {
          url = url.slice(0, hashmarkIndex);
        }
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
      }
      return url;
    };
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/core/InterceptorManager.js
var require_InterceptorManager = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/core/InterceptorManager.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    function InterceptorManager() {
      this.handlers = [];
    }
    InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
      this.handlers.push({
        fulfilled,
        rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
      });
      return this.handlers.length - 1;
    };
    InterceptorManager.prototype.eject = function eject(id) {
      if (this.handlers[id]) {
        this.handlers[id] = null;
      }
    };
    InterceptorManager.prototype.forEach = function forEach(fn) {
      utils.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) {
          fn(h);
        }
      });
    };
    module2.exports = InterceptorManager;
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/normalizeHeaderName.js
var require_normalizeHeaderName = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/normalizeHeaderName.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    module2.exports = function normalizeHeaderName(headers, normalizedName) {
      utils.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
          headers[normalizedName] = value;
          delete headers[name];
        }
      });
    };
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/core/AxiosError.js
var require_AxiosError = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/core/AxiosError.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    function AxiosError2(message, code, config, request, response) {
      Error.call(this);
      this.message = message;
      this.name = "AxiosError";
      code && (this.code = code);
      config && (this.config = config);
      request && (this.request = request);
      response && (this.response = response);
    }
    utils.inherits(AxiosError2, Error, {
      toJSON: function toJSON() {
        return {
          // Standard
          message: this.message,
          name: this.name,
          // Microsoft
          description: this.description,
          number: this.number,
          // Mozilla
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          // Axios
          config: this.config,
          code: this.code,
          status: this.response && this.response.status ? this.response.status : null
        };
      }
    });
    var prototype = AxiosError2.prototype;
    var descriptors = {};
    [
      "ERR_BAD_OPTION_VALUE",
      "ERR_BAD_OPTION",
      "ECONNABORTED",
      "ETIMEDOUT",
      "ERR_NETWORK",
      "ERR_FR_TOO_MANY_REDIRECTS",
      "ERR_DEPRECATED",
      "ERR_BAD_RESPONSE",
      "ERR_BAD_REQUEST",
      "ERR_CANCELED"
      // eslint-disable-next-line func-names
    ].forEach(function(code) {
      descriptors[code] = { value: code };
    });
    Object.defineProperties(AxiosError2, descriptors);
    Object.defineProperty(prototype, "isAxiosError", { value: true });
    AxiosError2.from = function(error, code, config, request, response, customProps) {
      var axiosError = Object.create(prototype);
      utils.toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
      });
      AxiosError2.call(axiosError, error.message, code, config, request, response);
      axiosError.name = error.name;
      customProps && Object.assign(axiosError, customProps);
      return axiosError;
    };
    module2.exports = AxiosError2;
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/defaults/transitional.js
var require_transitional = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/defaults/transitional.js"(exports, module2) {
    "use strict";
    module2.exports = {
      silentJSONParsing: true,
      forcedJSONParsing: true,
      clarifyTimeoutError: false
    };
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/toFormData.js
var require_toFormData = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/toFormData.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    function toFormData(obj, formData) {
      formData = formData || new FormData();
      var stack = [];
      function convertValue(value) {
        if (value === null)
          return "";
        if (utils.isDate(value)) {
          return value.toISOString();
        }
        if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
          return typeof Blob === "function" ? new Blob([value]) : Buffer.from(value);
        }
        return value;
      }
      function build(data, parentKey) {
        if (utils.isPlainObject(data) || utils.isArray(data)) {
          if (stack.indexOf(data) !== -1) {
            throw Error("Circular reference detected in " + parentKey);
          }
          stack.push(data);
          utils.forEach(data, function each(value, key) {
            if (utils.isUndefined(value))
              return;
            var fullKey = parentKey ? parentKey + "." + key : key;
            var arr;
            if (value && !parentKey && typeof value === "object") {
              if (utils.endsWith(key, "{}")) {
                value = JSON.stringify(value);
              } else if (utils.endsWith(key, "[]") && (arr = utils.toArray(value))) {
                arr.forEach(function(el) {
                  !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
                });
                return;
              }
            }
            build(value, fullKey);
          });
          stack.pop();
        } else {
          formData.append(parentKey, convertValue(data));
        }
      }
      build(obj);
      return formData;
    }
    module2.exports = toFormData;
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/core/settle.js
var require_settle = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/core/settle.js"(exports, module2) {
    "use strict";
    var AxiosError2 = require_AxiosError();
    module2.exports = function settle(resolve, reject, response) {
      var validateStatus = response.config.validateStatus;
      if (!response.status || !validateStatus || validateStatus(response.status)) {
        resolve(response);
      } else {
        reject(new AxiosError2(
          "Request failed with status code " + response.status,
          [AxiosError2.ERR_BAD_REQUEST, AxiosError2.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
          response.config,
          response.request,
          response
        ));
      }
    };
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/cookies.js
var require_cookies = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/cookies.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    module2.exports = utils.isStandardBrowserEnv() ? function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + "=" + encodeURIComponent(value));
          if (utils.isNumber(expires)) {
            cookie.push("expires=" + new Date(expires).toGMTString());
          }
          if (utils.isString(path)) {
            cookie.push("path=" + path);
          }
          if (utils.isString(domain)) {
            cookie.push("domain=" + domain);
          }
          if (secure === true) {
            cookie.push("secure");
          }
          document.cookie = cookie.join("; ");
        },
        read: function read(name) {
          var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
          return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
          this.write(name, "", Date.now() - 864e5);
        }
      };
    }() : function nonStandardBrowserEnv() {
      return {
        write: function write() {
        },
        read: function read() {
          return null;
        },
        remove: function remove() {
        }
      };
    }();
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/isAbsoluteURL.js
var require_isAbsoluteURL = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/isAbsoluteURL.js"(exports, module2) {
    "use strict";
    module2.exports = function isAbsoluteURL(url) {
      return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
    };
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/combineURLs.js
var require_combineURLs = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/combineURLs.js"(exports, module2) {
    "use strict";
    module2.exports = function combineURLs(baseURL, relativeURL) {
      return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
    };
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/core/buildFullPath.js
var require_buildFullPath = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/core/buildFullPath.js"(exports, module2) {
    "use strict";
    var isAbsoluteURL = require_isAbsoluteURL();
    var combineURLs = require_combineURLs();
    module2.exports = function buildFullPath(baseURL, requestedURL) {
      if (baseURL && !isAbsoluteURL(requestedURL)) {
        return combineURLs(baseURL, requestedURL);
      }
      return requestedURL;
    };
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/parseHeaders.js
var require_parseHeaders = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/parseHeaders.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    var ignoreDuplicateOf = [
      "age",
      "authorization",
      "content-length",
      "content-type",
      "etag",
      "expires",
      "from",
      "host",
      "if-modified-since",
      "if-unmodified-since",
      "last-modified",
      "location",
      "max-forwards",
      "proxy-authorization",
      "referer",
      "retry-after",
      "user-agent"
    ];
    module2.exports = function parseHeaders(headers) {
      var parsed = {};
      var key;
      var val;
      var i;
      if (!headers) {
        return parsed;
      }
      utils.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = utils.trim(line.substr(0, i)).toLowerCase();
        val = utils.trim(line.substr(i + 1));
        if (key) {
          if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
            return;
          }
          if (key === "set-cookie") {
            parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
          } else {
            parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
          }
        }
      });
      return parsed;
    };
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/isURLSameOrigin.js
var require_isURLSameOrigin = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/isURLSameOrigin.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    module2.exports = utils.isStandardBrowserEnv() ? function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement("a");
      var originURL;
      function resolveURL(url) {
        var href = url;
        if (msie) {
          urlParsingNode.setAttribute("href", href);
          href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
      }
      originURL = resolveURL(window.location.href);
      return function isURLSameOrigin(requestURL) {
        var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
      };
    }() : function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    }();
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/cancel/CanceledError.js
var require_CanceledError = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/cancel/CanceledError.js"(exports, module2) {
    "use strict";
    var AxiosError2 = require_AxiosError();
    var utils = require_utils();
    function CanceledError(message) {
      AxiosError2.call(this, message == null ? "canceled" : message, AxiosError2.ERR_CANCELED);
      this.name = "CanceledError";
    }
    utils.inherits(CanceledError, AxiosError2, {
      __CANCEL__: true
    });
    module2.exports = CanceledError;
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/parseProtocol.js
var require_parseProtocol = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/parseProtocol.js"(exports, module2) {
    "use strict";
    module2.exports = function parseProtocol(url) {
      var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
      return match && match[1] || "";
    };
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/adapters/xhr.js
var require_xhr = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/adapters/xhr.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    var settle = require_settle();
    var cookies = require_cookies();
    var buildURL = require_buildURL();
    var buildFullPath = require_buildFullPath();
    var parseHeaders = require_parseHeaders();
    var isURLSameOrigin = require_isURLSameOrigin();
    var transitionalDefaults = require_transitional();
    var AxiosError2 = require_AxiosError();
    var CanceledError = require_CanceledError();
    var parseProtocol = require_parseProtocol();
    module2.exports = function xhrAdapter(config) {
      return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
          if (config.cancelToken) {
            config.cancelToken.unsubscribe(onCanceled);
          }
          if (config.signal) {
            config.signal.removeEventListener("abort", onCanceled);
          }
        }
        if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
          delete requestHeaders["Content-Type"];
        }
        var request = new XMLHttpRequest();
        if (config.auth) {
          var username = config.auth.username || "";
          var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
          requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = buildFullPath(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
        request.timeout = config.timeout;
        function onloadend() {
          if (!request) {
            return;
          }
          var responseHeaders = "getAllResponseHeaders" in request ? parseHeaders(request.getAllResponseHeaders()) : null;
          var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
          var response = {
            data: responseData,
            status: request.status,
            statusText: request.statusText,
            headers: responseHeaders,
            config,
            request
          };
          settle(function _resolve(value) {
            resolve(value);
            done();
          }, function _reject(err) {
            reject(err);
            done();
          }, response);
          request = null;
        }
        if ("onloadend" in request) {
          request.onloadend = onloadend;
        } else {
          request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) {
              return;
            }
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) {
              return;
            }
            setTimeout(onloadend);
          };
        }
        request.onabort = function handleAbort() {
          if (!request) {
            return;
          }
          reject(new AxiosError2("Request aborted", AxiosError2.ECONNABORTED, config, request));
          request = null;
        };
        request.onerror = function handleError() {
          reject(new AxiosError2("Network Error", AxiosError2.ERR_NETWORK, config, request, request));
          request = null;
        };
        request.ontimeout = function handleTimeout() {
          var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
          var transitional = config.transitional || transitionalDefaults;
          if (config.timeoutErrorMessage) {
            timeoutErrorMessage = config.timeoutErrorMessage;
          }
          reject(new AxiosError2(
            timeoutErrorMessage,
            transitional.clarifyTimeoutError ? AxiosError2.ETIMEDOUT : AxiosError2.ECONNABORTED,
            config,
            request
          ));
          request = null;
        };
        if (utils.isStandardBrowserEnv()) {
          var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : void 0;
          if (xsrfValue) {
            requestHeaders[config.xsrfHeaderName] = xsrfValue;
          }
        }
        if ("setRequestHeader" in request) {
          utils.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
              delete requestHeaders[key];
            } else {
              request.setRequestHeader(key, val);
            }
          });
        }
        if (!utils.isUndefined(config.withCredentials)) {
          request.withCredentials = !!config.withCredentials;
        }
        if (responseType && responseType !== "json") {
          request.responseType = config.responseType;
        }
        if (typeof config.onDownloadProgress === "function") {
          request.addEventListener("progress", config.onDownloadProgress);
        }
        if (typeof config.onUploadProgress === "function" && request.upload) {
          request.upload.addEventListener("progress", config.onUploadProgress);
        }
        if (config.cancelToken || config.signal) {
          onCanceled = function(cancel) {
            if (!request) {
              return;
            }
            reject(!cancel || cancel && cancel.type ? new CanceledError() : cancel);
            request.abort();
            request = null;
          };
          config.cancelToken && config.cancelToken.subscribe(onCanceled);
          if (config.signal) {
            config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
          }
        }
        if (!requestData) {
          requestData = null;
        }
        var protocol = parseProtocol(fullPath);
        if (protocol && ["http", "https", "file"].indexOf(protocol) === -1) {
          reject(new AxiosError2("Unsupported protocol " + protocol + ":", AxiosError2.ERR_BAD_REQUEST, config));
          return;
        }
        request.send(requestData);
      });
    };
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/null.js
var require_null = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/null.js"(exports, module2) {
    module2.exports = null;
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/defaults/index.js
var require_defaults = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/defaults/index.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    var normalizeHeaderName = require_normalizeHeaderName();
    var AxiosError2 = require_AxiosError();
    var transitionalDefaults = require_transitional();
    var toFormData = require_toFormData();
    var DEFAULT_CONTENT_TYPE = {
      "Content-Type": "application/x-www-form-urlencoded"
    };
    function setContentTypeIfUnset(headers, value) {
      if (!utils.isUndefined(headers) && utils.isUndefined(headers["Content-Type"])) {
        headers["Content-Type"] = value;
      }
    }
    function getDefaultAdapter() {
      var adapter;
      if (typeof XMLHttpRequest !== "undefined") {
        adapter = require_xhr();
      } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
        adapter = require_xhr();
      }
      return adapter;
    }
    function stringifySafely(rawValue, parser, encoder) {
      if (utils.isString(rawValue)) {
        try {
          (parser || JSON.parse)(rawValue);
          return utils.trim(rawValue);
        } catch (e) {
          if (e.name !== "SyntaxError") {
            throw e;
          }
        }
      }
      return (encoder || JSON.stringify)(rawValue);
    }
    var defaults = {
      transitional: transitionalDefaults,
      adapter: getDefaultAdapter(),
      transformRequest: [function transformRequest(data, headers) {
        normalizeHeaderName(headers, "Accept");
        normalizeHeaderName(headers, "Content-Type");
        if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
          return data;
        }
        if (utils.isArrayBufferView(data)) {
          return data.buffer;
        }
        if (utils.isURLSearchParams(data)) {
          setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
          return data.toString();
        }
        var isObjectPayload = utils.isObject(data);
        var contentType = headers && headers["Content-Type"];
        var isFileList;
        if ((isFileList = utils.isFileList(data)) || isObjectPayload && contentType === "multipart/form-data") {
          var _FormData = this.env && this.env.FormData;
          return toFormData(isFileList ? { "files[]": data } : data, _FormData && new _FormData());
        } else if (isObjectPayload || contentType === "application/json") {
          setContentTypeIfUnset(headers, "application/json");
          return stringifySafely(data);
        }
        return data;
      }],
      transformResponse: [function transformResponse(data) {
        var transitional = this.transitional || defaults.transitional;
        var silentJSONParsing = transitional && transitional.silentJSONParsing;
        var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
        var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
        if (strictJSONParsing || forcedJSONParsing && utils.isString(data) && data.length) {
          try {
            return JSON.parse(data);
          } catch (e) {
            if (strictJSONParsing) {
              if (e.name === "SyntaxError") {
                throw AxiosError2.from(e, AxiosError2.ERR_BAD_RESPONSE, this, null, this.response);
              }
              throw e;
            }
          }
        }
        return data;
      }],
      /**
       * A timeout in milliseconds to abort a request. If set to 0 (default) a
       * timeout is not created.
       */
      timeout: 0,
      xsrfCookieName: "XSRF-TOKEN",
      xsrfHeaderName: "X-XSRF-TOKEN",
      maxContentLength: -1,
      maxBodyLength: -1,
      env: {
        FormData: require_null()
      },
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
      },
      headers: {
        common: {
          "Accept": "application/json, text/plain, */*"
        }
      }
    };
    utils.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
      defaults.headers[method] = {};
    });
    utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
      defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
    });
    module2.exports = defaults;
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/core/transformData.js
var require_transformData = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/core/transformData.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    var defaults = require_defaults();
    module2.exports = function transformData(data, headers, fns) {
      var context = this || defaults;
      utils.forEach(fns, function transform2(fn) {
        data = fn.call(context, data, headers);
      });
      return data;
    };
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/cancel/isCancel.js
var require_isCancel = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/cancel/isCancel.js"(exports, module2) {
    "use strict";
    module2.exports = function isCancel(value) {
      return !!(value && value.__CANCEL__);
    };
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/core/dispatchRequest.js
var require_dispatchRequest = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/core/dispatchRequest.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    var transformData = require_transformData();
    var isCancel = require_isCancel();
    var defaults = require_defaults();
    var CanceledError = require_CanceledError();
    function throwIfCancellationRequested(config) {
      if (config.cancelToken) {
        config.cancelToken.throwIfRequested();
      }
      if (config.signal && config.signal.aborted) {
        throw new CanceledError();
      }
    }
    module2.exports = function dispatchRequest(config) {
      throwIfCancellationRequested(config);
      config.headers = config.headers || {};
      config.data = transformData.call(
        config,
        config.data,
        config.headers,
        config.transformRequest
      );
      config.headers = utils.merge(
        config.headers.common || {},
        config.headers[config.method] || {},
        config.headers
      );
      utils.forEach(
        ["delete", "get", "head", "post", "put", "patch", "common"],
        function cleanHeaderConfig(method) {
          delete config.headers[method];
        }
      );
      var adapter = config.adapter || defaults.adapter;
      return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        response.data = transformData.call(
          config,
          response.data,
          response.headers,
          config.transformResponse
        );
        return response;
      }, function onAdapterRejection(reason) {
        if (!isCancel(reason)) {
          throwIfCancellationRequested(config);
          if (reason && reason.response) {
            reason.response.data = transformData.call(
              config,
              reason.response.data,
              reason.response.headers,
              config.transformResponse
            );
          }
        }
        return Promise.reject(reason);
      });
    };
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/core/mergeConfig.js
var require_mergeConfig = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/core/mergeConfig.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    module2.exports = function mergeConfig(config1, config2) {
      config2 = config2 || {};
      var config = {};
      function getMergedValue(target, source) {
        if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
          return utils.merge(target, source);
        } else if (utils.isPlainObject(source)) {
          return utils.merge({}, source);
        } else if (utils.isArray(source)) {
          return source.slice();
        }
        return source;
      }
      function mergeDeepProperties(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(config1[prop], config2[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      function valueFromConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(void 0, config2[prop]);
        }
      }
      function defaultToConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(void 0, config2[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      function mergeDirectKeys(prop) {
        if (prop in config2) {
          return getMergedValue(config1[prop], config2[prop]);
        } else if (prop in config1) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "beforeRedirect": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
      };
      utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        utils.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
      });
      return config;
    };
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/env/data.js
var require_data = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/env/data.js"(exports, module2) {
    module2.exports = {
      "version": "0.27.2"
    };
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/validator.js
var require_validator = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/validator.js"(exports, module2) {
    "use strict";
    var VERSION = require_data().version;
    var AxiosError2 = require_AxiosError();
    var validators = {};
    ["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i) {
      validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
      };
    });
    var deprecatedWarnings = {};
    validators.transitional = function transitional(validator, version, message) {
      function formatMessage(opt, desc) {
        return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
      }
      return function(value, opt, opts) {
        if (validator === false) {
          throw new AxiosError2(
            formatMessage(opt, " has been removed" + (version ? " in " + version : "")),
            AxiosError2.ERR_DEPRECATED
          );
        }
        if (version && !deprecatedWarnings[opt]) {
          deprecatedWarnings[opt] = true;
          console.warn(
            formatMessage(
              opt,
              " has been deprecated since v" + version + " and will be removed in the near future"
            )
          );
        }
        return validator ? validator(value, opt, opts) : true;
      };
    };
    function assertOptions(options, schema, allowUnknown) {
      if (typeof options !== "object") {
        throw new AxiosError2("options must be an object", AxiosError2.ERR_BAD_OPTION_VALUE);
      }
      var keys2 = Object.keys(options);
      var i = keys2.length;
      while (i-- > 0) {
        var opt = keys2[i];
        var validator = schema[opt];
        if (validator) {
          var value = options[opt];
          var result = value === void 0 || validator(value, opt, options);
          if (result !== true) {
            throw new AxiosError2("option " + opt + " must be " + result, AxiosError2.ERR_BAD_OPTION_VALUE);
          }
          continue;
        }
        if (allowUnknown !== true) {
          throw new AxiosError2("Unknown option " + opt, AxiosError2.ERR_BAD_OPTION);
        }
      }
    }
    module2.exports = {
      assertOptions,
      validators
    };
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/core/Axios.js
var require_Axios = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/core/Axios.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    var buildURL = require_buildURL();
    var InterceptorManager = require_InterceptorManager();
    var dispatchRequest = require_dispatchRequest();
    var mergeConfig = require_mergeConfig();
    var buildFullPath = require_buildFullPath();
    var validator = require_validator();
    var validators = validator.validators;
    function Axios(instanceConfig) {
      this.defaults = instanceConfig;
      this.interceptors = {
        request: new InterceptorManager(),
        response: new InterceptorManager()
      };
    }
    Axios.prototype.request = function request(configOrUrl, config) {
      if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
      } else {
        config = configOrUrl || {};
      }
      config = mergeConfig(this.defaults, config);
      if (config.method) {
        config.method = config.method.toLowerCase();
      } else if (this.defaults.method) {
        config.method = this.defaults.method.toLowerCase();
      } else {
        config.method = "get";
      }
      var transitional = config.transitional;
      if (transitional !== void 0) {
        validator.assertOptions(transitional, {
          silentJSONParsing: validators.transitional(validators.boolean),
          forcedJSONParsing: validators.transitional(validators.boolean),
          clarifyTimeoutError: validators.transitional(validators.boolean)
        }, false);
      }
      var requestInterceptorChain = [];
      var synchronousRequestInterceptors = true;
      this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
          return;
        }
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
      });
      var responseInterceptorChain = [];
      this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
      });
      var promise;
      if (!synchronousRequestInterceptors) {
        var chain = [dispatchRequest, void 0];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while (chain.length) {
          promise = promise.then(chain.shift(), chain.shift());
        }
        return promise;
      }
      var newConfig = config;
      while (requestInterceptorChain.length) {
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
          newConfig = onFulfilled(newConfig);
        } catch (error) {
          onRejected(error);
          break;
        }
      }
      try {
        promise = dispatchRequest(newConfig);
      } catch (error) {
        return Promise.reject(error);
      }
      while (responseInterceptorChain.length) {
        promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
      }
      return promise;
    };
    Axios.prototype.getUri = function getUri(config) {
      config = mergeConfig(this.defaults, config);
      var fullPath = buildFullPath(config.baseURL, config.url);
      return buildURL(fullPath, config.params, config.paramsSerializer);
    };
    utils.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
      Axios.prototype[method] = function(url, config) {
        return this.request(mergeConfig(config || {}, {
          method,
          url,
          data: (config || {}).data
        }));
      };
    });
    utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
      function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
          return this.request(mergeConfig(config || {}, {
            method,
            headers: isForm ? {
              "Content-Type": "multipart/form-data"
            } : {},
            url,
            data
          }));
        };
      }
      Axios.prototype[method] = generateHTTPMethod();
      Axios.prototype[method + "Form"] = generateHTTPMethod(true);
    });
    module2.exports = Axios;
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/cancel/CancelToken.js
var require_CancelToken = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/cancel/CancelToken.js"(exports, module2) {
    "use strict";
    var CanceledError = require_CanceledError();
    function CancelToken(executor) {
      if (typeof executor !== "function") {
        throw new TypeError("executor must be a function.");
      }
      var resolvePromise;
      this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
      });
      var token = this;
      this.promise.then(function(cancel) {
        if (!token._listeners)
          return;
        var i;
        var l = token._listeners.length;
        for (i = 0; i < l; i++) {
          token._listeners[i](cancel);
        }
        token._listeners = null;
      });
      this.promise.then = function(onfulfilled) {
        var _resolve;
        var promise = new Promise(function(resolve) {
          token.subscribe(resolve);
          _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
          token.unsubscribe(_resolve);
        };
        return promise;
      };
      executor(function cancel(message) {
        if (token.reason) {
          return;
        }
        token.reason = new CanceledError(message);
        resolvePromise(token.reason);
      });
    }
    CancelToken.prototype.throwIfRequested = function throwIfRequested() {
      if (this.reason) {
        throw this.reason;
      }
    };
    CancelToken.prototype.subscribe = function subscribe(listener) {
      if (this.reason) {
        listener(this.reason);
        return;
      }
      if (this._listeners) {
        this._listeners.push(listener);
      } else {
        this._listeners = [listener];
      }
    };
    CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
      if (!this._listeners) {
        return;
      }
      var index = this._listeners.indexOf(listener);
      if (index !== -1) {
        this._listeners.splice(index, 1);
      }
    };
    CancelToken.source = function source() {
      var cancel;
      var token = new CancelToken(function executor(c) {
        cancel = c;
      });
      return {
        token,
        cancel
      };
    };
    module2.exports = CancelToken;
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/spread.js
var require_spread = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/spread.js"(exports, module2) {
    "use strict";
    module2.exports = function spread(callback) {
      return function wrap(arr) {
        return callback.apply(null, arr);
      };
    };
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/isAxiosError.js
var require_isAxiosError = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/helpers/isAxiosError.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    module2.exports = function isAxiosError(payload) {
      return utils.isObject(payload) && payload.isAxiosError === true;
    };
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/axios.js
var require_axios = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/lib/axios.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    var bind = require_bind();
    var Axios = require_Axios();
    var mergeConfig = require_mergeConfig();
    var defaults = require_defaults();
    function createInstance(defaultConfig) {
      var context = new Axios(defaultConfig);
      var instance = bind(Axios.prototype.request, context);
      utils.extend(instance, Axios.prototype, context);
      utils.extend(instance, context);
      instance.create = function create(instanceConfig) {
        return createInstance(mergeConfig(defaultConfig, instanceConfig));
      };
      return instance;
    }
    var axios2 = createInstance(defaults);
    axios2.Axios = Axios;
    axios2.CanceledError = require_CanceledError();
    axios2.CancelToken = require_CancelToken();
    axios2.isCancel = require_isCancel();
    axios2.VERSION = require_data().version;
    axios2.toFormData = require_toFormData();
    axios2.AxiosError = require_AxiosError();
    axios2.Cancel = axios2.CanceledError;
    axios2.all = function all(promises) {
      return Promise.all(promises);
    };
    axios2.spread = require_spread();
    axios2.isAxiosError = require_isAxiosError();
    module2.exports = axios2;
    module2.exports.default = axios2;
  }
});

// .yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/index.js
var require_axios2 = __commonJS({
  ".yarn/cache/axios-npm-0.27.2-dbe3a48aea-38cb754046.zip/node_modules/axios/index.js"(exports, module2) {
    module2.exports = require_axios();
  }
});

// src/core/fetcher/Fetcher.ts
var import_axios, fetcher;
var init_Fetcher = __esm({
  "src/core/fetcher/Fetcher.ts"() {
    "use strict";
    import_axios = __toESM(require_axios2());
    fetcher = async (args) => {
      const headers = {
        "Content-Type": "application/json"
      };
      if (args.headers != null) {
        for (const [key, value] of Object.entries(args.headers)) {
          if (value != null) {
            headers[key] = value;
          }
        }
      }
      try {
        const response = await (0, import_axios.default)({
          url: args.url,
          params: args.queryParameters,
          method: args.method,
          headers,
          data: args.body,
          validateStatus: () => true,
          transformResponse: (response2) => response2,
          timeout: args.timeoutMs ?? 6e4,
          transitional: {
            clarifyTimeoutError: true
          },
          withCredentials: true
        });
        let body;
        if (response.data != null && response.data.length > 0) {
          try {
            body = JSON.parse(response.data) ?? void 0;
          } catch {
            return {
              ok: false,
              error: {
                reason: "non-json",
                statusCode: response.status,
                rawBody: response.data
              }
            };
          }
        }
        if (response.status >= 200 && response.status < 300) {
          return {
            ok: true,
            body
          };
        } else {
          return {
            ok: false,
            error: {
              reason: "status-code",
              statusCode: response.status,
              body
            }
          };
        }
      } catch (error) {
        if (error.code === "ETIMEDOUT") {
          return {
            ok: false,
            error: {
              reason: "timeout"
            }
          };
        }
        return {
          ok: false,
          error: {
            reason: "unknown",
            errorMessage: error.message
          }
        };
      }
    };
  }
});

// src/core/fetcher/Supplier.ts
var Supplier;
var init_Supplier = __esm({
  "src/core/fetcher/Supplier.ts"() {
    "use strict";
    Supplier = {
      get: async (supplier) => {
        if (typeof supplier === "function") {
          return supplier();
        } else {
          return supplier;
        }
      }
    };
  }
});

// src/core/fetcher/index.ts
var init_fetcher = __esm({
  "src/core/fetcher/index.ts"() {
    "use strict";
    init_Fetcher();
    init_Supplier();
  }
});

// .yarn/cache/base64-js-npm-1.5.1-b2f7275641-669632eb37.zip/node_modules/base64-js/index.js
var require_base64_js = __commonJS({
  ".yarn/cache/base64-js-npm-1.5.1-b2f7275641-669632eb37.zip/node_modules/base64-js/index.js"(exports) {
    "use strict";
    exports.byteLength = byteLength;
    exports.toByteArray = toByteArray;
    exports.fromByteArray = fromByteArray;
    var lookup = [];
    var revLookup = [];
    var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
    var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    for (i = 0, len = code.length; i < len; ++i) {
      lookup[i] = code[i];
      revLookup[code.charCodeAt(i)] = i;
    }
    var i;
    var len;
    revLookup["-".charCodeAt(0)] = 62;
    revLookup["_".charCodeAt(0)] = 63;
    function getLens(b64) {
      var len2 = b64.length;
      if (len2 % 4 > 0) {
        throw new Error("Invalid string. Length must be a multiple of 4");
      }
      var validLen = b64.indexOf("=");
      if (validLen === -1)
        validLen = len2;
      var placeHoldersLen = validLen === len2 ? 0 : 4 - validLen % 4;
      return [validLen, placeHoldersLen];
    }
    function byteLength(b64) {
      var lens = getLens(b64);
      var validLen = lens[0];
      var placeHoldersLen = lens[1];
      return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
    }
    function _byteLength(b64, validLen, placeHoldersLen) {
      return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
    }
    function toByteArray(b64) {
      var tmp;
      var lens = getLens(b64);
      var validLen = lens[0];
      var placeHoldersLen = lens[1];
      var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
      var curByte = 0;
      var len2 = placeHoldersLen > 0 ? validLen - 4 : validLen;
      var i2;
      for (i2 = 0; i2 < len2; i2 += 4) {
        tmp = revLookup[b64.charCodeAt(i2)] << 18 | revLookup[b64.charCodeAt(i2 + 1)] << 12 | revLookup[b64.charCodeAt(i2 + 2)] << 6 | revLookup[b64.charCodeAt(i2 + 3)];
        arr[curByte++] = tmp >> 16 & 255;
        arr[curByte++] = tmp >> 8 & 255;
        arr[curByte++] = tmp & 255;
      }
      if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i2)] << 2 | revLookup[b64.charCodeAt(i2 + 1)] >> 4;
        arr[curByte++] = tmp & 255;
      }
      if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i2)] << 10 | revLookup[b64.charCodeAt(i2 + 1)] << 4 | revLookup[b64.charCodeAt(i2 + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 255;
        arr[curByte++] = tmp & 255;
      }
      return arr;
    }
    function tripletToBase64(num) {
      return lookup[num >> 18 & 63] + lookup[num >> 12 & 63] + lookup[num >> 6 & 63] + lookup[num & 63];
    }
    function encodeChunk(uint8, start, end) {
      var tmp;
      var output = [];
      for (var i2 = start; i2 < end; i2 += 3) {
        tmp = (uint8[i2] << 16 & 16711680) + (uint8[i2 + 1] << 8 & 65280) + (uint8[i2 + 2] & 255);
        output.push(tripletToBase64(tmp));
      }
      return output.join("");
    }
    function fromByteArray(uint8) {
      var tmp;
      var len2 = uint8.length;
      var extraBytes = len2 % 3;
      var parts = [];
      var maxChunkLength = 16383;
      for (var i2 = 0, len22 = len2 - extraBytes; i2 < len22; i2 += maxChunkLength) {
        parts.push(encodeChunk(uint8, i2, i2 + maxChunkLength > len22 ? len22 : i2 + maxChunkLength));
      }
      if (extraBytes === 1) {
        tmp = uint8[len2 - 1];
        parts.push(
          lookup[tmp >> 2] + lookup[tmp << 4 & 63] + "=="
        );
      } else if (extraBytes === 2) {
        tmp = (uint8[len2 - 2] << 8) + uint8[len2 - 1];
        parts.push(
          lookup[tmp >> 10] + lookup[tmp >> 4 & 63] + lookup[tmp << 2 & 63] + "="
        );
      }
      return parts.join("");
    }
  }
});

// .yarn/cache/ieee754-npm-1.2.1-fb63b3caeb-5144c0c981.zip/node_modules/ieee754/index.js
var require_ieee754 = __commonJS({
  ".yarn/cache/ieee754-npm-1.2.1-fb63b3caeb-5144c0c981.zip/node_modules/ieee754/index.js"(exports) {
    exports.read = function(buffer, offset, isLE, mLen, nBytes) {
      var e, m;
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var nBits = -7;
      var i = isLE ? nBytes - 1 : 0;
      var d = isLE ? -1 : 1;
      var s = buffer[offset + i];
      i += d;
      e = s & (1 << -nBits) - 1;
      s >>= -nBits;
      nBits += eLen;
      for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {
      }
      m = e & (1 << -nBits) - 1;
      e >>= -nBits;
      nBits += mLen;
      for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {
      }
      if (e === 0) {
        e = 1 - eBias;
      } else if (e === eMax) {
        return m ? NaN : (s ? -1 : 1) * Infinity;
      } else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
      }
      return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
    };
    exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
      var e, m, c;
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
      var i = isLE ? 0 : nBytes - 1;
      var d = isLE ? 1 : -1;
      var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
      value = Math.abs(value);
      if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
      } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
          e--;
          c *= 2;
        }
        if (e + eBias >= 1) {
          value += rt / c;
        } else {
          value += rt * Math.pow(2, 1 - eBias);
        }
        if (value * c >= 2) {
          e++;
          c /= 2;
        }
        if (e + eBias >= eMax) {
          m = 0;
          e = eMax;
        } else if (e + eBias >= 1) {
          m = (value * c - 1) * Math.pow(2, mLen);
          e = e + eBias;
        } else {
          m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
          e = 0;
        }
      }
      for (; mLen >= 8; buffer[offset + i] = m & 255, i += d, m /= 256, mLen -= 8) {
      }
      e = e << mLen | m;
      eLen += mLen;
      for (; eLen > 0; buffer[offset + i] = e & 255, i += d, e /= 256, eLen -= 8) {
      }
      buffer[offset + i - d] |= s * 128;
    };
  }
});

// .yarn/cache/buffer-npm-6.0.3-cd90dfedfe-5ad23293d9.zip/node_modules/buffer/index.js
var require_buffer = __commonJS({
  ".yarn/cache/buffer-npm-6.0.3-cd90dfedfe-5ad23293d9.zip/node_modules/buffer/index.js"(exports) {
    "use strict";
    var base64 = require_base64_js();
    var ieee754 = require_ieee754();
    var customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" ? Symbol["for"]("nodejs.util.inspect.custom") : null;
    exports.Buffer = Buffer2;
    exports.SlowBuffer = SlowBuffer;
    exports.INSPECT_MAX_BYTES = 50;
    var K_MAX_LENGTH = 2147483647;
    exports.kMaxLength = K_MAX_LENGTH;
    Buffer2.TYPED_ARRAY_SUPPORT = typedArraySupport();
    if (!Buffer2.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") {
      console.error(
        "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
      );
    }
    function typedArraySupport() {
      try {
        const arr = new Uint8Array(1);
        const proto = { foo: function() {
          return 42;
        } };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
      } catch (e) {
        return false;
      }
    }
    Object.defineProperty(Buffer2.prototype, "parent", {
      enumerable: true,
      get: function() {
        if (!Buffer2.isBuffer(this))
          return void 0;
        return this.buffer;
      }
    });
    Object.defineProperty(Buffer2.prototype, "offset", {
      enumerable: true,
      get: function() {
        if (!Buffer2.isBuffer(this))
          return void 0;
        return this.byteOffset;
      }
    });
    function createBuffer(length) {
      if (length > K_MAX_LENGTH) {
        throw new RangeError('The value "' + length + '" is invalid for option "size"');
      }
      const buf = new Uint8Array(length);
      Object.setPrototypeOf(buf, Buffer2.prototype);
      return buf;
    }
    function Buffer2(arg, encodingOrOffset, length) {
      if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") {
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        }
        return allocUnsafe(arg);
      }
      return from(arg, encodingOrOffset, length);
    }
    Buffer2.poolSize = 8192;
    function from(value, encodingOrOffset, length) {
      if (typeof value === "string") {
        return fromString(value, encodingOrOffset);
      }
      if (ArrayBuffer.isView(value)) {
        return fromArrayView(value);
      }
      if (value == null) {
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value
        );
      }
      if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
        return fromArrayBuffer(value, encodingOrOffset, length);
      }
      if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) {
        return fromArrayBuffer(value, encodingOrOffset, length);
      }
      if (typeof value === "number") {
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      }
      const valueOf = value.valueOf && value.valueOf();
      if (valueOf != null && valueOf !== value) {
        return Buffer2.from(valueOf, encodingOrOffset, length);
      }
      const b = fromObject(value);
      if (b)
        return b;
      if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") {
        return Buffer2.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
      }
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value
      );
    }
    Buffer2.from = function(value, encodingOrOffset, length) {
      return from(value, encodingOrOffset, length);
    };
    Object.setPrototypeOf(Buffer2.prototype, Uint8Array.prototype);
    Object.setPrototypeOf(Buffer2, Uint8Array);
    function assertSize(size) {
      if (typeof size !== "number") {
        throw new TypeError('"size" argument must be of type number');
      } else if (size < 0) {
        throw new RangeError('The value "' + size + '" is invalid for option "size"');
      }
    }
    function alloc(size, fill, encoding) {
      assertSize(size);
      if (size <= 0) {
        return createBuffer(size);
      }
      if (fill !== void 0) {
        return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
      }
      return createBuffer(size);
    }
    Buffer2.alloc = function(size, fill, encoding) {
      return alloc(size, fill, encoding);
    };
    function allocUnsafe(size) {
      assertSize(size);
      return createBuffer(size < 0 ? 0 : checked(size) | 0);
    }
    Buffer2.allocUnsafe = function(size) {
      return allocUnsafe(size);
    };
    Buffer2.allocUnsafeSlow = function(size) {
      return allocUnsafe(size);
    };
    function fromString(string2, encoding) {
      if (typeof encoding !== "string" || encoding === "") {
        encoding = "utf8";
      }
      if (!Buffer2.isEncoding(encoding)) {
        throw new TypeError("Unknown encoding: " + encoding);
      }
      const length = byteLength(string2, encoding) | 0;
      let buf = createBuffer(length);
      const actual = buf.write(string2, encoding);
      if (actual !== length) {
        buf = buf.slice(0, actual);
      }
      return buf;
    }
    function fromArrayLike(array) {
      const length = array.length < 0 ? 0 : checked(array.length) | 0;
      const buf = createBuffer(length);
      for (let i = 0; i < length; i += 1) {
        buf[i] = array[i] & 255;
      }
      return buf;
    }
    function fromArrayView(arrayView) {
      if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
      }
      return fromArrayLike(arrayView);
    }
    function fromArrayBuffer(array, byteOffset, length) {
      if (byteOffset < 0 || array.byteLength < byteOffset) {
        throw new RangeError('"offset" is outside of buffer bounds');
      }
      if (array.byteLength < byteOffset + (length || 0)) {
        throw new RangeError('"length" is outside of buffer bounds');
      }
      let buf;
      if (byteOffset === void 0 && length === void 0) {
        buf = new Uint8Array(array);
      } else if (length === void 0) {
        buf = new Uint8Array(array, byteOffset);
      } else {
        buf = new Uint8Array(array, byteOffset, length);
      }
      Object.setPrototypeOf(buf, Buffer2.prototype);
      return buf;
    }
    function fromObject(obj) {
      if (Buffer2.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) {
          return buf;
        }
        obj.copy(buf, 0, 0, len);
        return buf;
      }
      if (obj.length !== void 0) {
        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) {
          return createBuffer(0);
        }
        return fromArrayLike(obj);
      }
      if (obj.type === "Buffer" && Array.isArray(obj.data)) {
        return fromArrayLike(obj.data);
      }
    }
    function checked(length) {
      if (length >= K_MAX_LENGTH) {
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
      }
      return length | 0;
    }
    function SlowBuffer(length) {
      if (+length != length) {
        length = 0;
      }
      return Buffer2.alloc(+length);
    }
    Buffer2.isBuffer = function isBuffer(b) {
      return b != null && b._isBuffer === true && b !== Buffer2.prototype;
    };
    Buffer2.compare = function compare(a, b) {
      if (isInstance(a, Uint8Array))
        a = Buffer2.from(a, a.offset, a.byteLength);
      if (isInstance(b, Uint8Array))
        b = Buffer2.from(b, b.offset, b.byteLength);
      if (!Buffer2.isBuffer(a) || !Buffer2.isBuffer(b)) {
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      }
      if (a === b)
        return 0;
      let x = a.length;
      let y = b.length;
      for (let i = 0, len = Math.min(x, y); i < len; ++i) {
        if (a[i] !== b[i]) {
          x = a[i];
          y = b[i];
          break;
        }
      }
      if (x < y)
        return -1;
      if (y < x)
        return 1;
      return 0;
    };
    Buffer2.isEncoding = function isEncoding(encoding) {
      switch (String(encoding).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return true;
        default:
          return false;
      }
    };
    Buffer2.concat = function concat(list2, length) {
      if (!Array.isArray(list2)) {
        throw new TypeError('"list" argument must be an Array of Buffers');
      }
      if (list2.length === 0) {
        return Buffer2.alloc(0);
      }
      let i;
      if (length === void 0) {
        length = 0;
        for (i = 0; i < list2.length; ++i) {
          length += list2[i].length;
        }
      }
      const buffer = Buffer2.allocUnsafe(length);
      let pos = 0;
      for (i = 0; i < list2.length; ++i) {
        let buf = list2[i];
        if (isInstance(buf, Uint8Array)) {
          if (pos + buf.length > buffer.length) {
            if (!Buffer2.isBuffer(buf))
              buf = Buffer2.from(buf);
            buf.copy(buffer, pos);
          } else {
            Uint8Array.prototype.set.call(
              buffer,
              buf,
              pos
            );
          }
        } else if (!Buffer2.isBuffer(buf)) {
          throw new TypeError('"list" argument must be an Array of Buffers');
        } else {
          buf.copy(buffer, pos);
        }
        pos += buf.length;
      }
      return buffer;
    };
    function byteLength(string2, encoding) {
      if (Buffer2.isBuffer(string2)) {
        return string2.length;
      }
      if (ArrayBuffer.isView(string2) || isInstance(string2, ArrayBuffer)) {
        return string2.byteLength;
      }
      if (typeof string2 !== "string") {
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string2
        );
      }
      const len = string2.length;
      const mustMatch = arguments.length > 2 && arguments[2] === true;
      if (!mustMatch && len === 0)
        return 0;
      let loweredCase = false;
      for (; ; ) {
        switch (encoding) {
          case "ascii":
          case "latin1":
          case "binary":
            return len;
          case "utf8":
          case "utf-8":
            return utf8ToBytes(string2).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return len * 2;
          case "hex":
            return len >>> 1;
          case "base64":
            return base64ToBytes(string2).length;
          default:
            if (loweredCase) {
              return mustMatch ? -1 : utf8ToBytes(string2).length;
            }
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
        }
      }
    }
    Buffer2.byteLength = byteLength;
    function slowToString(encoding, start, end) {
      let loweredCase = false;
      if (start === void 0 || start < 0) {
        start = 0;
      }
      if (start > this.length) {
        return "";
      }
      if (end === void 0 || end > this.length) {
        end = this.length;
      }
      if (end <= 0) {
        return "";
      }
      end >>>= 0;
      start >>>= 0;
      if (end <= start) {
        return "";
      }
      if (!encoding)
        encoding = "utf8";
      while (true) {
        switch (encoding) {
          case "hex":
            return hexSlice(this, start, end);
          case "utf8":
          case "utf-8":
            return utf8Slice(this, start, end);
          case "ascii":
            return asciiSlice(this, start, end);
          case "latin1":
          case "binary":
            return latin1Slice(this, start, end);
          case "base64":
            return base64Slice(this, start, end);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return utf16leSlice(this, start, end);
          default:
            if (loweredCase)
              throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
        }
      }
    }
    Buffer2.prototype._isBuffer = true;
    function swap(b, n, m) {
      const i = b[n];
      b[n] = b[m];
      b[m] = i;
    }
    Buffer2.prototype.swap16 = function swap16() {
      const len = this.length;
      if (len % 2 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      }
      for (let i = 0; i < len; i += 2) {
        swap(this, i, i + 1);
      }
      return this;
    };
    Buffer2.prototype.swap32 = function swap32() {
      const len = this.length;
      if (len % 4 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      }
      for (let i = 0; i < len; i += 4) {
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
      }
      return this;
    };
    Buffer2.prototype.swap64 = function swap64() {
      const len = this.length;
      if (len % 8 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      }
      for (let i = 0; i < len; i += 8) {
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
      }
      return this;
    };
    Buffer2.prototype.toString = function toString() {
      const length = this.length;
      if (length === 0)
        return "";
      if (arguments.length === 0)
        return utf8Slice(this, 0, length);
      return slowToString.apply(this, arguments);
    };
    Buffer2.prototype.toLocaleString = Buffer2.prototype.toString;
    Buffer2.prototype.equals = function equals(b) {
      if (!Buffer2.isBuffer(b))
        throw new TypeError("Argument must be a Buffer");
      if (this === b)
        return true;
      return Buffer2.compare(this, b) === 0;
    };
    Buffer2.prototype.inspect = function inspect() {
      let str = "";
      const max = exports.INSPECT_MAX_BYTES;
      str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
      if (this.length > max)
        str += " ... ";
      return "<Buffer " + str + ">";
    };
    if (customInspectSymbol) {
      Buffer2.prototype[customInspectSymbol] = Buffer2.prototype.inspect;
    }
    Buffer2.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
      if (isInstance(target, Uint8Array)) {
        target = Buffer2.from(target, target.offset, target.byteLength);
      }
      if (!Buffer2.isBuffer(target)) {
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target
        );
      }
      if (start === void 0) {
        start = 0;
      }
      if (end === void 0) {
        end = target ? target.length : 0;
      }
      if (thisStart === void 0) {
        thisStart = 0;
      }
      if (thisEnd === void 0) {
        thisEnd = this.length;
      }
      if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
        throw new RangeError("out of range index");
      }
      if (thisStart >= thisEnd && start >= end) {
        return 0;
      }
      if (thisStart >= thisEnd) {
        return -1;
      }
      if (start >= end) {
        return 1;
      }
      start >>>= 0;
      end >>>= 0;
      thisStart >>>= 0;
      thisEnd >>>= 0;
      if (this === target)
        return 0;
      let x = thisEnd - thisStart;
      let y = end - start;
      const len = Math.min(x, y);
      const thisCopy = this.slice(thisStart, thisEnd);
      const targetCopy = target.slice(start, end);
      for (let i = 0; i < len; ++i) {
        if (thisCopy[i] !== targetCopy[i]) {
          x = thisCopy[i];
          y = targetCopy[i];
          break;
        }
      }
      if (x < y)
        return -1;
      if (y < x)
        return 1;
      return 0;
    };
    function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
      if (buffer.length === 0)
        return -1;
      if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
      } else if (byteOffset > 2147483647) {
        byteOffset = 2147483647;
      } else if (byteOffset < -2147483648) {
        byteOffset = -2147483648;
      }
      byteOffset = +byteOffset;
      if (numberIsNaN(byteOffset)) {
        byteOffset = dir ? 0 : buffer.length - 1;
      }
      if (byteOffset < 0)
        byteOffset = buffer.length + byteOffset;
      if (byteOffset >= buffer.length) {
        if (dir)
          return -1;
        else
          byteOffset = buffer.length - 1;
      } else if (byteOffset < 0) {
        if (dir)
          byteOffset = 0;
        else
          return -1;
      }
      if (typeof val === "string") {
        val = Buffer2.from(val, encoding);
      }
      if (Buffer2.isBuffer(val)) {
        if (val.length === 0) {
          return -1;
        }
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
      } else if (typeof val === "number") {
        val = val & 255;
        if (typeof Uint8Array.prototype.indexOf === "function") {
          if (dir) {
            return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
          } else {
            return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
          }
        }
        return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
      }
      throw new TypeError("val must be string, number or Buffer");
    }
    function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
      let indexSize = 1;
      let arrLength = arr.length;
      let valLength = val.length;
      if (encoding !== void 0) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
          if (arr.length < 2 || val.length < 2) {
            return -1;
          }
          indexSize = 2;
          arrLength /= 2;
          valLength /= 2;
          byteOffset /= 2;
        }
      }
      function read(buf, i2) {
        if (indexSize === 1) {
          return buf[i2];
        } else {
          return buf.readUInt16BE(i2 * indexSize);
        }
      }
      let i;
      if (dir) {
        let foundIndex = -1;
        for (i = byteOffset; i < arrLength; i++) {
          if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1)
              foundIndex = i;
            if (i - foundIndex + 1 === valLength)
              return foundIndex * indexSize;
          } else {
            if (foundIndex !== -1)
              i -= i - foundIndex;
            foundIndex = -1;
          }
        }
      } else {
        if (byteOffset + valLength > arrLength)
          byteOffset = arrLength - valLength;
        for (i = byteOffset; i >= 0; i--) {
          let found = true;
          for (let j = 0; j < valLength; j++) {
            if (read(arr, i + j) !== read(val, j)) {
              found = false;
              break;
            }
          }
          if (found)
            return i;
        }
      }
      return -1;
    }
    Buffer2.prototype.includes = function includes(val, byteOffset, encoding) {
      return this.indexOf(val, byteOffset, encoding) !== -1;
    };
    Buffer2.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
    };
    Buffer2.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
    };
    function hexWrite(buf, string2, offset, length) {
      offset = Number(offset) || 0;
      const remaining = buf.length - offset;
      if (!length) {
        length = remaining;
      } else {
        length = Number(length);
        if (length > remaining) {
          length = remaining;
        }
      }
      const strLen = string2.length;
      if (length > strLen / 2) {
        length = strLen / 2;
      }
      let i;
      for (i = 0; i < length; ++i) {
        const parsed = parseInt(string2.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed))
          return i;
        buf[offset + i] = parsed;
      }
      return i;
    }
    function utf8Write(buf, string2, offset, length) {
      return blitBuffer(utf8ToBytes(string2, buf.length - offset), buf, offset, length);
    }
    function asciiWrite(buf, string2, offset, length) {
      return blitBuffer(asciiToBytes(string2), buf, offset, length);
    }
    function base64Write(buf, string2, offset, length) {
      return blitBuffer(base64ToBytes(string2), buf, offset, length);
    }
    function ucs2Write(buf, string2, offset, length) {
      return blitBuffer(utf16leToBytes(string2, buf.length - offset), buf, offset, length);
    }
    Buffer2.prototype.write = function write(string2, offset, length, encoding) {
      if (offset === void 0) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
      } else if (length === void 0 && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
      } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
          length = length >>> 0;
          if (encoding === void 0)
            encoding = "utf8";
        } else {
          encoding = length;
          length = void 0;
        }
      } else {
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      }
      const remaining = this.length - offset;
      if (length === void 0 || length > remaining)
        length = remaining;
      if (string2.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
        throw new RangeError("Attempt to write outside buffer bounds");
      }
      if (!encoding)
        encoding = "utf8";
      let loweredCase = false;
      for (; ; ) {
        switch (encoding) {
          case "hex":
            return hexWrite(this, string2, offset, length);
          case "utf8":
          case "utf-8":
            return utf8Write(this, string2, offset, length);
          case "ascii":
          case "latin1":
          case "binary":
            return asciiWrite(this, string2, offset, length);
          case "base64":
            return base64Write(this, string2, offset, length);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return ucs2Write(this, string2, offset, length);
          default:
            if (loweredCase)
              throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
        }
      }
    };
    Buffer2.prototype.toJSON = function toJSON() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function base64Slice(buf, start, end) {
      if (start === 0 && end === buf.length) {
        return base64.fromByteArray(buf);
      } else {
        return base64.fromByteArray(buf.slice(start, end));
      }
    }
    function utf8Slice(buf, start, end) {
      end = Math.min(buf.length, end);
      const res = [];
      let i = start;
      while (i < end) {
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
        if (i + bytesPerSequence <= end) {
          let secondByte, thirdByte, fourthByte, tempCodePoint;
          switch (bytesPerSequence) {
            case 1:
              if (firstByte < 128) {
                codePoint = firstByte;
              }
              break;
            case 2:
              secondByte = buf[i + 1];
              if ((secondByte & 192) === 128) {
                tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
                if (tempCodePoint > 127) {
                  codePoint = tempCodePoint;
                }
              }
              break;
            case 3:
              secondByte = buf[i + 1];
              thirdByte = buf[i + 2];
              if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
                tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
                if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) {
                  codePoint = tempCodePoint;
                }
              }
              break;
            case 4:
              secondByte = buf[i + 1];
              thirdByte = buf[i + 2];
              fourthByte = buf[i + 3];
              if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
                tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
                if (tempCodePoint > 65535 && tempCodePoint < 1114112) {
                  codePoint = tempCodePoint;
                }
              }
          }
        }
        if (codePoint === null) {
          codePoint = 65533;
          bytesPerSequence = 1;
        } else if (codePoint > 65535) {
          codePoint -= 65536;
          res.push(codePoint >>> 10 & 1023 | 55296);
          codePoint = 56320 | codePoint & 1023;
        }
        res.push(codePoint);
        i += bytesPerSequence;
      }
      return decodeCodePointsArray(res);
    }
    var MAX_ARGUMENTS_LENGTH = 4096;
    function decodeCodePointsArray(codePoints) {
      const len = codePoints.length;
      if (len <= MAX_ARGUMENTS_LENGTH) {
        return String.fromCharCode.apply(String, codePoints);
      }
      let res = "";
      let i = 0;
      while (i < len) {
        res += String.fromCharCode.apply(
          String,
          codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
        );
      }
      return res;
    }
    function asciiSlice(buf, start, end) {
      let ret = "";
      end = Math.min(buf.length, end);
      for (let i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i] & 127);
      }
      return ret;
    }
    function latin1Slice(buf, start, end) {
      let ret = "";
      end = Math.min(buf.length, end);
      for (let i = start; i < end; ++i) {
        ret += String.fromCharCode(buf[i]);
      }
      return ret;
    }
    function hexSlice(buf, start, end) {
      const len = buf.length;
      if (!start || start < 0)
        start = 0;
      if (!end || end < 0 || end > len)
        end = len;
      let out = "";
      for (let i = start; i < end; ++i) {
        out += hexSliceLookupTable[buf[i]];
      }
      return out;
    }
    function utf16leSlice(buf, start, end) {
      const bytes = buf.slice(start, end);
      let res = "";
      for (let i = 0; i < bytes.length - 1; i += 2) {
        res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
      }
      return res;
    }
    Buffer2.prototype.slice = function slice(start, end) {
      const len = this.length;
      start = ~~start;
      end = end === void 0 ? len : ~~end;
      if (start < 0) {
        start += len;
        if (start < 0)
          start = 0;
      } else if (start > len) {
        start = len;
      }
      if (end < 0) {
        end += len;
        if (end < 0)
          end = 0;
      } else if (end > len) {
        end = len;
      }
      if (end < start)
        end = start;
      const newBuf = this.subarray(start, end);
      Object.setPrototypeOf(newBuf, Buffer2.prototype);
      return newBuf;
    };
    function checkOffset(offset, ext, length) {
      if (offset % 1 !== 0 || offset < 0)
        throw new RangeError("offset is not uint");
      if (offset + ext > length)
        throw new RangeError("Trying to access beyond buffer length");
    }
    Buffer2.prototype.readUintLE = Buffer2.prototype.readUIntLE = function readUIntLE(offset, byteLength2, noAssert) {
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert)
        checkOffset(offset, byteLength2, this.length);
      let val = this[offset];
      let mul = 1;
      let i = 0;
      while (++i < byteLength2 && (mul *= 256)) {
        val += this[offset + i] * mul;
      }
      return val;
    };
    Buffer2.prototype.readUintBE = Buffer2.prototype.readUIntBE = function readUIntBE(offset, byteLength2, noAssert) {
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) {
        checkOffset(offset, byteLength2, this.length);
      }
      let val = this[offset + --byteLength2];
      let mul = 1;
      while (byteLength2 > 0 && (mul *= 256)) {
        val += this[offset + --byteLength2] * mul;
      }
      return val;
    };
    Buffer2.prototype.readUint8 = Buffer2.prototype.readUInt8 = function readUInt8(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 1, this.length);
      return this[offset];
    };
    Buffer2.prototype.readUint16LE = Buffer2.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 2, this.length);
      return this[offset] | this[offset + 1] << 8;
    };
    Buffer2.prototype.readUint16BE = Buffer2.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 2, this.length);
      return this[offset] << 8 | this[offset + 1];
    };
    Buffer2.prototype.readUint32LE = Buffer2.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 16777216;
    };
    Buffer2.prototype.readUint32BE = Buffer2.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return this[offset] * 16777216 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
    };
    Buffer2.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
      offset = offset >>> 0;
      validateNumber(offset, "offset");
      const first = this[offset];
      const last = this[offset + 7];
      if (first === void 0 || last === void 0) {
        boundsError(offset, this.length - 8);
      }
      const lo = first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
      const hi = this[++offset] + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + last * 2 ** 24;
      return BigInt(lo) + (BigInt(hi) << BigInt(32));
    });
    Buffer2.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
      offset = offset >>> 0;
      validateNumber(offset, "offset");
      const first = this[offset];
      const last = this[offset + 7];
      if (first === void 0 || last === void 0) {
        boundsError(offset, this.length - 8);
      }
      const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
      const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last;
      return (BigInt(hi) << BigInt(32)) + BigInt(lo);
    });
    Buffer2.prototype.readIntLE = function readIntLE(offset, byteLength2, noAssert) {
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert)
        checkOffset(offset, byteLength2, this.length);
      let val = this[offset];
      let mul = 1;
      let i = 0;
      while (++i < byteLength2 && (mul *= 256)) {
        val += this[offset + i] * mul;
      }
      mul *= 128;
      if (val >= mul)
        val -= Math.pow(2, 8 * byteLength2);
      return val;
    };
    Buffer2.prototype.readIntBE = function readIntBE(offset, byteLength2, noAssert) {
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert)
        checkOffset(offset, byteLength2, this.length);
      let i = byteLength2;
      let mul = 1;
      let val = this[offset + --i];
      while (i > 0 && (mul *= 256)) {
        val += this[offset + --i] * mul;
      }
      mul *= 128;
      if (val >= mul)
        val -= Math.pow(2, 8 * byteLength2);
      return val;
    };
    Buffer2.prototype.readInt8 = function readInt8(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 1, this.length);
      if (!(this[offset] & 128))
        return this[offset];
      return (255 - this[offset] + 1) * -1;
    };
    Buffer2.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 2, this.length);
      const val = this[offset] | this[offset + 1] << 8;
      return val & 32768 ? val | 4294901760 : val;
    };
    Buffer2.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 2, this.length);
      const val = this[offset + 1] | this[offset] << 8;
      return val & 32768 ? val | 4294901760 : val;
    };
    Buffer2.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
    };
    Buffer2.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
    };
    Buffer2.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
      offset = offset >>> 0;
      validateNumber(offset, "offset");
      const first = this[offset];
      const last = this[offset + 7];
      if (first === void 0 || last === void 0) {
        boundsError(offset, this.length - 8);
      }
      const val = this[offset + 4] + this[offset + 5] * 2 ** 8 + this[offset + 6] * 2 ** 16 + (last << 24);
      return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
    });
    Buffer2.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
      offset = offset >>> 0;
      validateNumber(offset, "offset");
      const first = this[offset];
      const last = this[offset + 7];
      if (first === void 0 || last === void 0) {
        boundsError(offset, this.length - 8);
      }
      const val = (first << 24) + // Overflow
      this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
      return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last);
    });
    Buffer2.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return ieee754.read(this, offset, true, 23, 4);
    };
    Buffer2.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 4, this.length);
      return ieee754.read(this, offset, false, 23, 4);
    };
    Buffer2.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 8, this.length);
      return ieee754.read(this, offset, true, 52, 8);
    };
    Buffer2.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
      offset = offset >>> 0;
      if (!noAssert)
        checkOffset(offset, 8, this.length);
      return ieee754.read(this, offset, false, 52, 8);
    };
    function checkInt(buf, value, offset, ext, max, min) {
      if (!Buffer2.isBuffer(buf))
        throw new TypeError('"buffer" argument must be a Buffer instance');
      if (value > max || value < min)
        throw new RangeError('"value" argument is out of bounds');
      if (offset + ext > buf.length)
        throw new RangeError("Index out of range");
    }
    Buffer2.prototype.writeUintLE = Buffer2.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength2, noAssert) {
      value = +value;
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength2) - 1;
        checkInt(this, value, offset, byteLength2, maxBytes, 0);
      }
      let mul = 1;
      let i = 0;
      this[offset] = value & 255;
      while (++i < byteLength2 && (mul *= 256)) {
        this[offset + i] = value / mul & 255;
      }
      return offset + byteLength2;
    };
    Buffer2.prototype.writeUintBE = Buffer2.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength2, noAssert) {
      value = +value;
      offset = offset >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength2) - 1;
        checkInt(this, value, offset, byteLength2, maxBytes, 0);
      }
      let i = byteLength2 - 1;
      let mul = 1;
      this[offset + i] = value & 255;
      while (--i >= 0 && (mul *= 256)) {
        this[offset + i] = value / mul & 255;
      }
      return offset + byteLength2;
    };
    Buffer2.prototype.writeUint8 = Buffer2.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 1, 255, 0);
      this[offset] = value & 255;
      return offset + 1;
    };
    Buffer2.prototype.writeUint16LE = Buffer2.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 2, 65535, 0);
      this[offset] = value & 255;
      this[offset + 1] = value >>> 8;
      return offset + 2;
    };
    Buffer2.prototype.writeUint16BE = Buffer2.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 2, 65535, 0);
      this[offset] = value >>> 8;
      this[offset + 1] = value & 255;
      return offset + 2;
    };
    Buffer2.prototype.writeUint32LE = Buffer2.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 4, 4294967295, 0);
      this[offset + 3] = value >>> 24;
      this[offset + 2] = value >>> 16;
      this[offset + 1] = value >>> 8;
      this[offset] = value & 255;
      return offset + 4;
    };
    Buffer2.prototype.writeUint32BE = Buffer2.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 4, 4294967295, 0);
      this[offset] = value >>> 24;
      this[offset + 1] = value >>> 16;
      this[offset + 2] = value >>> 8;
      this[offset + 3] = value & 255;
      return offset + 4;
    };
    function wrtBigUInt64LE(buf, value, offset, min, max) {
      checkIntBI(value, min, max, buf, offset, 7);
      let lo = Number(value & BigInt(4294967295));
      buf[offset++] = lo;
      lo = lo >> 8;
      buf[offset++] = lo;
      lo = lo >> 8;
      buf[offset++] = lo;
      lo = lo >> 8;
      buf[offset++] = lo;
      let hi = Number(value >> BigInt(32) & BigInt(4294967295));
      buf[offset++] = hi;
      hi = hi >> 8;
      buf[offset++] = hi;
      hi = hi >> 8;
      buf[offset++] = hi;
      hi = hi >> 8;
      buf[offset++] = hi;
      return offset;
    }
    function wrtBigUInt64BE(buf, value, offset, min, max) {
      checkIntBI(value, min, max, buf, offset, 7);
      let lo = Number(value & BigInt(4294967295));
      buf[offset + 7] = lo;
      lo = lo >> 8;
      buf[offset + 6] = lo;
      lo = lo >> 8;
      buf[offset + 5] = lo;
      lo = lo >> 8;
      buf[offset + 4] = lo;
      let hi = Number(value >> BigInt(32) & BigInt(4294967295));
      buf[offset + 3] = hi;
      hi = hi >> 8;
      buf[offset + 2] = hi;
      hi = hi >> 8;
      buf[offset + 1] = hi;
      hi = hi >> 8;
      buf[offset] = hi;
      return offset + 8;
    }
    Buffer2.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
      return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
    });
    Buffer2.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
      return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
    });
    Buffer2.prototype.writeIntLE = function writeIntLE(value, offset, byteLength2, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength2 - 1);
        checkInt(this, value, offset, byteLength2, limit - 1, -limit);
      }
      let i = 0;
      let mul = 1;
      let sub = 0;
      this[offset] = value & 255;
      while (++i < byteLength2 && (mul *= 256)) {
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
          sub = 1;
        }
        this[offset + i] = (value / mul >> 0) - sub & 255;
      }
      return offset + byteLength2;
    };
    Buffer2.prototype.writeIntBE = function writeIntBE(value, offset, byteLength2, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength2 - 1);
        checkInt(this, value, offset, byteLength2, limit - 1, -limit);
      }
      let i = byteLength2 - 1;
      let mul = 1;
      let sub = 0;
      this[offset + i] = value & 255;
      while (--i >= 0 && (mul *= 256)) {
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
          sub = 1;
        }
        this[offset + i] = (value / mul >> 0) - sub & 255;
      }
      return offset + byteLength2;
    };
    Buffer2.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 1, 127, -128);
      if (value < 0)
        value = 255 + value + 1;
      this[offset] = value & 255;
      return offset + 1;
    };
    Buffer2.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 2, 32767, -32768);
      this[offset] = value & 255;
      this[offset + 1] = value >>> 8;
      return offset + 2;
    };
    Buffer2.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 2, 32767, -32768);
      this[offset] = value >>> 8;
      this[offset + 1] = value & 255;
      return offset + 2;
    };
    Buffer2.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 4, 2147483647, -2147483648);
      this[offset] = value & 255;
      this[offset + 1] = value >>> 8;
      this[offset + 2] = value >>> 16;
      this[offset + 3] = value >>> 24;
      return offset + 4;
    };
    Buffer2.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert)
        checkInt(this, value, offset, 4, 2147483647, -2147483648);
      if (value < 0)
        value = 4294967295 + value + 1;
      this[offset] = value >>> 24;
      this[offset + 1] = value >>> 16;
      this[offset + 2] = value >>> 8;
      this[offset + 3] = value & 255;
      return offset + 4;
    };
    Buffer2.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
      return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    Buffer2.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
      return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    function checkIEEE754(buf, value, offset, ext, max, min) {
      if (offset + ext > buf.length)
        throw new RangeError("Index out of range");
      if (offset < 0)
        throw new RangeError("Index out of range");
    }
    function writeFloat(buf, value, offset, littleEndian, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) {
        checkIEEE754(buf, value, offset, 4, 34028234663852886e22, -34028234663852886e22);
      }
      ieee754.write(buf, value, offset, littleEndian, 23, 4);
      return offset + 4;
    }
    Buffer2.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
      return writeFloat(this, value, offset, true, noAssert);
    };
    Buffer2.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
      return writeFloat(this, value, offset, false, noAssert);
    };
    function writeDouble(buf, value, offset, littleEndian, noAssert) {
      value = +value;
      offset = offset >>> 0;
      if (!noAssert) {
        checkIEEE754(buf, value, offset, 8, 17976931348623157e292, -17976931348623157e292);
      }
      ieee754.write(buf, value, offset, littleEndian, 52, 8);
      return offset + 8;
    }
    Buffer2.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
      return writeDouble(this, value, offset, true, noAssert);
    };
    Buffer2.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
      return writeDouble(this, value, offset, false, noAssert);
    };
    Buffer2.prototype.copy = function copy(target, targetStart, start, end) {
      if (!Buffer2.isBuffer(target))
        throw new TypeError("argument should be a Buffer");
      if (!start)
        start = 0;
      if (!end && end !== 0)
        end = this.length;
      if (targetStart >= target.length)
        targetStart = target.length;
      if (!targetStart)
        targetStart = 0;
      if (end > 0 && end < start)
        end = start;
      if (end === start)
        return 0;
      if (target.length === 0 || this.length === 0)
        return 0;
      if (targetStart < 0) {
        throw new RangeError("targetStart out of bounds");
      }
      if (start < 0 || start >= this.length)
        throw new RangeError("Index out of range");
      if (end < 0)
        throw new RangeError("sourceEnd out of bounds");
      if (end > this.length)
        end = this.length;
      if (target.length - targetStart < end - start) {
        end = target.length - targetStart + start;
      }
      const len = end - start;
      if (this === target && typeof Uint8Array.prototype.copyWithin === "function") {
        this.copyWithin(targetStart, start, end);
      } else {
        Uint8Array.prototype.set.call(
          target,
          this.subarray(start, end),
          targetStart
        );
      }
      return len;
    };
    Buffer2.prototype.fill = function fill(val, start, end, encoding) {
      if (typeof val === "string") {
        if (typeof start === "string") {
          encoding = start;
          start = 0;
          end = this.length;
        } else if (typeof end === "string") {
          encoding = end;
          end = this.length;
        }
        if (encoding !== void 0 && typeof encoding !== "string") {
          throw new TypeError("encoding must be a string");
        }
        if (typeof encoding === "string" && !Buffer2.isEncoding(encoding)) {
          throw new TypeError("Unknown encoding: " + encoding);
        }
        if (val.length === 1) {
          const code = val.charCodeAt(0);
          if (encoding === "utf8" && code < 128 || encoding === "latin1") {
            val = code;
          }
        }
      } else if (typeof val === "number") {
        val = val & 255;
      } else if (typeof val === "boolean") {
        val = Number(val);
      }
      if (start < 0 || this.length < start || this.length < end) {
        throw new RangeError("Out of range index");
      }
      if (end <= start) {
        return this;
      }
      start = start >>> 0;
      end = end === void 0 ? this.length : end >>> 0;
      if (!val)
        val = 0;
      let i;
      if (typeof val === "number") {
        for (i = start; i < end; ++i) {
          this[i] = val;
        }
      } else {
        const bytes = Buffer2.isBuffer(val) ? val : Buffer2.from(val, encoding);
        const len = bytes.length;
        if (len === 0) {
          throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        }
        for (i = 0; i < end - start; ++i) {
          this[i + start] = bytes[i % len];
        }
      }
      return this;
    };
    var errors = {};
    function E(sym, getMessage, Base) {
      errors[sym] = class NodeError extends Base {
        constructor() {
          super();
          Object.defineProperty(this, "message", {
            value: getMessage.apply(this, arguments),
            writable: true,
            configurable: true
          });
          this.name = `${this.name} [${sym}]`;
          this.stack;
          delete this.name;
        }
        get code() {
          return sym;
        }
        set code(value) {
          Object.defineProperty(this, "code", {
            configurable: true,
            enumerable: true,
            value,
            writable: true
          });
        }
        toString() {
          return `${this.name} [${sym}]: ${this.message}`;
        }
      };
    }
    E(
      "ERR_BUFFER_OUT_OF_BOUNDS",
      function(name) {
        if (name) {
          return `${name} is outside of buffer bounds`;
        }
        return "Attempt to access memory outside buffer bounds";
      },
      RangeError
    );
    E(
      "ERR_INVALID_ARG_TYPE",
      function(name, actual) {
        return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
      },
      TypeError
    );
    E(
      "ERR_OUT_OF_RANGE",
      function(str, range, input) {
        let msg = `The value of "${str}" is out of range.`;
        let received = input;
        if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
          received = addNumericalSeparator(String(input));
        } else if (typeof input === "bigint") {
          received = String(input);
          if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
            received = addNumericalSeparator(received);
          }
          received += "n";
        }
        msg += ` It must be ${range}. Received ${received}`;
        return msg;
      },
      RangeError
    );
    function addNumericalSeparator(val) {
      let res = "";
      let i = val.length;
      const start = val[0] === "-" ? 1 : 0;
      for (; i >= start + 4; i -= 3) {
        res = `_${val.slice(i - 3, i)}${res}`;
      }
      return `${val.slice(0, i)}${res}`;
    }
    function checkBounds(buf, offset, byteLength2) {
      validateNumber(offset, "offset");
      if (buf[offset] === void 0 || buf[offset + byteLength2] === void 0) {
        boundsError(offset, buf.length - (byteLength2 + 1));
      }
    }
    function checkIntBI(value, min, max, buf, offset, byteLength2) {
      if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength2 > 3) {
          if (min === 0 || min === BigInt(0)) {
            range = `>= 0${n} and < 2${n} ** ${(byteLength2 + 1) * 8}${n}`;
          } else {
            range = `>= -(2${n} ** ${(byteLength2 + 1) * 8 - 1}${n}) and < 2 ** ${(byteLength2 + 1) * 8 - 1}${n}`;
          }
        } else {
          range = `>= ${min}${n} and <= ${max}${n}`;
        }
        throw new errors.ERR_OUT_OF_RANGE("value", range, value);
      }
      checkBounds(buf, offset, byteLength2);
    }
    function validateNumber(value, name) {
      if (typeof value !== "number") {
        throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
      }
    }
    function boundsError(value, length, type) {
      if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
      }
      if (length < 0) {
        throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
      }
      throw new errors.ERR_OUT_OF_RANGE(
        type || "offset",
        `>= ${type ? 1 : 0} and <= ${length}`,
        value
      );
    }
    var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
    function base64clean(str) {
      str = str.split("=")[0];
      str = str.trim().replace(INVALID_BASE64_RE, "");
      if (str.length < 2)
        return "";
      while (str.length % 4 !== 0) {
        str = str + "=";
      }
      return str;
    }
    function utf8ToBytes(string2, units) {
      units = units || Infinity;
      let codePoint;
      const length = string2.length;
      let leadSurrogate = null;
      const bytes = [];
      for (let i = 0; i < length; ++i) {
        codePoint = string2.charCodeAt(i);
        if (codePoint > 55295 && codePoint < 57344) {
          if (!leadSurrogate) {
            if (codePoint > 56319) {
              if ((units -= 3) > -1)
                bytes.push(239, 191, 189);
              continue;
            } else if (i + 1 === length) {
              if ((units -= 3) > -1)
                bytes.push(239, 191, 189);
              continue;
            }
            leadSurrogate = codePoint;
            continue;
          }
          if (codePoint < 56320) {
            if ((units -= 3) > -1)
              bytes.push(239, 191, 189);
            leadSurrogate = codePoint;
            continue;
          }
          codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
        } else if (leadSurrogate) {
          if ((units -= 3) > -1)
            bytes.push(239, 191, 189);
        }
        leadSurrogate = null;
        if (codePoint < 128) {
          if ((units -= 1) < 0)
            break;
          bytes.push(codePoint);
        } else if (codePoint < 2048) {
          if ((units -= 2) < 0)
            break;
          bytes.push(
            codePoint >> 6 | 192,
            codePoint & 63 | 128
          );
        } else if (codePoint < 65536) {
          if ((units -= 3) < 0)
            break;
          bytes.push(
            codePoint >> 12 | 224,
            codePoint >> 6 & 63 | 128,
            codePoint & 63 | 128
          );
        } else if (codePoint < 1114112) {
          if ((units -= 4) < 0)
            break;
          bytes.push(
            codePoint >> 18 | 240,
            codePoint >> 12 & 63 | 128,
            codePoint >> 6 & 63 | 128,
            codePoint & 63 | 128
          );
        } else {
          throw new Error("Invalid code point");
        }
      }
      return bytes;
    }
    function asciiToBytes(str) {
      const byteArray = [];
      for (let i = 0; i < str.length; ++i) {
        byteArray.push(str.charCodeAt(i) & 255);
      }
      return byteArray;
    }
    function utf16leToBytes(str, units) {
      let c, hi, lo;
      const byteArray = [];
      for (let i = 0; i < str.length; ++i) {
        if ((units -= 2) < 0)
          break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
      }
      return byteArray;
    }
    function base64ToBytes(str) {
      return base64.toByteArray(base64clean(str));
    }
    function blitBuffer(src, dst, offset, length) {
      let i;
      for (i = 0; i < length; ++i) {
        if (i + offset >= dst.length || i >= src.length)
          break;
        dst[i + offset] = src[i];
      }
      return i;
    }
    function isInstance(obj, type) {
      return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
    }
    function numberIsNaN(obj) {
      return obj !== obj;
    }
    var hexSliceLookupTable = function() {
      const alphabet = "0123456789abcdef";
      const table = new Array(256);
      for (let i = 0; i < 16; ++i) {
        const i16 = i * 16;
        for (let j = 0; j < 16; ++j) {
          table[i16 + j] = alphabet[i] + alphabet[j];
        }
      }
      return table;
    }();
    function defineBigIntMethod(fn) {
      return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
    }
    function BufferBigIntNotDefined() {
      throw new Error("BigInt not supported");
    }
  }
});

// .yarn/cache/safe-buffer-npm-5.1.2-c27fedf6c4-f2f1f7943c.zip/node_modules/safe-buffer/index.js
var require_safe_buffer = __commonJS({
  ".yarn/cache/safe-buffer-npm-5.1.2-c27fedf6c4-f2f1f7943c.zip/node_modules/safe-buffer/index.js"(exports, module2) {
    var buffer = require_buffer();
    var Buffer2 = buffer.Buffer;
    function copyProps(src, dst) {
      for (var key in src) {
        dst[key] = src[key];
      }
    }
    if (Buffer2.from && Buffer2.alloc && Buffer2.allocUnsafe && Buffer2.allocUnsafeSlow) {
      module2.exports = buffer;
    } else {
      copyProps(buffer, exports);
      exports.Buffer = SafeBuffer;
    }
    function SafeBuffer(arg, encodingOrOffset, length) {
      return Buffer2(arg, encodingOrOffset, length);
    }
    copyProps(Buffer2, SafeBuffer);
    SafeBuffer.from = function(arg, encodingOrOffset, length) {
      if (typeof arg === "number") {
        throw new TypeError("Argument must not be a number");
      }
      return Buffer2(arg, encodingOrOffset, length);
    };
    SafeBuffer.alloc = function(size, fill, encoding) {
      if (typeof size !== "number") {
        throw new TypeError("Argument must be a number");
      }
      var buf = Buffer2(size);
      if (fill !== void 0) {
        if (typeof encoding === "string") {
          buf.fill(fill, encoding);
        } else {
          buf.fill(fill);
        }
      } else {
        buf.fill(0);
      }
      return buf;
    };
    SafeBuffer.allocUnsafe = function(size) {
      if (typeof size !== "number") {
        throw new TypeError("Argument must be a number");
      }
      return Buffer2(size);
    };
    SafeBuffer.allocUnsafeSlow = function(size) {
      if (typeof size !== "number") {
        throw new TypeError("Argument must be a number");
      }
      return buffer.SlowBuffer(size);
    };
  }
});

// .yarn/cache/basic-auth-npm-2.0.1-f1627ef330-3419b805d5.zip/node_modules/basic-auth/index.js
var require_basic_auth = __commonJS({
  ".yarn/cache/basic-auth-npm-2.0.1-f1627ef330-3419b805d5.zip/node_modules/basic-auth/index.js"(exports, module2) {
    "use strict";
    var Buffer2 = require_safe_buffer().Buffer;
    module2.exports = auth;
    module2.exports.parse = parse2;
    var CREDENTIALS_REGEXP = /^ *(?:[Bb][Aa][Ss][Ii][Cc]) +([A-Za-z0-9._~+/-]+=*) *$/;
    var USER_PASS_REGEXP = /^([^:]*):(.*)$/;
    function auth(req) {
      if (!req) {
        throw new TypeError("argument req is required");
      }
      if (typeof req !== "object") {
        throw new TypeError("argument req is required to be an object");
      }
      var header = getAuthorization(req);
      return parse2(header);
    }
    function decodeBase64(str) {
      return Buffer2.from(str, "base64").toString();
    }
    function getAuthorization(req) {
      if (!req.headers || typeof req.headers !== "object") {
        throw new TypeError("argument req is required to have headers property");
      }
      return req.headers.authorization;
    }
    function parse2(string2) {
      if (typeof string2 !== "string") {
        return void 0;
      }
      var match = CREDENTIALS_REGEXP.exec(string2);
      if (!match) {
        return void 0;
      }
      var userPass = USER_PASS_REGEXP.exec(decodeBase64(match[1]));
      if (!userPass) {
        return void 0;
      }
      return new Credentials(userPass[1], userPass[2]);
    }
    function Credentials(name, pass) {
      this.name = name;
      this.pass = pass;
    }
  }
});

// src/core/auth/BasicAuth.ts
var import_basic_auth;
var init_BasicAuth = __esm({
  "src/core/auth/BasicAuth.ts"() {
    "use strict";
    import_basic_auth = __toESM(require_basic_auth());
  }
});

// src/core/auth/BearerToken.ts
var BEARER_AUTH_HEADER_PREFIX, BearerToken;
var init_BearerToken = __esm({
  "src/core/auth/BearerToken.ts"() {
    "use strict";
    BEARER_AUTH_HEADER_PREFIX = /^Bearer /i;
    BearerToken = {
      toAuthorizationHeader: (token) => {
        if (token == null) {
          return void 0;
        }
        return `Bearer ${token}`;
      },
      fromAuthorizationHeader: (header) => {
        return header.replace(BEARER_AUTH_HEADER_PREFIX, "").trim();
      }
    };
  }
});

// src/core/auth/index.ts
var init_auth = __esm({
  "src/core/auth/index.ts"() {
    "use strict";
    init_BasicAuth();
    init_BearerToken();
  }
});

// src/core/index.ts
var init_core = __esm({
  "src/core/index.ts"() {
    "use strict";
    init_utils();
    init_schemas();
    init_fetcher();
    init_auth();
  }
});

// src/resources/config/client/fetchConfig.ts
var fetchConfig_exports = {};
__export(fetchConfig_exports, {
  Error: () => Error2
});
var Error2;
var init_fetchConfig = __esm({
  "src/resources/config/client/fetchConfig.ts"() {
    "use strict";
    init_src();
    init_core();
    Error2 = {
      _unknown: (fetcherError) => {
        const valueWithoutVisit = fetcherError;
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.config.fetchConfig.Error._visit(this, visitor);
        });
      },
      _visit: (value, visitor) => {
        switch (value.statusCode) {
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/resources/config/client/index.ts
var init_client = __esm({
  "src/resources/config/client/index.ts"() {
    "use strict";
    init_fetchConfig();
  }
});

// src/resources/config/index.ts
var config_exports = {};
__export(config_exports, {
  fetchConfig: () => fetchConfig_exports
});
var init_config = __esm({
  "src/resources/config/index.ts"() {
    "use strict";
    init_types2();
    init_client();
  }
});

// src/resources/login/types/RedirectToUrl.ts
var init_RedirectToUrl = __esm({
  "src/resources/login/types/RedirectToUrl.ts"() {
    "use strict";
  }
});

// src/resources/login/types/BadRequestUpdateForgotPasswordType.ts
var init_BadRequestUpdateForgotPasswordType = __esm({
  "src/resources/login/types/BadRequestUpdateForgotPasswordType.ts"() {
    "use strict";
  }
});

// src/resources/login/types/BadRequestLoginType.ts
var init_BadRequestLoginType = __esm({
  "src/resources/login/types/BadRequestLoginType.ts"() {
    "use strict";
  }
});

// src/resources/login/types/NoAccountFoundWithCredentialsType.ts
var init_NoAccountFoundWithCredentialsType = __esm({
  "src/resources/login/types/NoAccountFoundWithCredentialsType.ts"() {
    "use strict";
  }
});

// src/resources/login/types/BadRequestLoginPasswordlessType.ts
var init_BadRequestLoginPasswordlessType = __esm({
  "src/resources/login/types/BadRequestLoginPasswordlessType.ts"() {
    "use strict";
  }
});

// src/resources/login/types/BadRequestForgotPasswordType.ts
var init_BadRequestForgotPasswordType = __esm({
  "src/resources/login/types/BadRequestForgotPasswordType.ts"() {
    "use strict";
  }
});

// src/resources/login/types/index.ts
var init_types5 = __esm({
  "src/resources/login/types/index.ts"() {
    "use strict";
    init_RedirectToUrl();
    init_BadRequestUpdateForgotPasswordType();
    init_BadRequestLoginType();
    init_NoAccountFoundWithCredentialsType();
    init_BadRequestLoginPasswordlessType();
    init_BadRequestForgotPasswordType();
  }
});

// src/resources/login/errors/BadRequestLogin.ts
var init_BadRequestLogin = __esm({
  "src/resources/login/errors/BadRequestLogin.ts"() {
    "use strict";
  }
});

// src/resources/login/errors/NoAccountFoundWithCredentials.ts
var init_NoAccountFoundWithCredentials = __esm({
  "src/resources/login/errors/NoAccountFoundWithCredentials.ts"() {
    "use strict";
  }
});

// src/resources/login/errors/BadRequestLoginPasswordless.ts
var init_BadRequestLoginPasswordless = __esm({
  "src/resources/login/errors/BadRequestLoginPasswordless.ts"() {
    "use strict";
  }
});

// src/resources/login/errors/BadRequestForgotPassword.ts
var init_BadRequestForgotPassword = __esm({
  "src/resources/login/errors/BadRequestForgotPassword.ts"() {
    "use strict";
  }
});

// src/resources/login/errors/BadRequestUpdateForgotPassword.ts
var init_BadRequestUpdateForgotPassword = __esm({
  "src/resources/login/errors/BadRequestUpdateForgotPassword.ts"() {
    "use strict";
  }
});

// src/resources/login/errors/index.ts
var init_errors2 = __esm({
  "src/resources/login/errors/index.ts"() {
    "use strict";
    init_BadRequestLogin();
    init_NoAccountFoundWithCredentials();
    init_BadRequestLoginPasswordless();
    init_BadRequestForgotPassword();
    init_BadRequestUpdateForgotPassword();
  }
});

// src/resources/login/client/login.ts
var login_exports = {};
__export(login_exports, {
  Error: () => Error3
});
var Error3;
var init_login = __esm({
  "src/resources/login/client/login.ts"() {
    "use strict";
    init_src();
    init_core();
    Error3 = {
      badRequestLogin: (value) => {
        const valueWithoutVisit = {
          content: value,
          statusCode: 400
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.login.login.Error._visit(this, visitor);
        });
      },
      noAccountFoundWithCredentials: (value) => {
        const valueWithoutVisit = {
          content: value,
          statusCode: 404
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.login.login.Error._visit(this, visitor);
        });
      },
      _unknown: (fetcherError) => {
        const valueWithoutVisit = fetcherError;
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.login.login.Error._visit(this, visitor);
        });
      },
      _visit: (value, visitor) => {
        switch (value.statusCode) {
          case 400:
            return visitor.badRequestLogin(value.content);
          case 404:
            return visitor.noAccountFoundWithCredentials(value.content);
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/resources/login/client/requests/index.ts
var init_requests = __esm({
  "src/resources/login/client/requests/index.ts"() {
    "use strict";
  }
});

// src/resources/login/client/sendMagicLinkLogin.ts
var sendMagicLinkLogin_exports = {};
__export(sendMagicLinkLogin_exports, {
  Error: () => Error4
});
var Error4;
var init_sendMagicLinkLogin = __esm({
  "src/resources/login/client/sendMagicLinkLogin.ts"() {
    "use strict";
    init_src();
    init_core();
    Error4 = {
      loginPasswordlessNotSupported: () => {
        const valueWithoutVisit = {
          statusCode: 404
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.login.sendMagicLinkLogin.Error._visit(this, visitor);
        });
      },
      badRequestLoginPasswordless: (value) => {
        const valueWithoutVisit = {
          content: value,
          statusCode: 400
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.login.sendMagicLinkLogin.Error._visit(this, visitor);
        });
      },
      _unknown: (fetcherError) => {
        const valueWithoutVisit = fetcherError;
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.login.sendMagicLinkLogin.Error._visit(this, visitor);
        });
      },
      _visit: (value, visitor) => {
        switch (value.statusCode) {
          case 404:
            return visitor.loginPasswordlessNotSupported();
          case 400:
            return visitor.badRequestLoginPasswordless(value.content);
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/resources/login/client/forgotPassword.ts
var forgotPassword_exports = {};
__export(forgotPassword_exports, {
  Error: () => Error5
});
var Error5;
var init_forgotPassword = __esm({
  "src/resources/login/client/forgotPassword.ts"() {
    "use strict";
    init_src();
    init_core();
    Error5 = {
      badRequestForgotPassword: (value) => {
        const valueWithoutVisit = {
          content: value,
          statusCode: 400
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.login.forgotPassword.Error._visit(this, visitor);
        });
      },
      _unknown: (fetcherError) => {
        const valueWithoutVisit = fetcherError;
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.login.forgotPassword.Error._visit(this, visitor);
        });
      },
      _visit: (value, visitor) => {
        switch (value.statusCode) {
          case 400:
            return visitor.badRequestForgotPassword(value.content);
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/resources/login/client/fetchLoginState.ts
var fetchLoginState_exports = {};
__export(fetchLoginState_exports, {
  Error: () => Error6
});
var Error6;
var init_fetchLoginState = __esm({
  "src/resources/login/client/fetchLoginState.ts"() {
    "use strict";
    init_src();
    init_core();
    Error6 = {
      _unknown: (fetcherError) => {
        const valueWithoutVisit = fetcherError;
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.login.fetchLoginState.Error._visit(this, visitor);
        });
      },
      _visit: (value, visitor) => {
        switch (value.statusCode) {
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/resources/login/client/checkOrgNameForSamlLogin.ts
var checkOrgNameForSamlLogin_exports = {};
__export(checkOrgNameForSamlLogin_exports, {
  Error: () => Error7
});
var Error7;
var init_checkOrgNameForSamlLogin = __esm({
  "src/resources/login/client/checkOrgNameForSamlLogin.ts"() {
    "use strict";
    init_src();
    init_core();
    Error7 = {
      notFoundOrgName: () => {
        const valueWithoutVisit = {
          statusCode: 404
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.login.checkOrgNameForSamlLogin.Error._visit(this, visitor);
        });
      },
      orgsNotEnabled: () => {
        const valueWithoutVisit = {
          statusCode: 404
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.login.checkOrgNameForSamlLogin.Error._visit(this, visitor);
        });
      },
      _unknown: (fetcherError) => {
        const valueWithoutVisit = fetcherError;
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.login.checkOrgNameForSamlLogin.Error._visit(this, visitor);
        });
      },
      _visit: (value, visitor) => {
        switch (value.statusCode) {
          case 404:
            return visitor.notFoundOrgName();
          case 404:
            return visitor.orgsNotEnabled();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/resources/login/client/index.ts
var init_client2 = __esm({
  "src/resources/login/client/index.ts"() {
    "use strict";
    init_login();
    init_requests();
    init_sendMagicLinkLogin();
    init_forgotPassword();
    init_fetchLoginState();
    init_checkOrgNameForSamlLogin();
  }
});

// src/resources/login/index.ts
var login_exports2 = {};
__export(login_exports2, {
  checkOrgNameForSamlLogin: () => checkOrgNameForSamlLogin_exports,
  fetchLoginState: () => fetchLoginState_exports,
  forgotPassword: () => forgotPassword_exports,
  login: () => login_exports,
  sendMagicLinkLogin: () => sendMagicLinkLogin_exports
});
var init_login2 = __esm({
  "src/resources/login/index.ts"() {
    "use strict";
    init_types5();
    init_errors2();
    init_client2();
  }
});

// src/resources/mfa/types/MfaStatusResponse.ts
var MfaStatusResponse;
var init_MfaStatusResponse = __esm({
  "src/resources/mfa/types/MfaStatusResponse.ts"() {
    "use strict";
    init_src();
    init_core();
    MfaStatusResponse = {
      enabled: (value) => {
        const valueWithoutVisit = {
          ...value,
          type: "Enabled"
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.MfaStatusResponse._visit(this, visitor);
        });
      },
      disabled: (value) => {
        const valueWithoutVisit = {
          ...value,
          type: "Disabled"
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.MfaStatusResponse._visit(this, visitor);
        });
      },
      _unknown: (value) => {
        const valueWithoutVisit = value;
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.MfaStatusResponse._visit(this, visitor);
        });
      },
      _visit: (value, visitor) => {
        switch (value.type) {
          case "Enabled":
            return visitor.enabled(value);
          case "Disabled":
            return visitor.disabled(value);
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/resources/mfa/types/MfaEnabledResponse.ts
var init_MfaEnabledResponse = __esm({
  "src/resources/mfa/types/MfaEnabledResponse.ts"() {
    "use strict";
  }
});

// src/resources/mfa/types/MfaDisabledResponse.ts
var init_MfaDisabledResponse = __esm({
  "src/resources/mfa/types/MfaDisabledResponse.ts"() {
    "use strict";
  }
});

// src/resources/mfa/types/BadRequestMfaVerifyError.ts
var init_BadRequestMfaVerifyError = __esm({
  "src/resources/mfa/types/BadRequestMfaVerifyError.ts"() {
    "use strict";
  }
});

// src/resources/mfa/types/BadRequestMfaEnableError.ts
var init_BadRequestMfaEnableError = __esm({
  "src/resources/mfa/types/BadRequestMfaEnableError.ts"() {
    "use strict";
  }
});

// src/resources/mfa/types/index.ts
var init_types6 = __esm({
  "src/resources/mfa/types/index.ts"() {
    "use strict";
    init_MfaStatusResponse();
    init_MfaEnabledResponse();
    init_MfaDisabledResponse();
    init_BadRequestMfaVerifyError();
    init_BadRequestMfaEnableError();
  }
});

// src/resources/mfa/errors/BadRequestMfaVerify.ts
var init_BadRequestMfaVerify = __esm({
  "src/resources/mfa/errors/BadRequestMfaVerify.ts"() {
    "use strict";
  }
});

// src/resources/mfa/errors/IncorrectMfaCode.ts
var init_IncorrectMfaCode = __esm({
  "src/resources/mfa/errors/IncorrectMfaCode.ts"() {
    "use strict";
  }
});

// src/resources/mfa/errors/BadRequestMfaEnable.ts
var init_BadRequestMfaEnable = __esm({
  "src/resources/mfa/errors/BadRequestMfaEnable.ts"() {
    "use strict";
  }
});

// src/resources/mfa/errors/ForbiddenMfaEnable.ts
var init_ForbiddenMfaEnable = __esm({
  "src/resources/mfa/errors/ForbiddenMfaEnable.ts"() {
    "use strict";
  }
});

// src/resources/mfa/errors/index.ts
var init_errors3 = __esm({
  "src/resources/mfa/errors/index.ts"() {
    "use strict";
    init_BadRequestMfaVerify();
    init_IncorrectMfaCode();
    init_BadRequestMfaEnable();
    init_ForbiddenMfaEnable();
  }
});

// src/resources/mfa/client/mfaVerify.ts
var mfaVerify_exports = {};
__export(mfaVerify_exports, {
  Error: () => Error8
});
var Error8;
var init_mfaVerify = __esm({
  "src/resources/mfa/client/mfaVerify.ts"() {
    "use strict";
    init_src();
    init_core();
    Error8 = {
      badRequestMfaVerify: (value) => {
        const valueWithoutVisit = {
          content: value,
          statusCode: 400
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.mfa.mfaVerify.Error._visit(this, visitor);
        });
      },
      mfaTimedOut: () => {
        const valueWithoutVisit = {
          statusCode: 404
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.mfa.mfaVerify.Error._visit(this, visitor);
        });
      },
      incorrectMfaCode: (value) => {
        const valueWithoutVisit = {
          content: value,
          statusCode: 403
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.mfa.mfaVerify.Error._visit(this, visitor);
        });
      },
      _unknown: (fetcherError) => {
        const valueWithoutVisit = fetcherError;
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.mfa.mfaVerify.Error._visit(this, visitor);
        });
      },
      _visit: (value, visitor) => {
        switch (value.statusCode) {
          case 400:
            return visitor.badRequestMfaVerify(value.content);
          case 404:
            return visitor.mfaTimedOut();
          case 403:
            return visitor.incorrectMfaCode(value.content);
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/resources/mfa/client/requests/index.ts
var init_requests2 = __esm({
  "src/resources/mfa/client/requests/index.ts"() {
    "use strict";
  }
});

// src/resources/mfa/client/mfaVerifyBackup.ts
var mfaVerifyBackup_exports = {};
__export(mfaVerifyBackup_exports, {
  Error: () => Error9
});
var Error9;
var init_mfaVerifyBackup = __esm({
  "src/resources/mfa/client/mfaVerifyBackup.ts"() {
    "use strict";
    init_src();
    init_core();
    Error9 = {
      badRequestMfaVerify: (value) => {
        const valueWithoutVisit = {
          content: value,
          statusCode: 400
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.mfa.mfaVerifyBackup.Error._visit(this, visitor);
        });
      },
      mfaTimedOut: () => {
        const valueWithoutVisit = {
          statusCode: 404
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.mfa.mfaVerifyBackup.Error._visit(this, visitor);
        });
      },
      incorrectMfaCode: (value) => {
        const valueWithoutVisit = {
          content: value,
          statusCode: 403
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.mfa.mfaVerifyBackup.Error._visit(this, visitor);
        });
      },
      _unknown: (fetcherError) => {
        const valueWithoutVisit = fetcherError;
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.mfa.mfaVerifyBackup.Error._visit(this, visitor);
        });
      },
      _visit: (value, visitor) => {
        switch (value.statusCode) {
          case 400:
            return visitor.badRequestMfaVerify(value.content);
          case 404:
            return visitor.mfaTimedOut();
          case 403:
            return visitor.incorrectMfaCode(value.content);
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/resources/mfa/client/index.ts
var init_client3 = __esm({
  "src/resources/mfa/client/index.ts"() {
    "use strict";
    init_mfaVerify();
    init_requests2();
    init_mfaVerifyBackup();
  }
});

// src/resources/mfa/index.ts
var mfa_exports = {};
__export(mfa_exports, {
  MfaStatusResponse: () => MfaStatusResponse,
  mfaVerify: () => mfaVerify_exports,
  mfaVerifyBackup: () => mfaVerifyBackup_exports
});
var init_mfa = __esm({
  "src/resources/mfa/index.ts"() {
    "use strict";
    init_types6();
    init_errors3();
    init_client3();
  }
});

// src/resources/org/types/PendingOrgInvitesResponse.ts
var init_PendingOrgInvitesResponse = __esm({
  "src/resources/org/types/PendingOrgInvitesResponse.ts"() {
    "use strict";
  }
});

// src/resources/org/types/Invitation.ts
var init_Invitation = __esm({
  "src/resources/org/types/Invitation.ts"() {
    "use strict";
  }
});

// src/resources/org/types/OrgResponse.ts
var init_OrgResponse = __esm({
  "src/resources/org/types/OrgResponse.ts"() {
    "use strict";
  }
});

// src/resources/org/types/CreateOrgOptionsResponse.ts
var init_CreateOrgOptionsResponse = __esm({
  "src/resources/org/types/CreateOrgOptionsResponse.ts"() {
    "use strict";
  }
});

// src/resources/org/types/OrgMembershipResponse.ts
var init_OrgMembershipResponse = __esm({
  "src/resources/org/types/OrgMembershipResponse.ts"() {
    "use strict";
  }
});

// src/resources/org/types/PendingInvite.ts
var init_PendingInvite = __esm({
  "src/resources/org/types/PendingInvite.ts"() {
    "use strict";
  }
});

// src/resources/org/types/SelectedOrgStatusUser.ts
var init_SelectedOrgStatusUser = __esm({
  "src/resources/org/types/SelectedOrgStatusUser.ts"() {
    "use strict";
  }
});

// src/resources/org/types/OrgStatusResponse.ts
var init_OrgStatusResponse = __esm({
  "src/resources/org/types/OrgStatusResponse.ts"() {
    "use strict";
  }
});

// src/resources/org/types/OrgInfoResponse.ts
var init_OrgInfoResponse = __esm({
  "src/resources/org/types/OrgInfoResponse.ts"() {
    "use strict";
  }
});

// src/resources/org/types/SelectedOrgStatusResponse.ts
var init_SelectedOrgStatusResponse = __esm({
  "src/resources/org/types/SelectedOrgStatusResponse.ts"() {
    "use strict";
  }
});

// src/resources/org/types/JoinableOrgsResponse.ts
var init_JoinableOrgsResponse = __esm({
  "src/resources/org/types/JoinableOrgsResponse.ts"() {
    "use strict";
  }
});

// src/resources/org/types/BadRequestCreateOrgError.ts
var init_BadRequestCreateOrgError = __esm({
  "src/resources/org/types/BadRequestCreateOrgError.ts"() {
    "use strict";
  }
});

// src/resources/org/types/BadRequestOrgInvitationError.ts
var init_BadRequestOrgInvitationError = __esm({
  "src/resources/org/types/BadRequestOrgInvitationError.ts"() {
    "use strict";
  }
});

// src/resources/org/types/BadRequestUpdateOrgMetadataError.ts
var init_BadRequestUpdateOrgMetadataError = __esm({
  "src/resources/org/types/BadRequestUpdateOrgMetadataError.ts"() {
    "use strict";
  }
});

// src/resources/org/types/BadRequestJoinOrgError.ts
var init_BadRequestJoinOrgError = __esm({
  "src/resources/org/types/BadRequestJoinOrgError.ts"() {
    "use strict";
  }
});

// src/resources/org/types/index.ts
var init_types7 = __esm({
  "src/resources/org/types/index.ts"() {
    "use strict";
    init_PendingOrgInvitesResponse();
    init_Invitation();
    init_OrgResponse();
    init_CreateOrgOptionsResponse();
    init_OrgMembershipResponse();
    init_PendingInvite();
    init_SelectedOrgStatusUser();
    init_OrgStatusResponse();
    init_OrgInfoResponse();
    init_SelectedOrgStatusResponse();
    init_JoinableOrgsResponse();
    init_BadRequestCreateOrgError();
    init_BadRequestOrgInvitationError();
    init_BadRequestUpdateOrgMetadataError();
    init_BadRequestJoinOrgError();
  }
});

// src/resources/org/errors/BadRequestCreateOrg.ts
var init_BadRequestCreateOrg = __esm({
  "src/resources/org/errors/BadRequestCreateOrg.ts"() {
    "use strict";
  }
});

// src/resources/org/errors/BadRequestJoinOrg.ts
var init_BadRequestJoinOrg = __esm({
  "src/resources/org/errors/BadRequestJoinOrg.ts"() {
    "use strict";
  }
});

// src/resources/org/errors/BadRequestOrgInvitation.ts
var init_BadRequestOrgInvitation = __esm({
  "src/resources/org/errors/BadRequestOrgInvitation.ts"() {
    "use strict";
  }
});

// src/resources/org/errors/BadRequestUpdateOrgMetadata.ts
var init_BadRequestUpdateOrgMetadata = __esm({
  "src/resources/org/errors/BadRequestUpdateOrgMetadata.ts"() {
    "use strict";
  }
});

// src/resources/org/errors/index.ts
var init_errors4 = __esm({
  "src/resources/org/errors/index.ts"() {
    "use strict";
    init_BadRequestCreateOrg();
    init_BadRequestJoinOrg();
    init_BadRequestOrgInvitation();
    init_BadRequestUpdateOrgMetadata();
  }
});

// src/resources/org/client/createOrg.ts
var createOrg_exports = {};
__export(createOrg_exports, {
  Error: () => Error10
});
var Error10;
var init_createOrg = __esm({
  "src/resources/org/client/createOrg.ts"() {
    "use strict";
    init_src();
    init_core();
    Error10 = {
      orgCreationNotEnabled: () => {
        const valueWithoutVisit = {
          statusCode: 404
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.org.createOrg.Error._visit(this, visitor);
        });
      },
      badRequestCreateOrg: (value) => {
        const valueWithoutVisit = {
          content: value,
          statusCode: 400
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.org.createOrg.Error._visit(this, visitor);
        });
      },
      unauthorized: () => {
        const valueWithoutVisit = {
          statusCode: 401
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.org.createOrg.Error._visit(this, visitor);
        });
      },
      _unknown: (fetcherError) => {
        const valueWithoutVisit = fetcherError;
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.org.createOrg.Error._visit(this, visitor);
        });
      },
      _visit: (value, visitor) => {
        switch (value.statusCode) {
          case 404:
            return visitor.orgCreationNotEnabled();
          case 400:
            return visitor.badRequestCreateOrg(value.content);
          case 401:
            return visitor.unauthorized();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/resources/org/client/requests/index.ts
var init_requests3 = __esm({
  "src/resources/org/client/requests/index.ts"() {
    "use strict";
  }
});

// src/resources/org/client/fetchCreateOrgOptions.ts
var fetchCreateOrgOptions_exports = {};
__export(fetchCreateOrgOptions_exports, {
  Error: () => Error11
});
var Error11;
var init_fetchCreateOrgOptions = __esm({
  "src/resources/org/client/fetchCreateOrgOptions.ts"() {
    "use strict";
    init_src();
    init_core();
    Error11 = {
      orgCreationNotEnabled: () => {
        const valueWithoutVisit = {
          statusCode: 404
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.org.fetchCreateOrgOptions.Error._visit(this, visitor);
        });
      },
      unauthorized: () => {
        const valueWithoutVisit = {
          statusCode: 401
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.org.fetchCreateOrgOptions.Error._visit(this, visitor);
        });
      },
      _unknown: (fetcherError) => {
        const valueWithoutVisit = fetcherError;
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.org.fetchCreateOrgOptions.Error._visit(this, visitor);
        });
      },
      _visit: (value, visitor) => {
        switch (value.statusCode) {
          case 404:
            return visitor.orgCreationNotEnabled();
          case 401:
            return visitor.unauthorized();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/resources/org/client/joinOrg.ts
var joinOrg_exports = {};
__export(joinOrg_exports, {
  Error: () => Error12
});
var Error12;
var init_joinOrg = __esm({
  "src/resources/org/client/joinOrg.ts"() {
    "use strict";
    init_src();
    init_core();
    Error12 = {
      orgsNotEnabled: () => {
        const valueWithoutVisit = {
          statusCode: 404
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.org.joinOrg.Error._visit(this, visitor);
        });
      },
      badRequestJoinOrg: (value) => {
        const valueWithoutVisit = {
          content: value,
          statusCode: 400
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.org.joinOrg.Error._visit(this, visitor);
        });
      },
      unauthorized: () => {
        const valueWithoutVisit = {
          statusCode: 401
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.org.joinOrg.Error._visit(this, visitor);
        });
      },
      _unknown: (fetcherError) => {
        const valueWithoutVisit = fetcherError;
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.org.joinOrg.Error._visit(this, visitor);
        });
      },
      _visit: (value, visitor) => {
        switch (value.statusCode) {
          case 404:
            return visitor.orgsNotEnabled();
          case 400:
            return visitor.badRequestJoinOrg(value.content);
          case 401:
            return visitor.unauthorized();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/resources/org/client/joinableOrgs.ts
var joinableOrgs_exports = {};
__export(joinableOrgs_exports, {
  Error: () => Error13
});
var Error13;
var init_joinableOrgs = __esm({
  "src/resources/org/client/joinableOrgs.ts"() {
    "use strict";
    init_src();
    init_core();
    Error13 = {
      orgsNotEnabled: () => {
        const valueWithoutVisit = {
          statusCode: 404
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.org.joinableOrgs.Error._visit(this, visitor);
        });
      },
      unauthorized: () => {
        const valueWithoutVisit = {
          statusCode: 401
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.org.joinableOrgs.Error._visit(this, visitor);
        });
      },
      _unknown: (fetcherError) => {
        const valueWithoutVisit = fetcherError;
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.org.joinableOrgs.Error._visit(this, visitor);
        });
      },
      _visit: (value, visitor) => {
        switch (value.statusCode) {
          case 404:
            return visitor.orgsNotEnabled();
          case 401:
            return visitor.unauthorized();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/resources/org/client/index.ts
var init_client4 = __esm({
  "src/resources/org/client/index.ts"() {
    "use strict";
    init_createOrg();
    init_requests3();
    init_fetchCreateOrgOptions();
    init_joinOrg();
    init_joinableOrgs();
  }
});

// src/resources/org/index.ts
var org_exports = {};
__export(org_exports, {
  createOrg: () => createOrg_exports,
  fetchCreateOrgOptions: () => fetchCreateOrgOptions_exports,
  joinOrg: () => joinOrg_exports,
  joinableOrgs: () => joinableOrgs_exports
});
var init_org = __esm({
  "src/resources/org/index.ts"() {
    "use strict";
    init_types7();
    init_errors4();
    init_client4();
  }
});

// src/resources/user/types/ProfileStatusResponse.ts
var init_ProfileStatusResponse = __esm({
  "src/resources/user/types/ProfileStatusResponse.ts"() {
    "use strict";
  }
});

// src/resources/user/types/UpdateProfileImageResponse.ts
var init_UpdateProfileImageResponse = __esm({
  "src/resources/user/types/UpdateProfileImageResponse.ts"() {
    "use strict";
  }
});

// src/resources/user/types/FetchPasswordOptionsResponse.ts
var init_FetchPasswordOptionsResponse = __esm({
  "src/resources/user/types/FetchPasswordOptionsResponse.ts"() {
    "use strict";
  }
});

// src/resources/user/types/BadRequestUpdateEmailError.ts
var init_BadRequestUpdateEmailError = __esm({
  "src/resources/user/types/BadRequestUpdateEmailError.ts"() {
    "use strict";
  }
});

// src/resources/user/types/BadRequestUpdateMetadataError.ts
var init_BadRequestUpdateMetadataError = __esm({
  "src/resources/user/types/BadRequestUpdateMetadataError.ts"() {
    "use strict";
  }
});

// src/resources/user/types/BadRequestUpdateNameError.ts
var init_BadRequestUpdateNameError = __esm({
  "src/resources/user/types/BadRequestUpdateNameError.ts"() {
    "use strict";
  }
});

// src/resources/user/types/BadRequestUpdatePasswordError.ts
var init_BadRequestUpdatePasswordError = __esm({
  "src/resources/user/types/BadRequestUpdatePasswordError.ts"() {
    "use strict";
  }
});

// src/resources/user/types/BadRequestUpdateProfileImageError.ts
var init_BadRequestUpdateProfileImageError = __esm({
  "src/resources/user/types/BadRequestUpdateProfileImageError.ts"() {
    "use strict";
  }
});

// src/resources/user/types/BadRequestUpdateUsernameError.ts
var init_BadRequestUpdateUsernameError = __esm({
  "src/resources/user/types/BadRequestUpdateUsernameError.ts"() {
    "use strict";
  }
});

// src/resources/user/types/BadRequestSignupError.ts
var init_BadRequestSignupError = __esm({
  "src/resources/user/types/BadRequestSignupError.ts"() {
    "use strict";
  }
});

// src/resources/user/types/index.ts
var init_types8 = __esm({
  "src/resources/user/types/index.ts"() {
    "use strict";
    init_ProfileStatusResponse();
    init_UpdateProfileImageResponse();
    init_FetchPasswordOptionsResponse();
    init_BadRequestUpdateEmailError();
    init_BadRequestUpdateMetadataError();
    init_BadRequestUpdateNameError();
    init_BadRequestUpdatePasswordError();
    init_BadRequestUpdateProfileImageError();
    init_BadRequestUpdateUsernameError();
    init_BadRequestSignupError();
  }
});

// src/resources/user/errors/BadRequestUpdateEmail.ts
var init_BadRequestUpdateEmail = __esm({
  "src/resources/user/errors/BadRequestUpdateEmail.ts"() {
    "use strict";
  }
});

// src/resources/user/errors/BadRequestUpdateMetadata.ts
var init_BadRequestUpdateMetadata = __esm({
  "src/resources/user/errors/BadRequestUpdateMetadata.ts"() {
    "use strict";
  }
});

// src/resources/user/errors/BadRequestUpdateName.ts
var init_BadRequestUpdateName = __esm({
  "src/resources/user/errors/BadRequestUpdateName.ts"() {
    "use strict";
  }
});

// src/resources/user/errors/BadRequestUpdatePassword.ts
var init_BadRequestUpdatePassword = __esm({
  "src/resources/user/errors/BadRequestUpdatePassword.ts"() {
    "use strict";
  }
});

// src/resources/user/errors/BadRequestUpdateProfileImage.ts
var init_BadRequestUpdateProfileImage = __esm({
  "src/resources/user/errors/BadRequestUpdateProfileImage.ts"() {
    "use strict";
  }
});

// src/resources/user/errors/BadRequestUpdateUsername.ts
var init_BadRequestUpdateUsername = __esm({
  "src/resources/user/errors/BadRequestUpdateUsername.ts"() {
    "use strict";
  }
});

// src/resources/user/errors/BadRequestSignup.ts
var init_BadRequestSignup = __esm({
  "src/resources/user/errors/BadRequestSignup.ts"() {
    "use strict";
  }
});

// src/resources/user/errors/index.ts
var init_errors5 = __esm({
  "src/resources/user/errors/index.ts"() {
    "use strict";
    init_BadRequestUpdateEmail();
    init_BadRequestUpdateMetadata();
    init_BadRequestUpdateName();
    init_BadRequestUpdatePassword();
    init_BadRequestUpdateProfileImage();
    init_BadRequestUpdateUsername();
    init_BadRequestSignup();
  }
});

// src/resources/user/client/updateMetadata.ts
var updateMetadata_exports = {};
__export(updateMetadata_exports, {
  Error: () => Error14
});
var Error14;
var init_updateMetadata = __esm({
  "src/resources/user/client/updateMetadata.ts"() {
    "use strict";
    init_src();
    init_core();
    Error14 = {
      unauthorized: () => {
        const valueWithoutVisit = {
          statusCode: 401
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.user.updateMetadata.Error._visit(this, visitor);
        });
      },
      badRequestUpdateMetadata: (value) => {
        const valueWithoutVisit = {
          content: value,
          statusCode: 400
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.user.updateMetadata.Error._visit(this, visitor);
        });
      },
      _unknown: (fetcherError) => {
        const valueWithoutVisit = fetcherError;
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.user.updateMetadata.Error._visit(this, visitor);
        });
      },
      _visit: (value, visitor) => {
        switch (value.statusCode) {
          case 401:
            return visitor.unauthorized();
          case 400:
            return visitor.badRequestUpdateMetadata(value.content);
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/resources/user/client/requests/index.ts
var init_requests4 = __esm({
  "src/resources/user/client/requests/index.ts"() {
    "use strict";
  }
});

// src/resources/user/client/fetchPasswordOptions.ts
var fetchPasswordOptions_exports = {};
__export(fetchPasswordOptions_exports, {
  Error: () => Error15
});
var Error15;
var init_fetchPasswordOptions = __esm({
  "src/resources/user/client/fetchPasswordOptions.ts"() {
    "use strict";
    init_src();
    init_core();
    Error15 = {
      unauthorized: () => {
        const valueWithoutVisit = {
          statusCode: 401
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.user.fetchPasswordOptions.Error._visit(this, visitor);
        });
      },
      _unknown: (fetcherError) => {
        const valueWithoutVisit = fetcherError;
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.user.fetchPasswordOptions.Error._visit(this, visitor);
        });
      },
      _visit: (value, visitor) => {
        switch (value.statusCode) {
          case 401:
            return visitor.unauthorized();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/resources/user/client/updatePassword.ts
var updatePassword_exports = {};
__export(updatePassword_exports, {
  Error: () => Error16
});
var Error16;
var init_updatePassword = __esm({
  "src/resources/user/client/updatePassword.ts"() {
    "use strict";
    init_src();
    init_core();
    Error16 = {
      unauthorized: () => {
        const valueWithoutVisit = {
          statusCode: 401
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.user.updatePassword.Error._visit(this, visitor);
        });
      },
      incorrectPassword: () => {
        const valueWithoutVisit = {
          statusCode: 404
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.user.updatePassword.Error._visit(this, visitor);
        });
      },
      badRequestUpdatePassword: (value) => {
        const valueWithoutVisit = {
          content: value,
          statusCode: 400
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.user.updatePassword.Error._visit(this, visitor);
        });
      },
      _unknown: (fetcherError) => {
        const valueWithoutVisit = fetcherError;
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.user.updatePassword.Error._visit(this, visitor);
        });
      },
      _visit: (value, visitor) => {
        switch (value.statusCode) {
          case 401:
            return visitor.unauthorized();
          case 404:
            return visitor.incorrectPassword();
          case 400:
            return visitor.badRequestUpdatePassword(value.content);
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/resources/user/client/signup.ts
var signup_exports = {};
__export(signup_exports, {
  Error: () => Error17
});
var Error17;
var init_signup = __esm({
  "src/resources/user/client/signup.ts"() {
    "use strict";
    init_src();
    init_core();
    Error17 = {
      badRequestSignup: (value) => {
        const valueWithoutVisit = {
          content: value,
          statusCode: 400
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.user.signup.Error._visit(this, visitor);
        });
      },
      signupNotAllowed: () => {
        const valueWithoutVisit = {
          statusCode: 404
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.user.signup.Error._visit(this, visitor);
        });
      },
      _unknown: (fetcherError) => {
        const valueWithoutVisit = fetcherError;
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.user.signup.Error._visit(this, visitor);
        });
      },
      _visit: (value, visitor) => {
        switch (value.statusCode) {
          case 400:
            return visitor.badRequestSignup(value.content);
          case 404:
            return visitor.signupNotAllowed();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/resources/user/client/resendEmailConfirmation.ts
var resendEmailConfirmation_exports = {};
__export(resendEmailConfirmation_exports, {
  Error: () => Error18
});
var Error18;
var init_resendEmailConfirmation = __esm({
  "src/resources/user/client/resendEmailConfirmation.ts"() {
    "use strict";
    init_src();
    init_core();
    Error18 = {
      tooManyRequests: () => {
        const valueWithoutVisit = {
          statusCode: 429
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.user.resendEmailConfirmation.Error._visit(this, visitor);
        });
      },
      unauthorized: () => {
        const valueWithoutVisit = {
          statusCode: 401
        };
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.user.resendEmailConfirmation.Error._visit(this, visitor);
        });
      },
      _unknown: (fetcherError) => {
        const valueWithoutVisit = fetcherError;
        return addNonEnumerableProperty(valueWithoutVisit, "_visit", function(visitor) {
          return resources_exports.user.resendEmailConfirmation.Error._visit(this, visitor);
        });
      },
      _visit: (value, visitor) => {
        switch (value.statusCode) {
          case 429:
            return visitor.tooManyRequests();
          case 401:
            return visitor.unauthorized();
          default:
            return visitor._other(value);
        }
      }
    };
  }
});

// src/resources/user/client/index.ts
var init_client5 = __esm({
  "src/resources/user/client/index.ts"() {
    "use strict";
    init_updateMetadata();
    init_requests4();
    init_fetchPasswordOptions();
    init_updatePassword();
    init_signup();
    init_resendEmailConfirmation();
  }
});

// src/resources/user/index.ts
var user_exports = {};
__export(user_exports, {
  fetchPasswordOptions: () => fetchPasswordOptions_exports,
  resendEmailConfirmation: () => resendEmailConfirmation_exports,
  signup: () => signup_exports,
  updateMetadata: () => updateMetadata_exports,
  updatePassword: () => updatePassword_exports
});
var init_user = __esm({
  "src/resources/user/index.ts"() {
    "use strict";
    init_types8();
    init_errors5();
    init_client5();
  }
});

// src/resources/index.ts
var resources_exports = {};
__export(resources_exports, {
  LoginStateEnum: () => LoginStateEnum,
  MfaStatusResponse: () => MfaStatusResponse,
  commons: () => commons_exports,
  config: () => config_exports,
  login: () => login_exports2,
  mfa: () => mfa_exports,
  org: () => org_exports,
  user: () => user_exports
});
var init_resources = __esm({
  "src/resources/index.ts"() {
    "use strict";
    init_commons();
    init_types();
    init_config();
    init_types2();
    init_login2();
    init_types5();
    init_mfa();
    init_types6();
    init_org();
    init_types7();
    init_user();
    init_types8();
    init_errors();
    init_errors2();
    init_errors3();
    init_errors4();
    init_errors5();
    init_requests();
    init_requests2();
    init_requests3();
    init_requests4();
  }
});

// .yarn/cache/url-join-npm-4.0.1-e1f4415722-f74e868bf2.zip/node_modules/url-join/lib/url-join.js
var require_url_join = __commonJS({
  ".yarn/cache/url-join-npm-4.0.1-e1f4415722-f74e868bf2.zip/node_modules/url-join/lib/url-join.js"(exports, module2) {
    (function(name, context, definition) {
      if (typeof module2 !== "undefined" && module2.exports)
        module2.exports = definition();
      else if (true)
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      else
        {}
    })("urljoin", exports, function() {
      function normalize(strArray) {
        var resultArray = [];
        if (strArray.length === 0) {
          return "";
        }
        if (typeof strArray[0] !== "string") {
          throw new TypeError("Url must be a string. Received " + strArray[0]);
        }
        if (strArray[0].match(/^[^/:]+:\/*$/) && strArray.length > 1) {
          var first = strArray.shift();
          strArray[0] = first + strArray[0];
        }
        if (strArray[0].match(/^file:\/\/\//)) {
          strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, "$1:///");
        } else {
          strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, "$1://");
        }
        for (var i = 0; i < strArray.length; i++) {
          var component = strArray[i];
          if (typeof component !== "string") {
            throw new TypeError("Url must be a string. Received " + component);
          }
          if (component === "") {
            continue;
          }
          if (i > 0) {
            component = component.replace(/^[\/]+/, "");
          }
          if (i < strArray.length - 1) {
            component = component.replace(/[\/]+$/, "");
          } else {
            component = component.replace(/[\/]+$/, "/");
          }
          resultArray.push(component);
        }
        var str = resultArray.join("/");
        str = str.replace(/\/(\?|&|#[^!])/g, "$1");
        var parts = str.split("?");
        str = parts.shift() + (parts.length > 0 ? "?" : "") + parts.join("&");
        return str;
      }
      return function() {
        var input;
        if (typeof arguments[0] === "object") {
          input = arguments[0];
        } else {
          input = [].slice.call(arguments);
        }
        return normalize(input);
      };
    });
  }
});

// src/serialization/commons/types/OrgId.ts
var OrgId;
var init_OrgId2 = __esm({
  "src/serialization/commons/types/OrgId.ts"() {
    "use strict";
    init_core();
    OrgId = schemas_exports.string();
  }
});

// src/serialization/commons/types/UserId.ts
var UserId;
var init_UserId2 = __esm({
  "src/serialization/commons/types/UserId.ts"() {
    "use strict";
    init_core();
    UserId = schemas_exports.string();
  }
});

// src/serialization/commons/types/LoginStateResponse.ts
var LoginStateResponse;
var init_LoginStateResponse2 = __esm({
  "src/serialization/commons/types/LoginStateResponse.ts"() {
    "use strict";
    init_core();
    LoginStateResponse = schemas_exports.object({
      loginState: schemas_exports.property(
        "login_state",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).LoginStateEnum)
      )
    });
  }
});

// src/serialization/commons/types/LoginStateEnum.ts
var LoginStateEnum2;
var init_LoginStateEnum2 = __esm({
  "src/serialization/commons/types/LoginStateEnum.ts"() {
    "use strict";
    init_core();
    LoginStateEnum2 = schemas_exports.enum_([
      "LoginRequired",
      "TwoFactorRequired",
      "ConfirmEmailRequired",
      "UserMetadataRequired",
      "OrgCreationRequired",
      "UpdatePasswordRequired",
      "Finished"
    ]);
  }
});

// src/serialization/commons/types/EncodedUserIdAndToken.ts
var EncodedUserIdAndToken;
var init_EncodedUserIdAndToken2 = __esm({
  "src/serialization/commons/types/EncodedUserIdAndToken.ts"() {
    "use strict";
    init_core();
    EncodedUserIdAndToken = schemas_exports.string().optional();
  }
});

// src/serialization/commons/types/GenericError.ts
var GenericError;
var init_GenericError2 = __esm({
  "src/serialization/commons/types/GenericError.ts"() {
    "use strict";
    init_core();
    GenericError = schemas_exports.object({
      error: schemas_exports.string().optional()
    });
  }
});

// src/serialization/commons/types/index.ts
var init_types9 = __esm({
  "src/serialization/commons/types/index.ts"() {
    "use strict";
    init_OrgId2();
    init_UserId2();
    init_LoginStateResponse2();
    init_LoginStateEnum2();
    init_EncodedUserIdAndToken2();
    init_GenericError2();
  }
});

// src/serialization/commons/errors/Forbidden.ts
var Forbidden;
var init_Forbidden2 = __esm({
  "src/serialization/commons/errors/Forbidden.ts"() {
    "use strict";
    init_core();
    Forbidden = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).GenericError);
  }
});

// src/serialization/commons/errors/index.ts
var init_errors6 = __esm({
  "src/serialization/commons/errors/index.ts"() {
    "use strict";
    init_Forbidden2();
  }
});

// src/serialization/commons/index.ts
var commons_exports2 = {};
__export(commons_exports2, {
  EncodedUserIdAndToken: () => EncodedUserIdAndToken,
  Forbidden: () => Forbidden,
  GenericError: () => GenericError,
  LoginStateEnum: () => LoginStateEnum2,
  LoginStateResponse: () => LoginStateResponse,
  OrgId: () => OrgId,
  UserId: () => UserId
});
var init_commons2 = __esm({
  "src/serialization/commons/index.ts"() {
    "use strict";
    init_types9();
    init_errors6();
  }
});

// src/serialization/config/types/AuthConfigurationResponse.ts
var AuthConfigurationResponse;
var init_AuthConfigurationResponse2 = __esm({
  "src/serialization/config/types/AuthConfigurationResponse.ts"() {
    "use strict";
    init_core();
    AuthConfigurationResponse = schemas_exports.object({
      logoUrl: schemas_exports.property("logo_url", schemas_exports.string()),
      siteDisplayName: schemas_exports.property("site_display_name", schemas_exports.string()),
      hasGoogleLogin: schemas_exports.property("has_google_login", schemas_exports.boolean()),
      hasGithubLogin: schemas_exports.property("has_github_login", schemas_exports.boolean()),
      hasMicrosoftLogin: schemas_exports.property("has_microsoft_login", schemas_exports.boolean()),
      hasSlackLogin: schemas_exports.property("has_slack_login", schemas_exports.boolean()),
      hasLinkedinLogin: schemas_exports.property("has_linkedin_login", schemas_exports.boolean()),
      hasPasswordlessLogin: schemas_exports.property("has_passwordless_login", schemas_exports.boolean()),
      hasSsoLogin: schemas_exports.property("has_sso_login", schemas_exports.boolean()),
      hasAnyNonPasswordLogin: schemas_exports.property("has_any_non_password_login", schemas_exports.boolean()),
      hasPasswordLogin: schemas_exports.property("has_password_login", schemas_exports.boolean()),
      requireUsersToSetUsername: schemas_exports.property("require_users_to_set_username", schemas_exports.boolean()),
      requireUsersToSetName: schemas_exports.property("require_users_to_set_name", schemas_exports.boolean()),
      allowUsersToSetProfilePicture: schemas_exports.property("allow_users_to_set_profile_picture", schemas_exports.boolean()),
      allowPublicSignups: schemas_exports.property("allow_public_signups", schemas_exports.boolean()),
      showPoweredBy: schemas_exports.property("show_powered_by", schemas_exports.boolean()),
      orgsEnabled: schemas_exports.property("orgs_enabled", schemas_exports.boolean()),
      orgsMetaname: schemas_exports.property("orgs_metaname", schemas_exports.string())
    });
  }
});

// src/serialization/config/types/index.ts
var init_types10 = __esm({
  "src/serialization/config/types/index.ts"() {
    "use strict";
    init_AuthConfigurationResponse2();
  }
});

// src/serialization/config/client/fetchConfig.ts
var fetchConfig_exports2 = {};
__export(fetchConfig_exports2, {
  Response: () => Response
});
var Response;
var init_fetchConfig2 = __esm({
  "src/serialization/config/client/fetchConfig.ts"() {
    "use strict";
    init_core();
    Response = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).AuthConfigurationResponse);
  }
});

// src/serialization/config/client/index.ts
var init_client6 = __esm({
  "src/serialization/config/client/index.ts"() {
    "use strict";
    init_fetchConfig2();
  }
});

// src/serialization/config/index.ts
var config_exports2 = {};
__export(config_exports2, {
  AuthConfigurationResponse: () => AuthConfigurationResponse,
  fetchConfig: () => fetchConfig_exports2
});
var init_config2 = __esm({
  "src/serialization/config/index.ts"() {
    "use strict";
    init_types10();
    init_client6();
  }
});

// src/serialization/login/types/RedirectToUrl.ts
var RedirectToUrl;
var init_RedirectToUrl2 = __esm({
  "src/serialization/login/types/RedirectToUrl.ts"() {
    "use strict";
    init_core();
    RedirectToUrl = schemas_exports.object({
      loginUrl: schemas_exports.property("login_url", schemas_exports.string())
    });
  }
});

// src/serialization/login/types/BadRequestUpdateForgotPasswordType.ts
var BadRequestUpdateForgotPasswordType;
var init_BadRequestUpdateForgotPasswordType2 = __esm({
  "src/serialization/login/types/BadRequestUpdateForgotPasswordType.ts"() {
    "use strict";
    init_core();
    BadRequestUpdateForgotPasswordType = schemas_exports.object({
      newPassword: schemas_exports.property("new_password", schemas_exports.list(schemas_exports.string()).optional())
    });
  }
});

// src/serialization/login/types/BadRequestLoginType.ts
var BadRequestLoginType;
var init_BadRequestLoginType2 = __esm({
  "src/serialization/login/types/BadRequestLoginType.ts"() {
    "use strict";
    init_core();
    BadRequestLoginType = schemas_exports.object({
      email: schemas_exports.list(schemas_exports.string()).optional(),
      password: schemas_exports.list(schemas_exports.string()).optional(),
      error: schemas_exports.list(schemas_exports.string()).optional()
    });
  }
});

// src/serialization/login/types/NoAccountFoundWithCredentialsType.ts
var NoAccountFoundWithCredentialsType;
var init_NoAccountFoundWithCredentialsType2 = __esm({
  "src/serialization/login/types/NoAccountFoundWithCredentialsType.ts"() {
    "use strict";
    init_core();
    NoAccountFoundWithCredentialsType = schemas_exports.object({
      error: schemas_exports.string()
    });
  }
});

// src/serialization/login/types/BadRequestLoginPasswordlessType.ts
var BadRequestLoginPasswordlessType;
var init_BadRequestLoginPasswordlessType2 = __esm({
  "src/serialization/login/types/BadRequestLoginPasswordlessType.ts"() {
    "use strict";
    init_core();
    BadRequestLoginPasswordlessType = schemas_exports.object({
      email: schemas_exports.list(schemas_exports.string()).optional(),
      error: schemas_exports.list(schemas_exports.string()).optional()
    });
  }
});

// src/serialization/login/types/BadRequestForgotPasswordType.ts
var BadRequestForgotPasswordType;
var init_BadRequestForgotPasswordType2 = __esm({
  "src/serialization/login/types/BadRequestForgotPasswordType.ts"() {
    "use strict";
    init_core();
    BadRequestForgotPasswordType = schemas_exports.object({
      email: schemas_exports.list(schemas_exports.string()).optional()
    });
  }
});

// src/serialization/login/types/index.ts
var init_types11 = __esm({
  "src/serialization/login/types/index.ts"() {
    "use strict";
    init_RedirectToUrl2();
    init_BadRequestUpdateForgotPasswordType2();
    init_BadRequestLoginType2();
    init_NoAccountFoundWithCredentialsType2();
    init_BadRequestLoginPasswordlessType2();
    init_BadRequestForgotPasswordType2();
  }
});

// src/serialization/login/errors/BadRequestLogin.ts
var BadRequestLogin;
var init_BadRequestLogin2 = __esm({
  "src/serialization/login/errors/BadRequestLogin.ts"() {
    "use strict";
    init_core();
    BadRequestLogin = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BadRequestLoginType);
  }
});

// src/serialization/login/errors/NoAccountFoundWithCredentials.ts
var NoAccountFoundWithCredentials;
var init_NoAccountFoundWithCredentials2 = __esm({
  "src/serialization/login/errors/NoAccountFoundWithCredentials.ts"() {
    "use strict";
    init_core();
    NoAccountFoundWithCredentials = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).NoAccountFoundWithCredentialsType);
  }
});

// src/serialization/login/errors/BadRequestLoginPasswordless.ts
var BadRequestLoginPasswordless;
var init_BadRequestLoginPasswordless2 = __esm({
  "src/serialization/login/errors/BadRequestLoginPasswordless.ts"() {
    "use strict";
    init_core();
    BadRequestLoginPasswordless = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BadRequestLoginPasswordlessType);
  }
});

// src/serialization/login/errors/BadRequestForgotPassword.ts
var BadRequestForgotPassword;
var init_BadRequestForgotPassword2 = __esm({
  "src/serialization/login/errors/BadRequestForgotPassword.ts"() {
    "use strict";
    init_core();
    BadRequestForgotPassword = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BadRequestForgotPasswordType);
  }
});

// src/serialization/login/errors/BadRequestUpdateForgotPassword.ts
var BadRequestUpdateForgotPassword;
var init_BadRequestUpdateForgotPassword2 = __esm({
  "src/serialization/login/errors/BadRequestUpdateForgotPassword.ts"() {
    "use strict";
    init_core();
    BadRequestUpdateForgotPassword = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BadRequestUpdateForgotPasswordType);
  }
});

// src/serialization/login/errors/index.ts
var init_errors7 = __esm({
  "src/serialization/login/errors/index.ts"() {
    "use strict";
    init_BadRequestLogin2();
    init_NoAccountFoundWithCredentials2();
    init_BadRequestLoginPasswordless2();
    init_BadRequestForgotPassword2();
    init_BadRequestUpdateForgotPassword2();
  }
});

// src/serialization/login/client/login.ts
var login_exports3 = {};
__export(login_exports3, {
  Request: () => Request,
  Response: () => Response2
});
var Request, Response2;
var init_login3 = __esm({
  "src/serialization/login/client/login.ts"() {
    "use strict";
    init_core();
    Request = schemas_exports.object({
      email: schemas_exports.string(),
      password: schemas_exports.string()
    });
    Response2 = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).LoginStateResponse);
  }
});

// src/serialization/login/client/sendMagicLinkLogin.ts
var sendMagicLinkLogin_exports2 = {};
__export(sendMagicLinkLogin_exports2, {
  Request: () => Request2
});
var Request2;
var init_sendMagicLinkLogin2 = __esm({
  "src/serialization/login/client/sendMagicLinkLogin.ts"() {
    "use strict";
    init_core();
    Request2 = schemas_exports.object({
      email: schemas_exports.string(),
      createIfDoesntExist: schemas_exports.property("create_if_doesnt_exist", schemas_exports.boolean())
    });
  }
});

// src/serialization/login/client/forgotPassword.ts
var forgotPassword_exports2 = {};
__export(forgotPassword_exports2, {
  Request: () => Request3
});
var Request3;
var init_forgotPassword2 = __esm({
  "src/serialization/login/client/forgotPassword.ts"() {
    "use strict";
    init_core();
    Request3 = schemas_exports.object({
      email: schemas_exports.string()
    });
  }
});

// src/serialization/login/client/fetchLoginState.ts
var fetchLoginState_exports2 = {};
__export(fetchLoginState_exports2, {
  Response: () => Response3
});
var Response3;
var init_fetchLoginState2 = __esm({
  "src/serialization/login/client/fetchLoginState.ts"() {
    "use strict";
    init_core();
    Response3 = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).LoginStateResponse);
  }
});

// src/serialization/login/client/checkOrgNameForSamlLogin.ts
var checkOrgNameForSamlLogin_exports2 = {};
__export(checkOrgNameForSamlLogin_exports2, {
  Request: () => Request4,
  Response: () => Response4
});
var Request4, Response4;
var init_checkOrgNameForSamlLogin2 = __esm({
  "src/serialization/login/client/checkOrgNameForSamlLogin.ts"() {
    "use strict";
    init_core();
    Request4 = schemas_exports.object({
      name: schemas_exports.string()
    });
    Response4 = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).RedirectToUrl);
  }
});

// src/serialization/login/client/index.ts
var init_client7 = __esm({
  "src/serialization/login/client/index.ts"() {
    "use strict";
    init_login3();
    init_sendMagicLinkLogin2();
    init_forgotPassword2();
    init_fetchLoginState2();
    init_checkOrgNameForSamlLogin2();
  }
});

// src/serialization/login/index.ts
var login_exports4 = {};
__export(login_exports4, {
  BadRequestForgotPassword: () => BadRequestForgotPassword,
  BadRequestForgotPasswordType: () => BadRequestForgotPasswordType,
  BadRequestLogin: () => BadRequestLogin,
  BadRequestLoginPasswordless: () => BadRequestLoginPasswordless,
  BadRequestLoginPasswordlessType: () => BadRequestLoginPasswordlessType,
  BadRequestLoginType: () => BadRequestLoginType,
  BadRequestUpdateForgotPassword: () => BadRequestUpdateForgotPassword,
  BadRequestUpdateForgotPasswordType: () => BadRequestUpdateForgotPasswordType,
  NoAccountFoundWithCredentials: () => NoAccountFoundWithCredentials,
  NoAccountFoundWithCredentialsType: () => NoAccountFoundWithCredentialsType,
  RedirectToUrl: () => RedirectToUrl,
  checkOrgNameForSamlLogin: () => checkOrgNameForSamlLogin_exports2,
  fetchLoginState: () => fetchLoginState_exports2,
  forgotPassword: () => forgotPassword_exports2,
  login: () => login_exports3,
  sendMagicLinkLogin: () => sendMagicLinkLogin_exports2
});
var init_login4 = __esm({
  "src/serialization/login/index.ts"() {
    "use strict";
    init_types11();
    init_errors7();
    init_client7();
  }
});

// src/serialization/mfa/types/MfaStatusResponse.ts
var MfaStatusResponse2;
var init_MfaStatusResponse2 = __esm({
  "src/serialization/mfa/types/MfaStatusResponse.ts"() {
    "use strict";
    init_src();
    init_core();
    MfaStatusResponse2 = schemas_exports.union("type", {
      Enabled: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).MfaEnabledResponse),
      Disabled: schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).MfaDisabledResponse)
    }).transform({
      parse: (value) => {
        switch (value.type) {
          case "Enabled":
            return resources_exports.MfaStatusResponse.enabled(value);
          case "Disabled":
            return resources_exports.MfaStatusResponse.disabled(value);
          default:
            return resources_exports.MfaStatusResponse._unknown(value);
        }
      },
      json: (value) => value
    });
  }
});

// src/serialization/mfa/types/MfaEnabledResponse.ts
var MfaEnabledResponse;
var init_MfaEnabledResponse2 = __esm({
  "src/serialization/mfa/types/MfaEnabledResponse.ts"() {
    "use strict";
    init_core();
    MfaEnabledResponse = schemas_exports.object({
      mfaEnabled: schemas_exports.property("mfa_enabled", schemas_exports.boolean()),
      backupCodes: schemas_exports.property("backup_codes", schemas_exports.list(schemas_exports.string())),
      hasPassword: schemas_exports.property("has_password", schemas_exports.boolean())
    });
  }
});

// src/serialization/mfa/types/MfaDisabledResponse.ts
var MfaDisabledResponse;
var init_MfaDisabledResponse2 = __esm({
  "src/serialization/mfa/types/MfaDisabledResponse.ts"() {
    "use strict";
    init_core();
    MfaDisabledResponse = schemas_exports.object({
      mfaEnabled: schemas_exports.property("mfa_enabled", schemas_exports.boolean()),
      newSecret: schemas_exports.property("new_secret", schemas_exports.string()),
      newQr: schemas_exports.property("new_qr", schemas_exports.string()),
      hasPassword: schemas_exports.property("has_password", schemas_exports.boolean())
    });
  }
});

// src/serialization/mfa/types/BadRequestMfaVerifyError.ts
var BadRequestMfaVerifyError;
var init_BadRequestMfaVerifyError2 = __esm({
  "src/serialization/mfa/types/BadRequestMfaVerifyError.ts"() {
    "use strict";
    init_core();
    BadRequestMfaVerifyError = schemas_exports.object({
      code: schemas_exports.list(schemas_exports.string()).optional()
    });
  }
});

// src/serialization/mfa/types/BadRequestMfaEnableError.ts
var BadRequestMfaEnableError;
var init_BadRequestMfaEnableError2 = __esm({
  "src/serialization/mfa/types/BadRequestMfaEnableError.ts"() {
    "use strict";
    init_core();
    BadRequestMfaEnableError = schemas_exports.object({
      code: schemas_exports.list(schemas_exports.string()).optional()
    });
  }
});

// src/serialization/mfa/types/index.ts
var init_types12 = __esm({
  "src/serialization/mfa/types/index.ts"() {
    "use strict";
    init_MfaStatusResponse2();
    init_MfaEnabledResponse2();
    init_MfaDisabledResponse2();
    init_BadRequestMfaVerifyError2();
    init_BadRequestMfaEnableError2();
  }
});

// src/serialization/mfa/errors/BadRequestMfaVerify.ts
var BadRequestMfaVerify;
var init_BadRequestMfaVerify2 = __esm({
  "src/serialization/mfa/errors/BadRequestMfaVerify.ts"() {
    "use strict";
    init_core();
    BadRequestMfaVerify = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BadRequestMfaVerifyError);
  }
});

// src/serialization/mfa/errors/IncorrectMfaCode.ts
var IncorrectMfaCode;
var init_IncorrectMfaCode2 = __esm({
  "src/serialization/mfa/errors/IncorrectMfaCode.ts"() {
    "use strict";
    init_core();
    IncorrectMfaCode = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).GenericError);
  }
});

// src/serialization/mfa/errors/BadRequestMfaEnable.ts
var BadRequestMfaEnable;
var init_BadRequestMfaEnable2 = __esm({
  "src/serialization/mfa/errors/BadRequestMfaEnable.ts"() {
    "use strict";
    init_core();
    BadRequestMfaEnable = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BadRequestMfaEnableError);
  }
});

// src/serialization/mfa/errors/ForbiddenMfaEnable.ts
var ForbiddenMfaEnable;
var init_ForbiddenMfaEnable2 = __esm({
  "src/serialization/mfa/errors/ForbiddenMfaEnable.ts"() {
    "use strict";
    init_core();
    ForbiddenMfaEnable = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).GenericError);
  }
});

// src/serialization/mfa/errors/index.ts
var init_errors8 = __esm({
  "src/serialization/mfa/errors/index.ts"() {
    "use strict";
    init_BadRequestMfaVerify2();
    init_IncorrectMfaCode2();
    init_BadRequestMfaEnable2();
    init_ForbiddenMfaEnable2();
  }
});

// src/serialization/mfa/client/mfaVerify.ts
var mfaVerify_exports2 = {};
__export(mfaVerify_exports2, {
  Request: () => Request5,
  Response: () => Response5
});
var Request5, Response5;
var init_mfaVerify2 = __esm({
  "src/serialization/mfa/client/mfaVerify.ts"() {
    "use strict";
    init_core();
    Request5 = schemas_exports.object({
      code: schemas_exports.string()
    });
    Response5 = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).LoginStateResponse);
  }
});

// src/serialization/mfa/client/mfaVerifyBackup.ts
var mfaVerifyBackup_exports2 = {};
__export(mfaVerifyBackup_exports2, {
  Request: () => Request6,
  Response: () => Response6
});
var Request6, Response6;
var init_mfaVerifyBackup2 = __esm({
  "src/serialization/mfa/client/mfaVerifyBackup.ts"() {
    "use strict";
    init_core();
    Request6 = schemas_exports.object({
      code: schemas_exports.string()
    });
    Response6 = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).LoginStateResponse);
  }
});

// src/serialization/mfa/client/index.ts
var init_client8 = __esm({
  "src/serialization/mfa/client/index.ts"() {
    "use strict";
    init_mfaVerify2();
    init_mfaVerifyBackup2();
  }
});

// src/serialization/mfa/index.ts
var mfa_exports2 = {};
__export(mfa_exports2, {
  BadRequestMfaEnable: () => BadRequestMfaEnable,
  BadRequestMfaEnableError: () => BadRequestMfaEnableError,
  BadRequestMfaVerify: () => BadRequestMfaVerify,
  BadRequestMfaVerifyError: () => BadRequestMfaVerifyError,
  ForbiddenMfaEnable: () => ForbiddenMfaEnable,
  IncorrectMfaCode: () => IncorrectMfaCode,
  MfaDisabledResponse: () => MfaDisabledResponse,
  MfaEnabledResponse: () => MfaEnabledResponse,
  MfaStatusResponse: () => MfaStatusResponse2,
  mfaVerify: () => mfaVerify_exports2,
  mfaVerifyBackup: () => mfaVerifyBackup_exports2
});
var init_mfa2 = __esm({
  "src/serialization/mfa/index.ts"() {
    "use strict";
    init_types12();
    init_errors8();
    init_client8();
  }
});

// src/serialization/org/types/PendingOrgInvitesResponse.ts
var PendingOrgInvitesResponse;
var init_PendingOrgInvitesResponse2 = __esm({
  "src/serialization/org/types/PendingOrgInvitesResponse.ts"() {
    "use strict";
    init_core();
    PendingOrgInvitesResponse = schemas_exports.object({
      pendingInvites: schemas_exports.property(
        "pending_invites",
        schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).Invitation))
      )
    });
  }
});

// src/serialization/org/types/Invitation.ts
var Invitation;
var init_Invitation2 = __esm({
  "src/serialization/org/types/Invitation.ts"() {
    "use strict";
    init_core();
    Invitation = schemas_exports.object({
      orgId: schemas_exports.property(
        "org_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).OrgId)
      ),
      orgName: schemas_exports.property("org_name", schemas_exports.string())
    });
  }
});

// src/serialization/org/types/OrgResponse.ts
var OrgResponse;
var init_OrgResponse2 = __esm({
  "src/serialization/org/types/OrgResponse.ts"() {
    "use strict";
    init_core();
    OrgResponse = schemas_exports.object({
      orgId: schemas_exports.property(
        "org_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).OrgId)
      ),
      firstOrg: schemas_exports.property("first_org", schemas_exports.boolean())
    });
  }
});

// src/serialization/org/types/CreateOrgOptionsResponse.ts
var CreateOrgOptionsResponse;
var init_CreateOrgOptionsResponse2 = __esm({
  "src/serialization/org/types/CreateOrgOptionsResponse.ts"() {
    "use strict";
    init_core();
    CreateOrgOptionsResponse = schemas_exports.object({
      canUseDomainOptions: schemas_exports.property("can_use_domain_options", schemas_exports.boolean()),
      currentUserDomain: schemas_exports.property("current_user_domain", schemas_exports.string())
    });
  }
});

// src/serialization/org/types/OrgMembershipResponse.ts
var OrgMembershipResponse;
var init_OrgMembershipResponse2 = __esm({
  "src/serialization/org/types/OrgMembershipResponse.ts"() {
    "use strict";
    init_core();
    OrgMembershipResponse = schemas_exports.object({
      inviteePossibleRoles: schemas_exports.property("invitee_possible_roles", schemas_exports.list(schemas_exports.string())),
      pendingInvites: schemas_exports.property(
        "pending_invites",
        schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).PendingInvite))
      ),
      expiredInvites: schemas_exports.property(
        "expired_invites",
        schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).PendingInvite))
      ),
      users: schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).SelectedOrgStatusUser))
    });
  }
});

// src/serialization/org/types/PendingInvite.ts
var PendingInvite;
var init_PendingInvite2 = __esm({
  "src/serialization/org/types/PendingInvite.ts"() {
    "use strict";
    init_core();
    PendingInvite = schemas_exports.object({
      email: schemas_exports.string(),
      role: schemas_exports.string(),
      expiresAtSeconds: schemas_exports.property("expires_at_seconds", schemas_exports.number())
    });
  }
});

// src/serialization/org/types/SelectedOrgStatusUser.ts
var SelectedOrgStatusUser;
var init_SelectedOrgStatusUser2 = __esm({
  "src/serialization/org/types/SelectedOrgStatusUser.ts"() {
    "use strict";
    init_core();
    SelectedOrgStatusUser = schemas_exports.object({
      userId: schemas_exports.property(
        "user_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).UserId)
      ),
      email: schemas_exports.string(),
      role: schemas_exports.string(),
      possibleRoles: schemas_exports.property("possible_roles", schemas_exports.list(schemas_exports.string())),
      canBeDeleted: schemas_exports.property("can_be_deleted", schemas_exports.boolean())
    });
  }
});

// src/serialization/org/types/OrgStatusResponse.ts
var OrgStatusResponse;
var init_OrgStatusResponse2 = __esm({
  "src/serialization/org/types/OrgStatusResponse.ts"() {
    "use strict";
    init_core();
    OrgStatusResponse = schemas_exports.object({
      selectedOrg: schemas_exports.property(
        "selected_org",
        schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).OrgInfoResponse).optional()
      ),
      allOrgs: schemas_exports.property(
        "all_orgs",
        schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).OrgInfoResponse))
      ),
      usersCanCreateOrgs: schemas_exports.property("users_can_create_orgs", schemas_exports.boolean())
    });
  }
});

// src/serialization/org/types/OrgInfoResponse.ts
var OrgInfoResponse;
var init_OrgInfoResponse2 = __esm({
  "src/serialization/org/types/OrgInfoResponse.ts"() {
    "use strict";
    init_core();
    OrgInfoResponse = schemas_exports.object({
      id: schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).OrgId),
      name: schemas_exports.string()
    });
  }
});

// src/serialization/org/types/SelectedOrgStatusResponse.ts
var SelectedOrgStatusResponse;
var init_SelectedOrgStatusResponse2 = __esm({
  "src/serialization/org/types/SelectedOrgStatusResponse.ts"() {
    "use strict";
    init_core();
    SelectedOrgStatusResponse = schemas_exports.object({
      inviteePossibleRoles: schemas_exports.property("invitee_possible_roles", schemas_exports.list(schemas_exports.string())),
      pendingInvites: schemas_exports.property(
        "pending_invites",
        schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).PendingInvite))
      ),
      users: schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).SelectedOrgStatusUser)),
      canSetupSaml: schemas_exports.property("can_setup_saml", schemas_exports.boolean()),
      isSamlEnabled: schemas_exports.property("is_saml_enabled", schemas_exports.boolean()),
      isSamlInTestMode: schemas_exports.property("is_saml_in_test_mode", schemas_exports.boolean())
    });
  }
});

// src/serialization/org/types/JoinableOrgsResponse.ts
var JoinableOrgsResponse;
var init_JoinableOrgsResponse2 = __esm({
  "src/serialization/org/types/JoinableOrgsResponse.ts"() {
    "use strict";
    init_core();
    JoinableOrgsResponse = schemas_exports.object({
      orgs: schemas_exports.list(schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).OrgInfoResponse))
    });
  }
});

// src/serialization/org/types/BadRequestCreateOrgError.ts
var BadRequestCreateOrgError;
var init_BadRequestCreateOrgError2 = __esm({
  "src/serialization/org/types/BadRequestCreateOrgError.ts"() {
    "use strict";
    init_core();
    BadRequestCreateOrgError = schemas_exports.object({
      name: schemas_exports.list(schemas_exports.string()).optional(),
      error: schemas_exports.list(schemas_exports.string()).optional()
    });
  }
});

// src/serialization/org/types/BadRequestOrgInvitationError.ts
var BadRequestOrgInvitationError;
var init_BadRequestOrgInvitationError2 = __esm({
  "src/serialization/org/types/BadRequestOrgInvitationError.ts"() {
    "use strict";
    init_core();
    BadRequestOrgInvitationError = schemas_exports.object({
      orgId: schemas_exports.property("org_id", schemas_exports.list(schemas_exports.string()).optional()),
      accept: schemas_exports.list(schemas_exports.string()).optional()
    });
  }
});

// src/serialization/org/types/BadRequestUpdateOrgMetadataError.ts
var BadRequestUpdateOrgMetadataError;
var init_BadRequestUpdateOrgMetadataError2 = __esm({
  "src/serialization/org/types/BadRequestUpdateOrgMetadataError.ts"() {
    "use strict";
    init_core();
    BadRequestUpdateOrgMetadataError = schemas_exports.object({
      name: schemas_exports.list(schemas_exports.string()).optional()
    });
  }
});

// src/serialization/org/types/BadRequestJoinOrgError.ts
var BadRequestJoinOrgError;
var init_BadRequestJoinOrgError2 = __esm({
  "src/serialization/org/types/BadRequestJoinOrgError.ts"() {
    "use strict";
    init_core();
    BadRequestJoinOrgError = schemas_exports.object({
      error: schemas_exports.list(schemas_exports.string()).optional()
    });
  }
});

// src/serialization/org/types/index.ts
var init_types13 = __esm({
  "src/serialization/org/types/index.ts"() {
    "use strict";
    init_PendingOrgInvitesResponse2();
    init_Invitation2();
    init_OrgResponse2();
    init_CreateOrgOptionsResponse2();
    init_OrgMembershipResponse2();
    init_PendingInvite2();
    init_SelectedOrgStatusUser2();
    init_OrgStatusResponse2();
    init_OrgInfoResponse2();
    init_SelectedOrgStatusResponse2();
    init_JoinableOrgsResponse2();
    init_BadRequestCreateOrgError2();
    init_BadRequestOrgInvitationError2();
    init_BadRequestUpdateOrgMetadataError2();
    init_BadRequestJoinOrgError2();
  }
});

// src/serialization/org/errors/BadRequestCreateOrg.ts
var BadRequestCreateOrg;
var init_BadRequestCreateOrg2 = __esm({
  "src/serialization/org/errors/BadRequestCreateOrg.ts"() {
    "use strict";
    init_core();
    BadRequestCreateOrg = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BadRequestCreateOrgError);
  }
});

// src/serialization/org/errors/BadRequestJoinOrg.ts
var BadRequestJoinOrg;
var init_BadRequestJoinOrg2 = __esm({
  "src/serialization/org/errors/BadRequestJoinOrg.ts"() {
    "use strict";
    init_core();
    BadRequestJoinOrg = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BadRequestJoinOrgError);
  }
});

// src/serialization/org/errors/BadRequestOrgInvitation.ts
var BadRequestOrgInvitation;
var init_BadRequestOrgInvitation2 = __esm({
  "src/serialization/org/errors/BadRequestOrgInvitation.ts"() {
    "use strict";
    init_core();
    BadRequestOrgInvitation = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BadRequestOrgInvitationError);
  }
});

// src/serialization/org/errors/BadRequestUpdateOrgMetadata.ts
var BadRequestUpdateOrgMetadata;
var init_BadRequestUpdateOrgMetadata2 = __esm({
  "src/serialization/org/errors/BadRequestUpdateOrgMetadata.ts"() {
    "use strict";
    init_core();
    BadRequestUpdateOrgMetadata = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BadRequestUpdateOrgMetadataError);
  }
});

// src/serialization/org/errors/index.ts
var init_errors9 = __esm({
  "src/serialization/org/errors/index.ts"() {
    "use strict";
    init_BadRequestCreateOrg2();
    init_BadRequestJoinOrg2();
    init_BadRequestOrgInvitation2();
    init_BadRequestUpdateOrgMetadata2();
  }
});

// src/serialization/org/client/createOrg.ts
var createOrg_exports2 = {};
__export(createOrg_exports2, {
  Request: () => Request7,
  Response: () => Response7
});
var Request7, Response7;
var init_createOrg2 = __esm({
  "src/serialization/org/client/createOrg.ts"() {
    "use strict";
    init_core();
    Request7 = schemas_exports.object({
      name: schemas_exports.string(),
      autojoinByDomain: schemas_exports.property("autojoin_by_domain", schemas_exports.boolean()),
      restrictToDomain: schemas_exports.property("restrict_to_domain", schemas_exports.boolean())
    });
    Response7 = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).OrgResponse);
  }
});

// src/serialization/org/client/fetchCreateOrgOptions.ts
var fetchCreateOrgOptions_exports2 = {};
__export(fetchCreateOrgOptions_exports2, {
  Response: () => Response8
});
var Response8;
var init_fetchCreateOrgOptions2 = __esm({
  "src/serialization/org/client/fetchCreateOrgOptions.ts"() {
    "use strict";
    init_core();
    Response8 = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).CreateOrgOptionsResponse);
  }
});

// src/serialization/org/client/joinOrg.ts
var joinOrg_exports2 = {};
__export(joinOrg_exports2, {
  Request: () => Request8,
  Response: () => Response9
});
var Request8, Response9;
var init_joinOrg2 = __esm({
  "src/serialization/org/client/joinOrg.ts"() {
    "use strict";
    init_core();
    Request8 = schemas_exports.object({
      orgId: schemas_exports.property(
        "org_id",
        schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).OrgId)
      )
    });
    Response9 = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).OrgResponse);
  }
});

// src/serialization/org/client/joinableOrgs.ts
var joinableOrgs_exports2 = {};
__export(joinableOrgs_exports2, {
  Response: () => Response10
});
var Response10;
var init_joinableOrgs2 = __esm({
  "src/serialization/org/client/joinableOrgs.ts"() {
    "use strict";
    init_core();
    Response10 = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).JoinableOrgsResponse);
  }
});

// src/serialization/org/client/index.ts
var init_client9 = __esm({
  "src/serialization/org/client/index.ts"() {
    "use strict";
    init_createOrg2();
    init_fetchCreateOrgOptions2();
    init_joinOrg2();
    init_joinableOrgs2();
  }
});

// src/serialization/org/index.ts
var org_exports2 = {};
__export(org_exports2, {
  BadRequestCreateOrg: () => BadRequestCreateOrg,
  BadRequestCreateOrgError: () => BadRequestCreateOrgError,
  BadRequestJoinOrg: () => BadRequestJoinOrg,
  BadRequestJoinOrgError: () => BadRequestJoinOrgError,
  BadRequestOrgInvitation: () => BadRequestOrgInvitation,
  BadRequestOrgInvitationError: () => BadRequestOrgInvitationError,
  BadRequestUpdateOrgMetadata: () => BadRequestUpdateOrgMetadata,
  BadRequestUpdateOrgMetadataError: () => BadRequestUpdateOrgMetadataError,
  CreateOrgOptionsResponse: () => CreateOrgOptionsResponse,
  Invitation: () => Invitation,
  JoinableOrgsResponse: () => JoinableOrgsResponse,
  OrgInfoResponse: () => OrgInfoResponse,
  OrgMembershipResponse: () => OrgMembershipResponse,
  OrgResponse: () => OrgResponse,
  OrgStatusResponse: () => OrgStatusResponse,
  PendingInvite: () => PendingInvite,
  PendingOrgInvitesResponse: () => PendingOrgInvitesResponse,
  SelectedOrgStatusResponse: () => SelectedOrgStatusResponse,
  SelectedOrgStatusUser: () => SelectedOrgStatusUser,
  createOrg: () => createOrg_exports2,
  fetchCreateOrgOptions: () => fetchCreateOrgOptions_exports2,
  joinOrg: () => joinOrg_exports2,
  joinableOrgs: () => joinableOrgs_exports2
});
var init_org2 = __esm({
  "src/serialization/org/index.ts"() {
    "use strict";
    init_types13();
    init_errors9();
    init_client9();
  }
});

// src/serialization/user/types/ProfileStatusResponse.ts
var ProfileStatusResponse;
var init_ProfileStatusResponse2 = __esm({
  "src/serialization/user/types/ProfileStatusResponse.ts"() {
    "use strict";
    init_core();
    ProfileStatusResponse = schemas_exports.object({
      email: schemas_exports.string(),
      hasUsername: schemas_exports.property("has_username", schemas_exports.boolean()),
      username: schemas_exports.string().optional(),
      hasName: schemas_exports.property("has_name", schemas_exports.boolean()),
      firstName: schemas_exports.property("first_name", schemas_exports.string().optional()),
      lastName: schemas_exports.property("last_name", schemas_exports.string().optional()),
      hasPictureUrl: schemas_exports.property("has_picture_url", schemas_exports.boolean()),
      pictureUrl: schemas_exports.property("picture_url", schemas_exports.string().optional())
    });
  }
});

// src/serialization/user/types/UpdateProfileImageResponse.ts
var UpdateProfileImageResponse;
var init_UpdateProfileImageResponse2 = __esm({
  "src/serialization/user/types/UpdateProfileImageResponse.ts"() {
    "use strict";
    init_core();
    UpdateProfileImageResponse = schemas_exports.object({
      pictureUrl: schemas_exports.property("picture_url", schemas_exports.string())
    });
  }
});

// src/serialization/user/types/FetchPasswordOptionsResponse.ts
var FetchPasswordOptionsResponse;
var init_FetchPasswordOptionsResponse2 = __esm({
  "src/serialization/user/types/FetchPasswordOptionsResponse.ts"() {
    "use strict";
    init_core();
    FetchPasswordOptionsResponse = schemas_exports.object({
      hasPassword: schemas_exports.property("has_password", schemas_exports.boolean())
    });
  }
});

// src/serialization/user/types/BadRequestUpdateEmailError.ts
var BadRequestUpdateEmailError;
var init_BadRequestUpdateEmailError2 = __esm({
  "src/serialization/user/types/BadRequestUpdateEmailError.ts"() {
    "use strict";
    init_core();
    BadRequestUpdateEmailError = schemas_exports.object({
      newEmail: schemas_exports.property("new_email", schemas_exports.list(schemas_exports.string()).optional())
    });
  }
});

// src/serialization/user/types/BadRequestUpdateMetadataError.ts
var BadRequestUpdateMetadataError;
var init_BadRequestUpdateMetadataError2 = __esm({
  "src/serialization/user/types/BadRequestUpdateMetadataError.ts"() {
    "use strict";
    init_core();
    BadRequestUpdateMetadataError = schemas_exports.object({
      username: schemas_exports.list(schemas_exports.string()).optional(),
      firstName: schemas_exports.property("first_name", schemas_exports.list(schemas_exports.string()).optional()),
      lastName: schemas_exports.property("last_name", schemas_exports.list(schemas_exports.string()).optional())
    });
  }
});

// src/serialization/user/types/BadRequestUpdateNameError.ts
var BadRequestUpdateNameError;
var init_BadRequestUpdateNameError2 = __esm({
  "src/serialization/user/types/BadRequestUpdateNameError.ts"() {
    "use strict";
    init_core();
    BadRequestUpdateNameError = schemas_exports.object({
      firstName: schemas_exports.property("first_name", schemas_exports.list(schemas_exports.string()).optional()),
      lastName: schemas_exports.property("last_name", schemas_exports.list(schemas_exports.string()).optional())
    });
  }
});

// src/serialization/user/types/BadRequestUpdatePasswordError.ts
var BadRequestUpdatePasswordError;
var init_BadRequestUpdatePasswordError2 = __esm({
  "src/serialization/user/types/BadRequestUpdatePasswordError.ts"() {
    "use strict";
    init_core();
    BadRequestUpdatePasswordError = schemas_exports.object({
      currentPassword: schemas_exports.property("current_password", schemas_exports.list(schemas_exports.string()).optional()),
      password: schemas_exports.list(schemas_exports.string()).optional()
    });
  }
});

// src/serialization/user/types/BadRequestUpdateProfileImageError.ts
var BadRequestUpdateProfileImageError;
var init_BadRequestUpdateProfileImageError2 = __esm({
  "src/serialization/user/types/BadRequestUpdateProfileImageError.ts"() {
    "use strict";
    init_core();
    BadRequestUpdateProfileImageError = schemas_exports.object({
      pictureUrl: schemas_exports.property("picture_url", schemas_exports.list(schemas_exports.string()).optional())
    });
  }
});

// src/serialization/user/types/BadRequestUpdateUsernameError.ts
var BadRequestUpdateUsernameError;
var init_BadRequestUpdateUsernameError2 = __esm({
  "src/serialization/user/types/BadRequestUpdateUsernameError.ts"() {
    "use strict";
    init_core();
    BadRequestUpdateUsernameError = schemas_exports.object({
      username: schemas_exports.list(schemas_exports.string()).optional()
    });
  }
});

// src/serialization/user/types/BadRequestSignupError.ts
var BadRequestSignupError;
var init_BadRequestSignupError2 = __esm({
  "src/serialization/user/types/BadRequestSignupError.ts"() {
    "use strict";
    init_core();
    BadRequestSignupError = schemas_exports.object({
      email: schemas_exports.list(schemas_exports.string()).optional(),
      password: schemas_exports.list(schemas_exports.string()).optional(),
      username: schemas_exports.list(schemas_exports.string()).optional(),
      firstName: schemas_exports.property("first_name", schemas_exports.list(schemas_exports.string()).optional()),
      lastName: schemas_exports.property("last_name", schemas_exports.list(schemas_exports.string()).optional())
    });
  }
});

// src/serialization/user/types/index.ts
var init_types14 = __esm({
  "src/serialization/user/types/index.ts"() {
    "use strict";
    init_ProfileStatusResponse2();
    init_UpdateProfileImageResponse2();
    init_FetchPasswordOptionsResponse2();
    init_BadRequestUpdateEmailError2();
    init_BadRequestUpdateMetadataError2();
    init_BadRequestUpdateNameError2();
    init_BadRequestUpdatePasswordError2();
    init_BadRequestUpdateProfileImageError2();
    init_BadRequestUpdateUsernameError2();
    init_BadRequestSignupError2();
  }
});

// src/serialization/user/errors/BadRequestUpdateEmail.ts
var BadRequestUpdateEmail;
var init_BadRequestUpdateEmail2 = __esm({
  "src/serialization/user/errors/BadRequestUpdateEmail.ts"() {
    "use strict";
    init_core();
    BadRequestUpdateEmail = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BadRequestUpdateEmailError);
  }
});

// src/serialization/user/errors/BadRequestUpdateMetadata.ts
var BadRequestUpdateMetadata;
var init_BadRequestUpdateMetadata2 = __esm({
  "src/serialization/user/errors/BadRequestUpdateMetadata.ts"() {
    "use strict";
    init_core();
    BadRequestUpdateMetadata = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BadRequestUpdateMetadataError);
  }
});

// src/serialization/user/errors/BadRequestUpdateName.ts
var BadRequestUpdateName;
var init_BadRequestUpdateName2 = __esm({
  "src/serialization/user/errors/BadRequestUpdateName.ts"() {
    "use strict";
    init_core();
    BadRequestUpdateName = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BadRequestUpdateNameError);
  }
});

// src/serialization/user/errors/BadRequestUpdatePassword.ts
var BadRequestUpdatePassword;
var init_BadRequestUpdatePassword2 = __esm({
  "src/serialization/user/errors/BadRequestUpdatePassword.ts"() {
    "use strict";
    init_core();
    BadRequestUpdatePassword = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BadRequestUpdatePasswordError);
  }
});

// src/serialization/user/errors/BadRequestUpdateProfileImage.ts
var BadRequestUpdateProfileImage;
var init_BadRequestUpdateProfileImage2 = __esm({
  "src/serialization/user/errors/BadRequestUpdateProfileImage.ts"() {
    "use strict";
    init_core();
    BadRequestUpdateProfileImage = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BadRequestUpdateProfileImageError);
  }
});

// src/serialization/user/errors/BadRequestUpdateUsername.ts
var BadRequestUpdateUsername;
var init_BadRequestUpdateUsername2 = __esm({
  "src/serialization/user/errors/BadRequestUpdateUsername.ts"() {
    "use strict";
    init_core();
    BadRequestUpdateUsername = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BadRequestUpdateUsernameError);
  }
});

// src/serialization/user/errors/BadRequestSignup.ts
var BadRequestSignup;
var init_BadRequestSignup2 = __esm({
  "src/serialization/user/errors/BadRequestSignup.ts"() {
    "use strict";
    init_core();
    BadRequestSignup = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).BadRequestSignupError);
  }
});

// src/serialization/user/errors/index.ts
var init_errors10 = __esm({
  "src/serialization/user/errors/index.ts"() {
    "use strict";
    init_BadRequestUpdateEmail2();
    init_BadRequestUpdateMetadata2();
    init_BadRequestUpdateName2();
    init_BadRequestUpdatePassword2();
    init_BadRequestUpdateProfileImage2();
    init_BadRequestUpdateUsername2();
    init_BadRequestSignup2();
  }
});

// src/serialization/user/client/updateMetadata.ts
var updateMetadata_exports2 = {};
__export(updateMetadata_exports2, {
  Request: () => Request9
});
var Request9;
var init_updateMetadata2 = __esm({
  "src/serialization/user/client/updateMetadata.ts"() {
    "use strict";
    init_core();
    Request9 = schemas_exports.object({
      username: schemas_exports.string().optional(),
      firstName: schemas_exports.property("first_name", schemas_exports.string().optional()),
      lastName: schemas_exports.property("last_name", schemas_exports.string().optional())
    });
  }
});

// src/serialization/user/client/fetchPasswordOptions.ts
var fetchPasswordOptions_exports2 = {};
__export(fetchPasswordOptions_exports2, {
  Response: () => Response11
});
var Response11;
var init_fetchPasswordOptions2 = __esm({
  "src/serialization/user/client/fetchPasswordOptions.ts"() {
    "use strict";
    init_core();
    Response11 = schemas_exports.lazyObject(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).FetchPasswordOptionsResponse);
  }
});

// src/serialization/user/client/updatePassword.ts
var updatePassword_exports2 = {};
__export(updatePassword_exports2, {
  Request: () => Request10
});
var Request10;
var init_updatePassword2 = __esm({
  "src/serialization/user/client/updatePassword.ts"() {
    "use strict";
    init_core();
    Request10 = schemas_exports.object({
      currentPassword: schemas_exports.property("current_password", schemas_exports.string().optional()),
      password: schemas_exports.string()
    });
  }
});

// src/serialization/user/client/signup.ts
var signup_exports2 = {};
__export(signup_exports2, {
  Request: () => Request11,
  Response: () => Response12
});
var Request11, Response12;
var init_signup2 = __esm({
  "src/serialization/user/client/signup.ts"() {
    "use strict";
    init_core();
    Request11 = schemas_exports.object({
      email: schemas_exports.string(),
      password: schemas_exports.string(),
      username: schemas_exports.string().optional(),
      firstName: schemas_exports.property("first_name", schemas_exports.string().optional()),
      lastName: schemas_exports.property("last_name", schemas_exports.string().optional())
    });
    Response12 = schemas_exports.lazy(async () => (await Promise.resolve().then(() => (init_serialization(), serialization_exports))).LoginStateEnum);
  }
});

// src/serialization/user/client/index.ts
var init_client10 = __esm({
  "src/serialization/user/client/index.ts"() {
    "use strict";
    init_updateMetadata2();
    init_fetchPasswordOptions2();
    init_updatePassword2();
    init_signup2();
  }
});

// src/serialization/user/index.ts
var user_exports2 = {};
__export(user_exports2, {
  BadRequestSignup: () => BadRequestSignup,
  BadRequestSignupError: () => BadRequestSignupError,
  BadRequestUpdateEmail: () => BadRequestUpdateEmail,
  BadRequestUpdateEmailError: () => BadRequestUpdateEmailError,
  BadRequestUpdateMetadata: () => BadRequestUpdateMetadata,
  BadRequestUpdateMetadataError: () => BadRequestUpdateMetadataError,
  BadRequestUpdateName: () => BadRequestUpdateName,
  BadRequestUpdateNameError: () => BadRequestUpdateNameError,
  BadRequestUpdatePassword: () => BadRequestUpdatePassword,
  BadRequestUpdatePasswordError: () => BadRequestUpdatePasswordError,
  BadRequestUpdateProfileImage: () => BadRequestUpdateProfileImage,
  BadRequestUpdateProfileImageError: () => BadRequestUpdateProfileImageError,
  BadRequestUpdateUsername: () => BadRequestUpdateUsername,
  BadRequestUpdateUsernameError: () => BadRequestUpdateUsernameError,
  FetchPasswordOptionsResponse: () => FetchPasswordOptionsResponse,
  ProfileStatusResponse: () => ProfileStatusResponse,
  UpdateProfileImageResponse: () => UpdateProfileImageResponse,
  fetchPasswordOptions: () => fetchPasswordOptions_exports2,
  signup: () => signup_exports2,
  updateMetadata: () => updateMetadata_exports2,
  updatePassword: () => updatePassword_exports2
});
var init_user2 = __esm({
  "src/serialization/user/index.ts"() {
    "use strict";
    init_types14();
    init_errors10();
    init_client10();
  }
});

// src/serialization/index.ts
var serialization_exports = {};
__export(serialization_exports, {
  AuthConfigurationResponse: () => AuthConfigurationResponse,
  BadRequestCreateOrg: () => BadRequestCreateOrg,
  BadRequestCreateOrgError: () => BadRequestCreateOrgError,
  BadRequestForgotPassword: () => BadRequestForgotPassword,
  BadRequestForgotPasswordType: () => BadRequestForgotPasswordType,
  BadRequestJoinOrg: () => BadRequestJoinOrg,
  BadRequestJoinOrgError: () => BadRequestJoinOrgError,
  BadRequestLogin: () => BadRequestLogin,
  BadRequestLoginPasswordless: () => BadRequestLoginPasswordless,
  BadRequestLoginPasswordlessType: () => BadRequestLoginPasswordlessType,
  BadRequestLoginType: () => BadRequestLoginType,
  BadRequestMfaEnable: () => BadRequestMfaEnable,
  BadRequestMfaEnableError: () => BadRequestMfaEnableError,
  BadRequestMfaVerify: () => BadRequestMfaVerify,
  BadRequestMfaVerifyError: () => BadRequestMfaVerifyError,
  BadRequestOrgInvitation: () => BadRequestOrgInvitation,
  BadRequestOrgInvitationError: () => BadRequestOrgInvitationError,
  BadRequestSignup: () => BadRequestSignup,
  BadRequestSignupError: () => BadRequestSignupError,
  BadRequestUpdateEmail: () => BadRequestUpdateEmail,
  BadRequestUpdateEmailError: () => BadRequestUpdateEmailError,
  BadRequestUpdateForgotPassword: () => BadRequestUpdateForgotPassword,
  BadRequestUpdateForgotPasswordType: () => BadRequestUpdateForgotPasswordType,
  BadRequestUpdateMetadata: () => BadRequestUpdateMetadata,
  BadRequestUpdateMetadataError: () => BadRequestUpdateMetadataError,
  BadRequestUpdateName: () => BadRequestUpdateName,
  BadRequestUpdateNameError: () => BadRequestUpdateNameError,
  BadRequestUpdateOrgMetadata: () => BadRequestUpdateOrgMetadata,
  BadRequestUpdateOrgMetadataError: () => BadRequestUpdateOrgMetadataError,
  BadRequestUpdatePassword: () => BadRequestUpdatePassword,
  BadRequestUpdatePasswordError: () => BadRequestUpdatePasswordError,
  BadRequestUpdateProfileImage: () => BadRequestUpdateProfileImage,
  BadRequestUpdateProfileImageError: () => BadRequestUpdateProfileImageError,
  BadRequestUpdateUsername: () => BadRequestUpdateUsername,
  BadRequestUpdateUsernameError: () => BadRequestUpdateUsernameError,
  CreateOrgOptionsResponse: () => CreateOrgOptionsResponse,
  EncodedUserIdAndToken: () => EncodedUserIdAndToken,
  FetchPasswordOptionsResponse: () => FetchPasswordOptionsResponse,
  Forbidden: () => Forbidden,
  ForbiddenMfaEnable: () => ForbiddenMfaEnable,
  GenericError: () => GenericError,
  IncorrectMfaCode: () => IncorrectMfaCode,
  Invitation: () => Invitation,
  JoinableOrgsResponse: () => JoinableOrgsResponse,
  LoginStateEnum: () => LoginStateEnum2,
  LoginStateResponse: () => LoginStateResponse,
  MfaDisabledResponse: () => MfaDisabledResponse,
  MfaEnabledResponse: () => MfaEnabledResponse,
  MfaStatusResponse: () => MfaStatusResponse2,
  NoAccountFoundWithCredentials: () => NoAccountFoundWithCredentials,
  NoAccountFoundWithCredentialsType: () => NoAccountFoundWithCredentialsType,
  OrgId: () => OrgId,
  OrgInfoResponse: () => OrgInfoResponse,
  OrgMembershipResponse: () => OrgMembershipResponse,
  OrgResponse: () => OrgResponse,
  OrgStatusResponse: () => OrgStatusResponse,
  PendingInvite: () => PendingInvite,
  PendingOrgInvitesResponse: () => PendingOrgInvitesResponse,
  ProfileStatusResponse: () => ProfileStatusResponse,
  RedirectToUrl: () => RedirectToUrl,
  SelectedOrgStatusResponse: () => SelectedOrgStatusResponse,
  SelectedOrgStatusUser: () => SelectedOrgStatusUser,
  UpdateProfileImageResponse: () => UpdateProfileImageResponse,
  UserId: () => UserId,
  commons: () => commons_exports2,
  config: () => config_exports2,
  login: () => login_exports4,
  mfa: () => mfa_exports2,
  org: () => org_exports2,
  user: () => user_exports2
});
var init_serialization = __esm({
  "src/serialization/index.ts"() {
    "use strict";
    init_commons2();
    init_types9();
    init_config2();
    init_types10();
    init_login4();
    init_types11();
    init_mfa2();
    init_types12();
    init_org2();
    init_types13();
    init_user2();
    init_types14();
    init_errors6();
    init_errors7();
    init_errors8();
    init_errors9();
    init_errors10();
  }
});

// src/resources/config/client/Client.ts
var import_url_join, Client;
var init_Client = __esm({
  "src/resources/config/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join = __toESM(require_url_join());
    init_serialization();
    Client = class {
      constructor(options) {
        this.options = options;
      }
      async fetchConfig() {
        const _response = await fetcher({
          url: (0, import_url_join.default)(this.options.environment, "/api/fe/v2/auth_configuration"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await config_exports2.fetchConfig.Response.parse(
              _response.body
            )
          };
        }
        return {
          ok: false,
          error: resources_exports.config.fetchConfig.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/resources/login/client/Client.ts
var import_url_join2, Client2;
var init_Client2 = __esm({
  "src/resources/login/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join2 = __toESM(require_url_join());
    init_serialization();
    Client2 = class {
      constructor(options) {
        this.options = options;
      }
      async login(request) {
        const _response = await fetcher({
          url: (0, import_url_join2.default)(this.options.environment, "/api/fe/v2/login"),
          method: "POST",
          headers: {
            "X-CSRF-Token": request.xCsrfToken,
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await login_exports4.login.Request.json({
            email: request.email,
            password: request.password
          })
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await login_exports4.login.Response.parse(_response.body)
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              return {
                ok: false,
                error: resources_exports.login.login.Error.badRequestLogin(
                  await BadRequestLogin.parse(_response.error.body)
                )
              };
            case 404:
              return {
                ok: false,
                error: resources_exports.login.login.Error.noAccountFoundWithCredentials(
                  await NoAccountFoundWithCredentials.parse(
                    _response.error.body
                  )
                )
              };
          }
        }
        return {
          ok: false,
          error: resources_exports.login.login.Error._unknown(_response.error)
        };
      }
      async sendMagicLinkLogin(request) {
        const _response = await fetcher({
          url: (0, import_url_join2.default)(this.options.environment, "/api/fe/v2/login_passwordless"),
          method: "POST",
          headers: {
            "X-CSRF-Token": request.xCsrfToken,
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await login_exports4.sendMagicLinkLogin.Request.json({
            email: request.email,
            createIfDoesntExist: request.createIfDoesntExist
          })
        });
        if (_response.ok) {
          return {
            ok: true,
            body: void 0
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 404:
              return {
                ok: false,
                error: resources_exports.login.sendMagicLinkLogin.Error.loginPasswordlessNotSupported()
              };
            case 400:
              return {
                ok: false,
                error: resources_exports.login.sendMagicLinkLogin.Error.badRequestLoginPasswordless(
                  await BadRequestLoginPasswordless.parse(
                    _response.error.body
                  )
                )
              };
          }
        }
        return {
          ok: false,
          error: resources_exports.login.sendMagicLinkLogin.Error._unknown(_response.error)
        };
      }
      async forgotPassword(request) {
        const _response = await fetcher({
          url: (0, import_url_join2.default)(this.options.environment, "/api/fe/v2/forgot_password"),
          method: "POST",
          headers: {
            "X-CSRF-Token": request.xCsrfToken,
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await login_exports4.forgotPassword.Request.json({
            email: request.email
          })
        });
        if (_response.ok) {
          return {
            ok: true,
            body: void 0
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              return {
                ok: false,
                error: resources_exports.login.forgotPassword.Error.badRequestForgotPassword(
                  await BadRequestForgotPassword.parse(
                    _response.error.body
                  )
                )
              };
          }
        }
        return {
          ok: false,
          error: resources_exports.login.forgotPassword.Error._unknown(_response.error)
        };
      }
      async fetchLoginState() {
        const _response = await fetcher({
          url: (0, import_url_join2.default)(this.options.environment, "/api/fe/v2/login_state"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await login_exports4.fetchLoginState.Response.parse(
              _response.body
            )
          };
        }
        return {
          ok: false,
          error: resources_exports.login.fetchLoginState.Error._unknown(_response.error)
        };
      }
      async checkOrgNameForSamlLogin(request) {
        const _response = await fetcher({
          url: (0, import_url_join2.default)(this.options.environment, "/api/fe/v2/org_url/check"),
          method: "POST",
          headers: {
            "X-CSRF-Token": request.xCsrfToken,
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await login_exports4.checkOrgNameForSamlLogin.Request.json({
            name: request.name
          })
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await login_exports4.checkOrgNameForSamlLogin.Response.parse(
              _response.body
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 404:
              return {
                ok: false,
                error: resources_exports.login.checkOrgNameForSamlLogin.Error.notFoundOrgName()
              };
            case 404:
              return {
                ok: false,
                error: resources_exports.login.checkOrgNameForSamlLogin.Error.notFoundOrgName()
              };
          }
        }
        return {
          ok: false,
          error: resources_exports.login.checkOrgNameForSamlLogin.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/resources/mfa/client/Client.ts
var import_url_join3, Client3;
var init_Client3 = __esm({
  "src/resources/mfa/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join3 = __toESM(require_url_join());
    init_serialization();
    Client3 = class {
      constructor(options) {
        this.options = options;
      }
      async mfaVerify(request) {
        const _response = await fetcher({
          url: (0, import_url_join3.default)(this.options.environment, "/api/fe/v2/verify"),
          method: "POST",
          headers: {
            "X-CSRF-Token": request.xCsrfToken,
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await mfa_exports2.mfaVerify.Request.json({
            code: request.code
          })
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await mfa_exports2.mfaVerify.Response.parse(_response.body)
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              return {
                ok: false,
                error: resources_exports.mfa.mfaVerify.Error.badRequestMfaVerify(
                  await BadRequestMfaVerify.parse(_response.error.body)
                )
              };
            case 404:
              return {
                ok: false,
                error: resources_exports.mfa.mfaVerify.Error.mfaTimedOut()
              };
            case 403:
              return {
                ok: false,
                error: resources_exports.mfa.mfaVerify.Error.incorrectMfaCode(
                  await IncorrectMfaCode.parse(_response.error.body)
                )
              };
          }
        }
        return {
          ok: false,
          error: resources_exports.mfa.mfaVerify.Error._unknown(_response.error)
        };
      }
      async mfaVerifyBackup(request) {
        const _response = await fetcher({
          url: (0, import_url_join3.default)(this.options.environment, "/api/fe/v2/verify_backup"),
          method: "POST",
          headers: {
            "X-CSRF-Token": request.xCsrfToken,
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await mfa_exports2.mfaVerifyBackup.Request.json({
            code: request.code
          })
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await mfa_exports2.mfaVerifyBackup.Response.parse(
              _response.body
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              return {
                ok: false,
                error: resources_exports.mfa.mfaVerifyBackup.Error.badRequestMfaVerify(
                  await BadRequestMfaVerify.parse(_response.error.body)
                )
              };
            case 404:
              return {
                ok: false,
                error: resources_exports.mfa.mfaVerifyBackup.Error.mfaTimedOut()
              };
            case 403:
              return {
                ok: false,
                error: resources_exports.mfa.mfaVerifyBackup.Error.incorrectMfaCode(
                  await IncorrectMfaCode.parse(_response.error.body)
                )
              };
          }
        }
        return {
          ok: false,
          error: resources_exports.mfa.mfaVerifyBackup.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/resources/org/client/Client.ts
var import_url_join4, Client4;
var init_Client4 = __esm({
  "src/resources/org/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join4 = __toESM(require_url_join());
    init_serialization();
    Client4 = class {
      constructor(options) {
        this.options = options;
      }
      async createOrg(request) {
        const _response = await fetcher({
          url: (0, import_url_join4.default)(this.options.environment, "/api/fe/v2/create_org"),
          method: "POST",
          headers: {
            "X-CSRF-Token": request.xCsrfToken,
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await org_exports2.createOrg.Request.json({
            name: request.name,
            autojoinByDomain: request.autojoinByDomain,
            restrictToDomain: request.restrictToDomain
          })
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await org_exports2.createOrg.Response.parse(_response.body)
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 404:
              return {
                ok: false,
                error: resources_exports.org.createOrg.Error.orgCreationNotEnabled()
              };
            case 400:
              return {
                ok: false,
                error: resources_exports.org.createOrg.Error.badRequestCreateOrg(
                  await BadRequestCreateOrg.parse(_response.error.body)
                )
              };
            case 401:
              return {
                ok: false,
                error: resources_exports.org.createOrg.Error.unauthorized()
              };
          }
        }
        return {
          ok: false,
          error: resources_exports.org.createOrg.Error._unknown(_response.error)
        };
      }
      async fetchCreateOrgOptions() {
        const _response = await fetcher({
          url: (0, import_url_join4.default)(this.options.environment, "/api/fe/v2/create_org_options"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await org_exports2.fetchCreateOrgOptions.Response.parse(
              _response.body
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 404:
              return {
                ok: false,
                error: resources_exports.org.fetchCreateOrgOptions.Error.orgCreationNotEnabled()
              };
            case 401:
              return {
                ok: false,
                error: resources_exports.org.fetchCreateOrgOptions.Error.unauthorized()
              };
          }
        }
        return {
          ok: false,
          error: resources_exports.org.fetchCreateOrgOptions.Error._unknown(_response.error)
        };
      }
      async joinOrg(request) {
        const _response = await fetcher({
          url: (0, import_url_join4.default)(this.options.environment, "/api/fe/v2/join_org"),
          method: "POST",
          headers: {
            "X-CSRF-Token": request.xCsrfToken,
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await org_exports2.joinOrg.Request.json({
            orgId: request.orgId
          })
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await org_exports2.joinOrg.Response.parse(_response.body)
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 404:
              return {
                ok: false,
                error: resources_exports.org.joinOrg.Error.orgsNotEnabled()
              };
            case 400:
              return {
                ok: false,
                error: resources_exports.org.joinOrg.Error.badRequestJoinOrg(
                  await BadRequestJoinOrg.parse(_response.error.body)
                )
              };
            case 401:
              return {
                ok: false,
                error: resources_exports.org.joinOrg.Error.unauthorized()
              };
          }
        }
        return {
          ok: false,
          error: resources_exports.org.joinOrg.Error._unknown(_response.error)
        };
      }
      async joinableOrgs() {
        const _response = await fetcher({
          url: (0, import_url_join4.default)(this.options.environment, "/api/fe/v2/joinable_orgs"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await org_exports2.joinableOrgs.Response.parse(
              _response.body
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 404:
              return {
                ok: false,
                error: resources_exports.org.joinableOrgs.Error.orgsNotEnabled()
              };
            case 401:
              return {
                ok: false,
                error: resources_exports.org.joinableOrgs.Error.unauthorized()
              };
          }
        }
        return {
          ok: false,
          error: resources_exports.org.joinableOrgs.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/resources/user/client/Client.ts
var import_url_join5, Client5;
var init_Client5 = __esm({
  "src/resources/user/client/Client.ts"() {
    "use strict";
    init_core();
    init_src();
    import_url_join5 = __toESM(require_url_join());
    init_serialization();
    Client5 = class {
      constructor(options) {
        this.options = options;
      }
      async updateMetadata(request) {
        const _response = await fetcher({
          url: (0, import_url_join5.default)(this.options.environment, "/api/fe/v2/update_metadata"),
          method: "POST",
          headers: {
            "X-CSRF-Token": request.xCsrfToken,
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await user_exports2.updateMetadata.Request.json({
            username: request.username,
            firstName: request.firstName,
            lastName: request.lastName
          })
        });
        if (_response.ok) {
          return {
            ok: true,
            body: void 0
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 401:
              return {
                ok: false,
                error: resources_exports.user.updateMetadata.Error.unauthorized()
              };
            case 400:
              return {
                ok: false,
                error: resources_exports.user.updateMetadata.Error.badRequestUpdateMetadata(
                  await BadRequestUpdateMetadata.parse(
                    _response.error.body
                  )
                )
              };
          }
        }
        return {
          ok: false,
          error: resources_exports.user.updateMetadata.Error._unknown(_response.error)
        };
      }
      async fetchPasswordOptions() {
        const _response = await fetcher({
          url: (0, import_url_join5.default)(this.options.environment, "/api/fe/v2/update_password_options"),
          method: "GET",
          headers: {
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await user_exports2.fetchPasswordOptions.Response.parse(
              _response.body
            )
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 401:
              return {
                ok: false,
                error: resources_exports.user.fetchPasswordOptions.Error.unauthorized()
              };
          }
        }
        return {
          ok: false,
          error: resources_exports.user.fetchPasswordOptions.Error._unknown(_response.error)
        };
      }
      async updatePassword(request) {
        const _response = await fetcher({
          url: (0, import_url_join5.default)(this.options.environment, "/api/fe/v2/update_password"),
          method: "POST",
          headers: {
            "X-CSRF-Token": request.xCsrfToken,
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await user_exports2.updatePassword.Request.json({
            currentPassword: request.currentPassword,
            password: request.password
          })
        });
        if (_response.ok) {
          return {
            ok: true,
            body: void 0
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 401:
              return {
                ok: false,
                error: resources_exports.user.updatePassword.Error.unauthorized()
              };
            case 404:
              return {
                ok: false,
                error: resources_exports.user.updatePassword.Error.incorrectPassword()
              };
            case 400:
              return {
                ok: false,
                error: resources_exports.user.updatePassword.Error.badRequestUpdatePassword(
                  await BadRequestUpdatePassword.parse(
                    _response.error.body
                  )
                )
              };
          }
        }
        return {
          ok: false,
          error: resources_exports.user.updatePassword.Error._unknown(_response.error)
        };
      }
      async signup(request) {
        const _response = await fetcher({
          url: (0, import_url_join5.default)(this.options.environment, "/api/fe/v2/signup"),
          method: "POST",
          headers: {
            "X-CSRF-Token": request.xCsrfToken,
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          },
          body: await user_exports2.signup.Request.json({
            email: request.email,
            password: request.password,
            username: request.username,
            firstName: request.firstName,
            lastName: request.lastName
          })
        });
        if (_response.ok) {
          return {
            ok: true,
            body: await user_exports2.signup.Response.parse(_response.body)
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 400:
              return {
                ok: false,
                error: resources_exports.user.signup.Error.badRequestSignup(
                  await BadRequestSignup.parse(_response.error.body)
                )
              };
            case 404:
              return {
                ok: false,
                error: resources_exports.user.signup.Error.signupNotAllowed()
              };
          }
        }
        return {
          ok: false,
          error: resources_exports.user.signup.Error._unknown(_response.error)
        };
      }
      async resendEmailConfirmation(request) {
        const _response = await fetcher({
          url: (0, import_url_join5.default)(this.options.environment, "/api/fe/v2/resend_email_confirmation"),
          method: "POST",
          headers: {
            "X-CSRF-Token": request.xCsrfToken,
            Authorization: BearerToken.toAuthorizationHeader(await Supplier.get(this.options.token))
          }
        });
        if (_response.ok) {
          return {
            ok: true,
            body: void 0
          };
        }
        if (_response.error.reason === "status-code") {
          switch (_response.error.statusCode) {
            case 429:
              return {
                ok: false,
                error: resources_exports.user.resendEmailConfirmation.Error.tooManyRequests()
              };
            case 401:
              return {
                ok: false,
                error: resources_exports.user.resendEmailConfirmation.Error.unauthorized()
              };
          }
        }
        return {
          ok: false,
          error: resources_exports.user.resendEmailConfirmation.Error._unknown(_response.error)
        };
      }
    };
  }
});

// src/Client.ts
var PropelAuthFeV2Client;
var init_Client6 = __esm({
  "src/Client.ts"() {
    "use strict";
    init_Client();
    init_Client2();
    init_Client3();
    init_Client4();
    init_Client5();
    PropelAuthFeV2Client = class {
      constructor(options) {
        this.options = options;
      }
      #config;
      get config() {
        return this.#config ??= new Client(this.options);
      }
      #login;
      get login() {
        return this.#login ??= new Client2(this.options);
      }
      #mfa;
      get mfa() {
        return this.#mfa ??= new Client3(this.options);
      }
      #org;
      get org() {
        return this.#org ??= new Client4(this.options);
      }
      #user;
      get user() {
        return this.#user ??= new Client5(this.options);
      }
    };
  }
});

// src/index.ts
var src_exports = {};
__export(src_exports, {
  PropelAuthFeV2: () => resources_exports,
  PropelAuthFeV2Client: () => PropelAuthFeV2Client
});
module.exports = __toCommonJS(src_exports);
var init_src = __esm({
  "src/index.ts"() {
    init_resources();
    init_Client6();
  }
});
init_src();
/*! Bundled license information:

ieee754/index.js:
  (*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> *)

buffer/index.js:
  (*!
   * The buffer module from node.js, for the browser.
   *
   * @author   Feross Aboukhadijeh <https://feross.org>
   * @license  MIT
   *)

basic-auth/index.js:
  (*!
   * basic-auth
   * Copyright(c) 2013 TJ Holowaychuk
   * Copyright(c) 2014 Jonathan Ong
   * Copyright(c) 2015-2016 Douglas Christopher Wilson
   * MIT Licensed
   *)
*/


/***/ }),

/***/ "./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js":
/*!**********************************************************************************!*\
  !*** ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js ***!
  \**********************************************************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(/*! react-is */ "./node_modules/react-is/index.js");

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ "./node_modules/react-is/cjs/react-is.development.js":
/*!***********************************************************!*\
  !*** ./node_modules/react-is/cjs/react-is.development.js ***!
  \***********************************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */





if (true) {
  (function() {
'use strict';

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}


/***/ }),

/***/ "./node_modules/react-is/index.js":
/*!****************************************!*\
  !*** ./node_modules/react-is/index.js ***!
  \****************************************/
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (false) {} else {
  module.exports = __webpack_require__(/*! ./cjs/react-is.development.js */ "./node_modules/react-is/cjs/react-is.development.js");
}


/***/ }),

/***/ "./src/AppearanceProvider.tsx":
/*!************************************!*\
  !*** ./src/AppearanceProvider.tsx ***!
  \************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useAppearance = exports.AppearanceProvider = exports.AppearanceContext = exports.DEFAULT_APPEARANCE = void 0;
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
exports.DEFAULT_APPEARANCE = {};
exports.AppearanceContext = (0, react_1.createContext)(undefined);
const AppearanceProvider = ({ appearance, children }) => {
    const [_appearance, _setAppearance] = (0, react_1.useState)(appearance || exports.DEFAULT_APPEARANCE);
    return (react_1.default.createElement(exports.AppearanceContext.Provider, { value: {
            appearance: _appearance,
            setAppearance: _setAppearance,
        } }, children));
};
exports.AppearanceProvider = AppearanceProvider;
const useAppearance = () => {
    const context = (0, react_1.useContext)(exports.AppearanceContext);
    if (context === undefined) {
        throw new Error("The component you are using is part of our component library beta (docs.propelauth.com/component-library/overview). " +
            "To use it, you must specify the `appearance` prop in BetaComponentLibraryProvider.");
    }
    return { appearance: context.appearance, setAppearance: context.setAppearance };
};
exports.useAppearance = useAppearance;


/***/ }),

/***/ "./src/AuthContext.tsx":
/*!*****************************!*\
  !*** ./src/AuthContext.tsx ***!
  \*****************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RequiredAuthProvider = exports.AuthProvider = exports.AuthContext = void 0;
const javascript_1 = __webpack_require__(/*! @propelauth/javascript */ "./node_modules/@propelauth/javascript/dist/javascript.min.js");
const js_apis_1 = __webpack_require__(/*! @propelauth/js-apis */ "./node_modules/@propelauth/js-apis/dist/browser/cjs/index.js");
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const useActiveOrg_1 = __webpack_require__(/*! ./useActiveOrg */ "./src/useActiveOrg.tsx");
const withRequiredAuthInfo_1 = __webpack_require__(/*! ./withRequiredAuthInfo */ "./src/withRequiredAuthInfo.tsx");
exports.AuthContext = react_1.default.createContext(undefined);
const initialAuthInfoState = {
    loading: true,
    authInfo: null,
};
function authInfoStateReducer(_state, action) {
    if (_state.loading) {
        return {
            loading: false,
            authInfo: action.authInfo,
        };
    }
    else if (action.authInfo) {
        if (_state.authInfo && _state.authInfo.accessToken === action.authInfo.accessToken) {
            return _state;
        }
        else {
            return {
                loading: false,
                authInfo: action.authInfo,
            };
        }
    }
    else if (_state.authInfo) {
        return {
            loading: false,
            authInfo: action.authInfo,
        };
    }
    else {
        return _state;
    }
}
const AuthProvider = (props) => {
    const [authInfoState, dispatch] = (0, react_1.useReducer)(authInfoStateReducer, initialAuthInfoState);
    const [loggedInChangeCounter, setLoggedInChangeCounter] = (0, react_1.useState)(0);
    // Create a client and register an observer that triggers when the user logs in or out
    const client = (0, react_1.useMemo)(() => {
        // Disable background token refresh as we will do it within React instead
        const client = (0, javascript_1.createClient)({ authUrl: props.authUrl, enableBackgroundTokenRefresh: false });
        client.addLoggedInChangeObserver(() => setLoggedInChangeCounter((x) => x + 1));
        return client;
    }, [props.authUrl]);
    // On unmount, destroy the client
    (0, react_1.useEffect)(() => {
        return () => {
            client.destroy();
        };
    }, []);
    // Periodically refresh the token. The client will only make requests when the authInfo is stale
    // Errors are logged and the token will be invalidated separately
    (0, react_1.useEffect)(() => {
        let didCancel = false;
        function refreshToken() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const authInfo = yield client.getAuthenticationInfoOrNull();
                    if (!didCancel) {
                        dispatch({ authInfo });
                    }
                }
                catch (_) {
                    // Exceptions are logged in the JS library
                }
            });
        }
        const interval = setInterval(refreshToken, 60000);
        return () => {
            didCancel = true;
            clearInterval(interval);
        };
    }, [client]);
    // Refresh the token when the user has logged in or out
    (0, react_1.useEffect)(() => {
        let didCancel = false;
        function refreshToken() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const authInfo = yield client.getAuthenticationInfoOrNull();
                    if (!didCancel) {
                        dispatch({ authInfo });
                    }
                }
                catch (_) {
                    // Exceptions are logged in the JS library
                }
            });
        }
        refreshToken();
        return () => {
            didCancel = true;
        };
    }, [client, loggedInChangeCounter]);
    // Watchdog timer to make sure that if we hit the expiration we get rid of the token.
    // This should only be triggered if we are unable to get a new token due to an unexpected error/network timeouts.
    const expiresAtSeconds = authInfoState.authInfo ? authInfoState.authInfo.expiresAtSeconds : 0;
    (0, react_1.useEffect)(() => {
        if (!authInfoState.authInfo) {
            return;
        }
        const millisUntilTokenExpires = getMillisUntilTokenExpires(authInfoState.authInfo.expiresAtSeconds);
        const timeout = setTimeout(() => {
            dispatch({ authInfo: null });
        }, millisUntilTokenExpires);
        return () => clearTimeout(timeout);
    }, [expiresAtSeconds]);
    const api = new js_apis_1.PropelAuthFeV2Client({ environment: props.authUrl });
    const logout = (0, react_1.useCallback)(client.logout, []);
    const redirectToLoginPage = (0, react_1.useCallback)(client.redirectToLoginPage, []);
    const redirectToSignupPage = (0, react_1.useCallback)(client.redirectToSignupPage, []);
    const redirectToAccountPage = (0, react_1.useCallback)(client.redirectToAccountPage, []);
    const redirectToOrgPage = (0, react_1.useCallback)(client.redirectToOrgPage, []);
    const redirectToCreateOrgPage = (0, react_1.useCallback)(client.redirectToCreateOrgPage, []);
    const activeOrgFn = props.getActiveOrgFn || useActiveOrg_1.loadOrgSelectionFromLocalStorage;
    const value = {
        loading: authInfoState.loading,
        authInfo: authInfoState.authInfo,
        logout,
        redirectToLoginPage,
        redirectToSignupPage,
        redirectToAccountPage,
        redirectToOrgPage,
        redirectToCreateOrgPage,
        activeOrgFn,
        setLoggedInChangeCounter,
        api,
        authUrl: props.authUrl,
    };
    return react_1.default.createElement(exports.AuthContext.Provider, { value: value }, props.children);
};
exports.AuthProvider = AuthProvider;
const RequiredAuthProvider = (props) => {
    const { children, displayIfLoggedOut, displayWhileLoading } = props, sharedProps = __rest(props, ["children", "displayIfLoggedOut", "displayWhileLoading"]);
    const WrappedComponent = (0, withRequiredAuthInfo_1.withRequiredAuthInfo)(() => {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }, {
        displayWhileLoading: displayWhileLoading,
        displayIfLoggedOut: displayIfLoggedOut,
    });
    return (react_1.default.createElement(exports.AuthProvider, Object.assign({}, sharedProps),
        react_1.default.createElement(WrappedComponent, null)));
};
exports.RequiredAuthProvider = RequiredAuthProvider;
function getMillisUntilTokenExpires(expiresAtSeconds) {
    let millisUntilTokenExpires = expiresAtSeconds * 1000 - Date.now();
    return Math.max(0, millisUntilTokenExpires);
}


/***/ }),

/***/ "./src/AuthContextForTesting.tsx":
/*!***************************************!*\
  !*** ./src/AuthContextForTesting.tsx ***!
  \***************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AuthProviderForTesting = void 0;
const js_apis_1 = __webpack_require__(/*! @propelauth/js-apis */ "./node_modules/@propelauth/js-apis/dist/browser/cjs/index.js");
const react_1 = __importDefault(__webpack_require__(/*! react */ "react"));
const AuthContext_1 = __webpack_require__(/*! ./AuthContext */ "./src/AuthContext.tsx");
/**
 * A version of the AuthProvider specifically used for testing. It won't make any external requests, but will
 * instead set up the AuthProvider to act as if the information provided was returned from the API.
 */
const AuthProviderForTesting = ({ loading, userInformation, activeOrgFn, children, }) => {
    const authInfo = getAuthInfoForTesting(userInformation);
    const activeOrgFnWithDefault = activeOrgFn ? activeOrgFn : () => null;
    const api = new js_apis_1.PropelAuthFeV2Client({ environment: "" });
    const contextValue = {
        loading: !!loading,
        authInfo,
        logout: () => Promise.resolve(),
        redirectToLoginPage: () => { },
        redirectToSignupPage: () => { },
        redirectToAccountPage: () => { },
        redirectToOrgPage: () => { },
        redirectToCreateOrgPage: () => { },
        activeOrgFn: activeOrgFnWithDefault,
        setLoggedInChangeCounter: () => { },
        api,
        authUrl: "",
    };
    return react_1.default.createElement(AuthContext_1.AuthContext.Provider, { value: contextValue }, children);
};
exports.AuthProviderForTesting = AuthProviderForTesting;
function getAuthInfoForTesting(userInformation) {
    if (!userInformation) {
        return null;
    }
    const orgIdToOrgMemberInfo = {};
    for (const orgMemberInfo of userInformation.orgMemberInfos) {
        orgIdToOrgMemberInfo[orgMemberInfo.orgId] = orgMemberInfo;
    }
    const accessTokenWithDefault = userInformation.accessToken === undefined ? "PLACEHOLDER_ACCESS_TOKEN" : userInformation.accessToken;
    return {
        accessToken: accessTokenWithDefault,
        expiresAtSeconds: 1701596820,
        orgHelper: getOrgHelper(orgIdToOrgMemberInfo),
        accessHelper: getAccessHelper(orgIdToOrgMemberInfo),
        orgIdToOrgMemberInfo: orgIdToOrgMemberInfo,
        user: userInformation.user,
    };
}
// These helpers come from @propelauth/javascript, down the road we may want to export them from that library
//   instead of copying
function getOrgHelper(orgIdToOrgMemberInfo) {
    return {
        getOrg(orgId) {
            if (orgIdToOrgMemberInfo.hasOwnProperty(orgId)) {
                return orgIdToOrgMemberInfo[orgId];
            }
            else {
                return undefined;
            }
        },
        getOrgIds() {
            return Object.keys(orgIdToOrgMemberInfo);
        },
        getOrgs() {
            return Object.values(orgIdToOrgMemberInfo);
        },
        getOrgByName(orgName) {
            for (const orgMemberInfo of Object.values(orgIdToOrgMemberInfo)) {
                if (orgMemberInfo.orgName === orgName || orgMemberInfo.urlSafeOrgName === orgName) {
                    return orgMemberInfo;
                }
            }
            return undefined;
        },
    };
}
function getAccessHelper(orgIdToOrgMemberInfo) {
    function isRole(orgId, role) {
        const orgMemberInfo = orgIdToOrgMemberInfo[orgId];
        if (orgMemberInfo === undefined) {
            return false;
        }
        return orgMemberInfo.userAssignedRole === role;
    }
    function isAtLeastRole(orgId, role) {
        const orgMemberInfo = orgIdToOrgMemberInfo[orgId];
        if (orgMemberInfo === undefined) {
            return false;
        }
        return orgMemberInfo.userInheritedRolesPlusCurrentRole.includes(role);
    }
    function hasPermission(orgId, permission) {
        const orgMemberInfo = orgIdToOrgMemberInfo[orgId];
        if (orgMemberInfo === undefined) {
            return false;
        }
        return orgMemberInfo.userPermissions.includes(permission);
    }
    function hasAllPermissions(orgId, permissions) {
        const orgMemberInfo = orgIdToOrgMemberInfo[orgId];
        if (orgMemberInfo === undefined) {
            return false;
        }
        return permissions.every((permission) => orgMemberInfo.userPermissions.includes(permission));
    }
    function getAccessHelperWithOrgId(orgId) {
        return {
            isRole(role) {
                return isRole(orgId, role);
            },
            isAtLeastRole(role) {
                return isAtLeastRole(orgId, role);
            },
            hasPermission(permission) {
                return hasPermission(orgId, permission);
            },
            hasAllPermissions(permissions) {
                return hasAllPermissions(orgId, permissions);
            },
        };
    }
    return {
        isRole,
        isAtLeastRole,
        hasPermission,
        hasAllPermissions,
        getAccessHelperWithOrgId,
    };
}


/***/ }),

/***/ "./src/BetaComponentLibraryProvider.tsx":
/*!**********************************************!*\
  !*** ./src/BetaComponentLibraryProvider.tsx ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BetaComponentLibraryProvider = void 0;
const react_1 = __importDefault(__webpack_require__(/*! react */ "react"));
const AppearanceProvider_1 = __webpack_require__(/*! ./AppearanceProvider */ "./src/AppearanceProvider.tsx");
const ConfigProvider_1 = __webpack_require__(/*! ./ConfigProvider */ "./src/ConfigProvider.tsx");
const ElementsProvider_1 = __webpack_require__(/*! ./ElementsProvider */ "./src/ElementsProvider.tsx");
const BetaComponentLibraryProvider = ({ elements, appearance, manuallySpecifiedConfig, children, }) => {
    return (react_1.default.createElement(ElementsProvider_1.ElementsProvider, { elements: elements },
        react_1.default.createElement(AppearanceProvider_1.AppearanceProvider, { appearance: appearance },
            react_1.default.createElement(ConfigProvider_1.ConfigProvider, { manuallySpecifiedConfig: manuallySpecifiedConfig }, children))));
};
exports.BetaComponentLibraryProvider = BetaComponentLibraryProvider;


/***/ }),

/***/ "./src/ConfigProvider.tsx":
/*!********************************!*\
  !*** ./src/ConfigProvider.tsx ***!
  \********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ConfigProvider = exports.ConfigContext = void 0;
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const constants_1 = __webpack_require__(/*! ./components/constants */ "./src/components/constants.ts");
const useApi_1 = __webpack_require__(/*! ./useApi */ "./src/useApi.tsx");
exports.ConfigContext = (0, react_1.createContext)({ loading: true, config: undefined, error: undefined });
const ConfigProvider = ({ manuallySpecifiedConfig, children }) => {
    const { configApi } = (0, useApi_1.useApi)();
    const [config, setConfig] = (0, react_1.useState)(manuallySpecifiedConfig);
    const [loading, setLoading] = (0, react_1.useState)(!manuallySpecifiedConfig);
    const [error, setError] = (0, react_1.useState)(undefined);
    (0, react_1.useEffect)(() => {
        if (manuallySpecifiedConfig) {
            return;
        }
        let mounted = true;
        configApi
            .fetchConfig()
            .then((res) => {
            if (!mounted) {
                return;
            }
            if (res.ok) {
                setConfig(res.body);
            }
            else {
                res.error._visit({
                    _other: () => setError(constants_1.UNEXPECTED_ERROR),
                });
            }
        })
            .catch((e) => {
            if (mounted) {
                setError(constants_1.UNEXPECTED_ERROR);
                console.error(e);
            }
        })
            .finally(() => {
            if (mounted) {
                setLoading(false);
            }
        });
        return () => {
            mounted = false;
        };
    }, []);
    return (react_1.default.createElement(exports.ConfigContext.Provider, { value: {
            config,
            error,
            loading,
        } }, children));
};
exports.ConfigProvider = ConfigProvider;


/***/ }),

/***/ "./src/ElementsProvider.tsx":
/*!**********************************!*\
  !*** ./src/ElementsProvider.tsx ***!
  \**********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useElements = exports.ElementsProvider = exports.ElementsContext = void 0;
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
exports.ElementsContext = (0, react_1.createContext)(undefined);
const ElementsProvider = ({ elements, children }) => {
    const [el, setEl] = (0, react_1.useState)(elements);
    return react_1.default.createElement(exports.ElementsContext.Provider, { value: { elements: el, setElements: setEl } }, children);
};
exports.ElementsProvider = ElementsProvider;
const useElements = () => {
    const context = (0, react_1.useContext)(exports.ElementsContext);
    if (context === undefined) {
        throw new Error("The component you are using is part of our component library beta (docs.propelauth.com/component-library/overview). " +
            "To use it, you must specify the `elements` prop in BetaComponentLibraryProvider.");
    }
    return { elements: context.elements, setElements: context.setElements };
};
exports.useElements = useElements;


/***/ }),

/***/ "./src/additionalHooks.ts":
/*!********************************!*\
  !*** ./src/additionalHooks.ts ***!
  \********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useAuthRefresh = exports.useAuthUrl = exports.useAccessHelper = exports.useOrgHelper = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const AuthContext_1 = __webpack_require__(/*! ./AuthContext */ "./src/AuthContext.tsx");
const useAuthInfo_1 = __webpack_require__(/*! ./useAuthInfo */ "./src/useAuthInfo.ts");
function useOrgHelper() {
    const authInfo = (0, useAuthInfo_1.useAuthInfo)();
    if (authInfo.loading) {
        return {
            loading: true,
            orgHelper: null,
        };
    }
    else if (authInfo.isLoggedIn) {
        return {
            loading: false,
            orgHelper: authInfo.orgHelper,
        };
    }
    else {
        return {
            loading: false,
            orgHelper: null,
        };
    }
}
exports.useOrgHelper = useOrgHelper;
function useAccessHelper() {
    const authInfo = (0, useAuthInfo_1.useAuthInfo)();
    if (authInfo.loading) {
        return {
            loading: true,
            accessHelper: null,
        };
    }
    else if (authInfo.isLoggedIn) {
        return {
            loading: false,
            accessHelper: authInfo.accessHelper,
        };
    }
    else {
        return {
            loading: false,
            accessHelper: null,
        };
    }
}
exports.useAccessHelper = useAccessHelper;
function useAuthUrl() {
    const context = (0, react_1.useContext)(AuthContext_1.AuthContext);
    if (context === undefined) {
        throw new Error("useAuthInfo must be used within an AuthProvider or RequiredAuthProvider");
    }
    return { authUrl: context.authUrl };
}
exports.useAuthUrl = useAuthUrl;
function useAuthRefresh() {
    const context = (0, react_1.useContext)(AuthContext_1.AuthContext);
    if (context === undefined) {
        throw new Error("useAuthRefresh must be used within an AuthProvider or RequiredAuthProvider");
    }
    return { refreshAuth: () => context.setLoggedInChangeCounter((x) => x + 1) };
}
exports.useAuthRefresh = useAuthRefresh;


/***/ }),

/***/ "./src/components/CompleteAccount.tsx":
/*!********************************************!*\
  !*** ./src/components/CompleteAccount.tsx ***!
  \********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const Alert_1 = __webpack_require__(/*! ../elements/Alert */ "./src/elements/Alert.tsx");
const Button_1 = __webpack_require__(/*! ../elements/Button */ "./src/elements/Button.tsx");
const Container_1 = __webpack_require__(/*! ../elements/Container */ "./src/elements/Container.tsx");
const H3_1 = __webpack_require__(/*! ../elements/H3 */ "./src/elements/H3.tsx");
const Image_1 = __webpack_require__(/*! ../elements/Image */ "./src/elements/Image.tsx");
const Input_1 = __webpack_require__(/*! ../elements/Input */ "./src/elements/Input.tsx");
const Label_1 = __webpack_require__(/*! ../elements/Label */ "./src/elements/Label.tsx");
const Paragraph_1 = __webpack_require__(/*! ../elements/Paragraph */ "./src/elements/Paragraph.tsx");
const useApi_1 = __webpack_require__(/*! ../useApi */ "./src/useApi.tsx");
const useRedirectFunctions_1 = __webpack_require__(/*! ../useRedirectFunctions */ "./src/useRedirectFunctions.tsx");
const withConfig_1 = __webpack_require__(/*! ../withConfig */ "./src/withConfig.tsx");
const constants_1 = __webpack_require__(/*! ./constants */ "./src/components/constants.ts");
const CompleteAccount = ({ onStepCompleted, appearance, testMode, config }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    const { userApi, loginApi } = (0, useApi_1.useApi)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [firstName, setFirstName] = (0, react_1.useState)("");
    const [lastName, setLastName] = (0, react_1.useState)("");
    const [username, setUsername] = (0, react_1.useState)("");
    const [firstNameError, setFirstNameError] = (0, react_1.useState)(undefined);
    const [lastNameError, setLastNameError] = (0, react_1.useState)(undefined);
    const [usernameError, setUsernameError] = (0, react_1.useState)(undefined);
    const [error, setError] = (0, react_1.useState)(undefined);
    const { redirectToLoginPage } = (0, useRedirectFunctions_1.useRedirectFunctions)();
    const clearErrors = () => {
        setFirstNameError(undefined);
        setLastNameError(undefined);
        setUsernameError(undefined);
        setError(undefined);
    };
    function updateMetadata(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            if (testMode) {
                alert("You are currently in test mode. Remove the `overrideCurrentScreenForTesting` prop to complete account.");
                return;
            }
            try {
                clearErrors();
                setLoading(true);
                const options = { xCsrfToken: constants_1.X_CSRF_TOKEN };
                if (config.requireUsersToSetName) {
                    options.firstName = firstName;
                    options.lastName = lastName;
                }
                if (config.requireUsersToSetUsername) {
                    options.username = username;
                }
                const response = yield userApi.updateMetadata(options);
                if (response.ok) {
                    const status = yield loginApi.fetchLoginState();
                    if (status.ok) {
                        onStepCompleted();
                    }
                    else {
                        setError(constants_1.UNEXPECTED_ERROR);
                    }
                }
                else {
                    response.error._visit({
                        unauthorized: redirectToLoginPage,
                        badRequestUpdateMetadata: (err) => {
                            if (err.firstName || err.lastName || err.username) {
                                if (err.firstName) {
                                    setFirstNameError(err.firstName.join(", "));
                                }
                                if (err.lastName) {
                                    setLastNameError(err.lastName.join(", "));
                                }
                                if (err.username) {
                                    setUsernameError(err.username.join(", "));
                                }
                            }
                            else {
                                setError(constants_1.BAD_REQUEST);
                            }
                        },
                        _other: () => setError(constants_1.UNEXPECTED_ERROR),
                    });
                }
            }
            catch (e) {
                setError(constants_1.UNEXPECTED_ERROR);
                console.error(e);
            }
            finally {
                setLoading(false);
            }
        });
    }
    function getCompleteAccountContent() {
        if (testMode) {
            if (!config.requireUsersToSetName && !config.requireUsersToSetUsername) {
                return "You are currently in test mode. No information is needed to complete your account.";
            }
        }
        return constants_1.COMPLETE_ACCOUNT_TEXT;
    }
    return (react_1.default.createElement("div", { "data-contain": "component" },
        react_1.default.createElement(Container_1.Container, { appearance: (_a = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _a === void 0 ? void 0 : _a.Container },
            ((_b = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _b === void 0 ? void 0 : _b.displayLogo) && (react_1.default.createElement("div", { "data-contain": "logo" },
                react_1.default.createElement(Image_1.Image, { src: config.logoUrl, alt: config.siteDisplayName, appearance: (_c = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _c === void 0 ? void 0 : _c.Logo }))),
            react_1.default.createElement("div", { "data-contain": "header" },
                react_1.default.createElement(H3_1.H3, { appearance: (_d = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _d === void 0 ? void 0 : _d.Header }, "Complete your account")),
            react_1.default.createElement("div", { "data-contain": "content" },
                react_1.default.createElement(Paragraph_1.Paragraph, { appearance: (_e = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _e === void 0 ? void 0 : _e.Content }, getCompleteAccountContent())),
            react_1.default.createElement("div", { "data-contain": "form" },
                react_1.default.createElement("form", { onSubmit: updateMetadata },
                    config.requireUsersToSetName && (react_1.default.createElement("div", { "data-contain": "name_fields" },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(Label_1.Label, { htmlFor: "first_name", appearance: (_f = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _f === void 0 ? void 0 : _f.FirstNameLabel }, "First name"),
                            react_1.default.createElement(Input_1.Input, { id: "first_name", type: "text", value: firstName, placeholder: "First name", onChange: (e) => setFirstName(e.target.value), appearance: (_g = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _g === void 0 ? void 0 : _g.FirstNameInput }),
                            firstNameError && (react_1.default.createElement(Alert_1.Alert, { appearance: (_h = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _h === void 0 ? void 0 : _h.ErrorMessage, type: "error" }, firstNameError))),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(Label_1.Label, { htmlFor: "last_name", appearance: (_j = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _j === void 0 ? void 0 : _j.LastNameLabel }, "Last name"),
                            react_1.default.createElement(Input_1.Input, { id: "last_name", type: "text", value: lastName, placeholder: "Last name", onChange: (e) => setLastName(e.target.value), appearance: (_k = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _k === void 0 ? void 0 : _k.LastNameInput }),
                            lastNameError && (react_1.default.createElement(Alert_1.Alert, { appearance: (_l = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _l === void 0 ? void 0 : _l.ErrorMessage, type: "error" }, lastNameError))))),
                    config.requireUsersToSetUsername && (react_1.default.createElement("div", null,
                        react_1.default.createElement(Label_1.Label, { htmlFor: "username", appearance: (_m = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _m === void 0 ? void 0 : _m.UsernameLabel }, "Username"),
                        react_1.default.createElement(Input_1.Input, { id: "username", type: "text", value: username, placeholder: "Username", onChange: (e) => setUsername(e.target.value), appearance: (_o = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _o === void 0 ? void 0 : _o.UsernameInput }),
                        usernameError && (react_1.default.createElement(Alert_1.Alert, { appearance: (_p = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _p === void 0 ? void 0 : _p.ErrorMessage, type: "error" }, usernameError)))),
                    react_1.default.createElement(Button_1.Button, { loading: loading, appearance: (_q = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _q === void 0 ? void 0 : _q.SubmitButton, type: "submit" }, ((_r = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _r === void 0 ? void 0 : _r.submitButtonText) || "Continue"),
                    error && (react_1.default.createElement(Alert_1.Alert, { appearance: (_s = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _s === void 0 ? void 0 : _s.ErrorMessage, type: "error" }, error)))))));
};
exports["default"] = (0, withConfig_1.withConfig)(CompleteAccount);


/***/ }),

/***/ "./src/components/ConfirmEmail.tsx":
/*!*****************************************!*\
  !*** ./src/components/ConfirmEmail.tsx ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const Alert_1 = __webpack_require__(/*! ../elements/Alert */ "./src/elements/Alert.tsx");
const Button_1 = __webpack_require__(/*! ../elements/Button */ "./src/elements/Button.tsx");
const Container_1 = __webpack_require__(/*! ../elements/Container */ "./src/elements/Container.tsx");
const H3_1 = __webpack_require__(/*! ../elements/H3 */ "./src/elements/H3.tsx");
const Image_1 = __webpack_require__(/*! ../elements/Image */ "./src/elements/Image.tsx");
const Paragraph_1 = __webpack_require__(/*! ../elements/Paragraph */ "./src/elements/Paragraph.tsx");
const useApi_1 = __webpack_require__(/*! ../useApi */ "./src/useApi.tsx");
const useLogoutFunction_1 = __webpack_require__(/*! ../useLogoutFunction */ "./src/useLogoutFunction.ts");
const useRedirectFunctions_1 = __webpack_require__(/*! ../useRedirectFunctions */ "./src/useRedirectFunctions.tsx");
const withConfig_1 = __webpack_require__(/*! ../withConfig */ "./src/withConfig.tsx");
const constants_1 = __webpack_require__(/*! ./constants */ "./src/components/constants.ts");
const ConfirmEmail = ({ appearance, testMode, config }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { userApi } = (0, useApi_1.useApi)();
    const logoutFn = (0, useLogoutFunction_1.useLogoutFunction)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [resent, setResent] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(undefined);
    const { redirectToLoginPage } = (0, useRedirectFunctions_1.useRedirectFunctions)();
    function handleClick() {
        return __awaiter(this, void 0, void 0, function* () {
            if (testMode) {
                alert("You are currently in test mode. Remove the `overrideCurrentScreenForTesting` prop to resend email confirmation.");
                return;
            }
            try {
                setError(undefined);
                setLoading(true);
                const response = yield userApi.resendEmailConfirmation({ xCsrfToken: constants_1.X_CSRF_TOKEN });
                if (response.ok) {
                    setResent(true);
                }
                else {
                    response.error._visit({
                        tooManyRequests: () => setError(constants_1.RATE_LIMIT_EMAIL_CONFIRMATION),
                        unauthorized: redirectToLoginPage,
                        _other: () => setError(constants_1.UNEXPECTED_ERROR),
                    });
                }
            }
            catch (e) {
                setError(constants_1.UNEXPECTED_ERROR);
                console.error(e);
            }
            finally {
                setLoading(false);
            }
        });
    }
    return (react_1.default.createElement("div", { "data-contain": "component" },
        react_1.default.createElement(Container_1.Container, { appearance: (_a = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _a === void 0 ? void 0 : _a.Container },
            ((_b = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _b === void 0 ? void 0 : _b.displayLogo) && (react_1.default.createElement("div", { "data-contain": "logo" },
                react_1.default.createElement(Image_1.Image, { src: config.logoUrl, alt: config.siteDisplayName, appearance: (_c = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _c === void 0 ? void 0 : _c.Logo }))),
            react_1.default.createElement("div", { "data-contain": "header" },
                react_1.default.createElement(H3_1.H3, { appearance: (_d = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _d === void 0 ? void 0 : _d.Header }, "Confirm your email")),
            react_1.default.createElement("div", { "data-contain": "content" },
                react_1.default.createElement(Paragraph_1.Paragraph, { appearance: (_e = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _e === void 0 ? void 0 : _e.ConfirmationText }, constants_1.CONFIRM_EMAIL_MESSAGE)),
            react_1.default.createElement("div", { "data-contain": "form" },
                resent ? (react_1.default.createElement(Alert_1.Alert, { appearance: (_f = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _f === void 0 ? void 0 : _f.SuccessMessage, type: "success" }, constants_1.RESEND_CONFIRM_EMAIL_MESSAGE)) : (react_1.default.createElement(Button_1.Button, { loading: loading, onClick: handleClick, appearance: (_g = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _g === void 0 ? void 0 : _g.ResendConfirmationButton }, ((_h = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _h === void 0 ? void 0 : _h.resendConfirmationButtonText) || `Resend Confirmation Email`)),
                react_1.default.createElement(Button_1.Button, { onClick: () => logoutFn(true), appearance: (_j = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _j === void 0 ? void 0 : _j.LogoutButton }, "Logout")),
            error && (react_1.default.createElement(Alert_1.Alert, { appearance: (_k = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _k === void 0 ? void 0 : _k.ErrorMessage, type: "error" }, error)))));
};
exports["default"] = (0, withConfig_1.withConfig)(ConfirmEmail);


/***/ }),

/***/ "./src/components/CreateOrg.tsx":
/*!**************************************!*\
  !*** ./src/components/CreateOrg.tsx ***!
  \**************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const Alert_1 = __webpack_require__(/*! ../elements/Alert */ "./src/elements/Alert.tsx");
const Button_1 = __webpack_require__(/*! ../elements/Button */ "./src/elements/Button.tsx");
const Checkbox_1 = __webpack_require__(/*! ../elements/Checkbox */ "./src/elements/Checkbox.tsx");
const Container_1 = __webpack_require__(/*! ../elements/Container */ "./src/elements/Container.tsx");
const H3_1 = __webpack_require__(/*! ../elements/H3 */ "./src/elements/H3.tsx");
const Input_1 = __webpack_require__(/*! ../elements/Input */ "./src/elements/Input.tsx");
const Label_1 = __webpack_require__(/*! ../elements/Label */ "./src/elements/Label.tsx");
const Select_1 = __webpack_require__(/*! ../elements/Select */ "./src/elements/Select.tsx");
const useApi_1 = __webpack_require__(/*! ../useApi */ "./src/useApi.tsx");
const useRedirectFunctions_1 = __webpack_require__(/*! ../useRedirectFunctions */ "./src/useRedirectFunctions.tsx");
const withConfig_1 = __webpack_require__(/*! ../withConfig */ "./src/withConfig.tsx");
const constants_1 = __webpack_require__(/*! ./constants */ "./src/components/constants.ts");
const ErrorMessage_1 = __webpack_require__(/*! ./ErrorMessage */ "./src/components/ErrorMessage.tsx");
const Loading_1 = __webpack_require__(/*! ./Loading */ "./src/components/Loading.tsx");
const OrDivider_1 = __webpack_require__(/*! ./OrDivider */ "./src/components/OrDivider.tsx");
const CreateOrg = ({ onOrgCreatedOrJoined, appearance, testMode, config }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { orgApi } = (0, useApi_1.useApi)();
    const [statusLoading, setStatusLoading] = (0, react_1.useState)(false);
    const [statusError, setStatusError] = (0, react_1.useState)(undefined);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [name, setName] = (0, react_1.useState)("");
    const [canUseDomainOptions, setCanUseDomainOptions] = (0, react_1.useState)(false);
    const [autojoinByDomain, setAutojoinByDomain] = (0, react_1.useState)(false);
    const [restrictToDomain, setRestrictToDomain] = (0, react_1.useState)(false);
    const [existingDomain, setExistingDomain] = (0, react_1.useState)(testMode ? "example.com" : "");
    const [orgNameError, setOrgNameError] = (0, react_1.useState)(undefined);
    const [error, setError] = (0, react_1.useState)(undefined);
    const { redirectToLoginPage } = (0, useRedirectFunctions_1.useRedirectFunctions)();
    const orgMetaname = (config === null || config === void 0 ? void 0 : config.orgsMetaname) || "Organization";
    const autojoinByDomainText = `Any user with an @${existingDomain} email can join without approval.`;
    const restrictToDomainText = `Restrict membership to only users with an @${existingDomain} email.`;
    const clearErrors = () => {
        setStatusError(undefined);
        setOrgNameError(undefined);
        setError(undefined);
    };
    (0, react_1.useEffect)(() => {
        let mounted = true;
        if (!testMode) {
            clearErrors();
            setStatusLoading(true);
            orgApi
                .fetchCreateOrgOptions()
                .then((response) => {
                if (mounted) {
                    if (response.ok) {
                        setExistingDomain(response.body.currentUserDomain);
                        setCanUseDomainOptions(response.body.canUseDomainOptions);
                    }
                    else {
                        response.error._visit({
                            orgCreationNotEnabled: () => setStatusError(constants_1.ORG_CREATION_NOT_ENABLED),
                            unauthorized: redirectToLoginPage,
                            _other: () => setStatusError(constants_1.UNEXPECTED_ERROR),
                        });
                    }
                }
            })
                .catch((e) => {
                setStatusError(constants_1.UNEXPECTED_ERROR);
                console.error(e);
            })
                .finally(() => setStatusLoading(false));
        }
        return () => {
            mounted = false;
        };
    }, []);
    function createOrg(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            if (testMode) {
                alert("You are currently in test mode. Remove the `overrideCurrentScreenForTesting` prop to create an organization.");
                return;
            }
            try {
                clearErrors();
                setLoading(true);
                const options = { name, autojoinByDomain, restrictToDomain, xCsrfToken: constants_1.X_CSRF_TOKEN };
                const response = yield orgApi.createOrg(options);
                if (response.ok) {
                    onOrgCreatedOrJoined({ id: response.body.orgId, name });
                }
                else {
                    response.error._visit({
                        orgCreationNotEnabled: () => setError(constants_1.ORG_CREATION_NOT_ENABLED),
                        badRequestCreateOrg: (err) => {
                            if (err.name || err.error) {
                                if (err.name) {
                                    setOrgNameError(err.name.join(", "));
                                }
                                if (err.error) {
                                    setError(err.error.join(", "));
                                }
                            }
                            else {
                                setError(constants_1.BAD_REQUEST);
                            }
                        },
                        unauthorized: redirectToLoginPage,
                        _other: () => setError(constants_1.UNEXPECTED_ERROR),
                    });
                }
            }
            catch (e) {
                setError(constants_1.UNEXPECTED_ERROR);
                console.error(e);
            }
            finally {
                setLoading(false);
            }
        });
    }
    if (statusLoading) {
        return react_1.default.createElement(Loading_1.Loading, { appearance: appearance });
    }
    else if (statusError) {
        return react_1.default.createElement(ErrorMessage_1.ErrorMessage, { errorMessage: statusError, appearance: appearance });
    }
    return (react_1.default.createElement("div", { "data-contain": "component" },
        react_1.default.createElement(Container_1.Container, { appearance: (_a = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _a === void 0 ? void 0 : _a.Container },
            react_1.default.createElement("div", { "data-contain": "header" },
                react_1.default.createElement(H3_1.H3, { appearance: (_b = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _b === void 0 ? void 0 : _b.Header }, `Create your ${orgMetaname}`)),
            react_1.default.createElement("div", { "data-contain": "form" },
                react_1.default.createElement("form", { onSubmit: createOrg },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Label_1.Label, { htmlFor: "org_name", appearance: (_c = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _c === void 0 ? void 0 : _c.OrgNameLabel }, `What's the name of your ${orgMetaname.toLowerCase()}? This will be visible to other members.`),
                        react_1.default.createElement(Input_1.Input, { id: "org_name", type: "text", value: name, placeholder: "Name", onChange: (e) => setName(e.target.value), appearance: (_d = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _d === void 0 ? void 0 : _d.OrgNameInput, required: true }),
                        orgNameError && (react_1.default.createElement(Alert_1.Alert, { appearance: (_e = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _e === void 0 ? void 0 : _e.ErrorMessage, type: "error" }, orgNameError))),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Checkbox_1.Checkbox, { id: "autojoin_by_domain", label: autojoinByDomainText, checked: autojoinByDomain, onChange: (e) => setAutojoinByDomain(e.target.checked), appearance: (_f = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _f === void 0 ? void 0 : _f.AutojoinByDomainCheckbox, disabled: !canUseDomainOptions })),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Checkbox_1.Checkbox, { id: "restrict_to_domain", label: restrictToDomainText, checked: restrictToDomain, onChange: (e) => setRestrictToDomain(e.target.checked), appearance: (_g = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _g === void 0 ? void 0 : _g.RestrictToDomainCheckbox, disabled: !canUseDomainOptions })),
                    react_1.default.createElement(Button_1.Button, { loading: loading, appearance: (_h = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _h === void 0 ? void 0 : _h.CreateOrgButton, type: "submit" }, ((_j = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _j === void 0 ? void 0 : _j.createOrgButtonText) || `Create ${orgMetaname}`),
                    error && (react_1.default.createElement(Alert_1.Alert, { appearance: (_k = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _k === void 0 ? void 0 : _k.ErrorMessage, type: "error" }, error)))),
            !testMode && (react_1.default.createElement(JoinableOrgs, { orgMetaname: orgMetaname, onOrgCreatedOrJoined: onOrgCreatedOrJoined, appearance: appearance })))));
};
const JoinableOrgs = ({ orgMetaname, onOrgCreatedOrJoined, appearance }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { orgApi } = (0, useApi_1.useApi)();
    const [joinableOrgs, setJoinableOrgs] = (0, react_1.useState)([]);
    const [selectedOrgId, setSelectedOrgId] = (0, react_1.useState)("");
    const [fetchLoading, setFetchLoading] = (0, react_1.useState)(false);
    const [fetchError, setFetchError] = (0, react_1.useState)(undefined);
    const [joinLoading, setJoinLoading] = (0, react_1.useState)(false);
    const [joinError, setJoinError] = (0, react_1.useState)(undefined);
    const { redirectToLoginPage } = (0, useRedirectFunctions_1.useRedirectFunctions)();
    const joinOrgText = `Select the ${orgMetaname.toLowerCase()} you'd like to join. Based on your email address, you can join:`;
    const clearErrors = () => {
        setFetchError(undefined);
        setJoinError(undefined);
    };
    (0, react_1.useEffect)(() => {
        let mounted = true;
        clearErrors();
        setFetchLoading(true);
        orgApi
            .joinableOrgs()
            .then((response) => {
            if (mounted) {
                if (response.ok) {
                    const responseOrgs = response.body.orgs;
                    setJoinableOrgs(responseOrgs);
                    if (responseOrgs && responseOrgs.length > 0) {
                        setSelectedOrgId(responseOrgs[0].id);
                    }
                }
                else {
                    response.error._visit({
                        orgsNotEnabled: () => setFetchError(constants_1.ORGS_NOT_ENABLED),
                        unauthorized: redirectToLoginPage,
                        _other: () => setFetchError(constants_1.UNEXPECTED_ERROR),
                    });
                }
            }
        })
            .catch((e) => {
            setFetchError(constants_1.UNEXPECTED_ERROR);
            console.error(e);
        })
            .finally(() => setFetchLoading(false));
        return () => {
            mounted = false;
        };
    }, []);
    function joinOrg(e) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                e.preventDefault();
                clearErrors();
                setJoinLoading(true);
                if (!selectedOrgId) {
                    setJoinError(`Please select ${orgMetaname} to join.`);
                    return;
                }
                const response = yield orgApi.joinOrg({
                    orgId: selectedOrgId,
                    xCsrfToken: constants_1.X_CSRF_TOKEN,
                });
                if (response.ok) {
                    const selectedOrg = joinableOrgs.find((org) => org.id === selectedOrgId);
                    onOrgCreatedOrJoined(selectedOrg);
                }
                else {
                    response.error._visit({
                        orgsNotEnabled: () => setJoinError(constants_1.ORGS_NOT_ENABLED),
                        badRequestJoinOrg: (err) => { var _a; return setJoinError(((_a = err.error) === null || _a === void 0 ? void 0 : _a.join(", ")) || constants_1.BAD_REQUEST); },
                        unauthorized: redirectToLoginPage,
                        _other: () => setJoinError(constants_1.UNEXPECTED_ERROR),
                    });
                }
            }
            catch (e) {
                setJoinError(constants_1.UNEXPECTED_ERROR);
                console.error(e);
            }
            finally {
                setJoinLoading(false);
            }
        });
    }
    if (fetchLoading || joinableOrgs.length <= 0) {
        return null;
    }
    else if (fetchError) {
        return react_1.default.createElement(ErrorMessage_1.ErrorMessage, { errorMessage: fetchError, appearance: appearance });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(OrDivider_1.OrDivider, { appearance: (_a = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _a === void 0 ? void 0 : _a.Divider, options: (_b = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _b === void 0 ? void 0 : _b.divider }),
        react_1.default.createElement("div", { "data-contain": "form" },
            react_1.default.createElement("form", { onSubmit: joinOrg },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Label_1.Label, { htmlFor: "org", appearance: (_c = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _c === void 0 ? void 0 : _c.JoinOrgLabel }, joinOrgText),
                    react_1.default.createElement(Select_1.Select, { id: "org", value: selectedOrgId, onChange: (e) => setSelectedOrgId(e.target.value), appearance: (_d = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _d === void 0 ? void 0 : _d.JoinOrgSelect, options: joinableOrgs.map((org) => {
                            return { label: org.name, value: org.id };
                        }) })),
                react_1.default.createElement(Button_1.Button, { loading: joinLoading, appearance: (_e = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _e === void 0 ? void 0 : _e.JoinOrgButton, type: "submit" }, ((_f = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _f === void 0 ? void 0 : _f.joinOrgButtonText) || `Join ${orgMetaname}`),
                joinError && (react_1.default.createElement(Alert_1.Alert, { appearance: (_g = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _g === void 0 ? void 0 : _g.ErrorMessage, type: "error" }, joinError))))));
};
exports["default"] = (0, withConfig_1.withConfig)(CreateOrg);


/***/ }),

/***/ "./src/components/ErrorMessage.tsx":
/*!*****************************************!*\
  !*** ./src/components/ErrorMessage.tsx ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ErrorMessage = void 0;
const react_1 = __importDefault(__webpack_require__(/*! react */ "react"));
const Alert_1 = __webpack_require__(/*! ../elements/Alert */ "./src/elements/Alert.tsx");
const Container_1 = __webpack_require__(/*! ../elements/Container */ "./src/elements/Container.tsx");
const constants_1 = __webpack_require__(/*! ./constants */ "./src/components/constants.ts");
const ErrorMessage = ({ errorMessage, appearance }) => {
    var _a, _b;
    return (react_1.default.createElement("div", { "data-contain": "component" },
        react_1.default.createElement(Container_1.Container, { appearance: (_a = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _a === void 0 ? void 0 : _a.Container },
            react_1.default.createElement(Alert_1.Alert, { type: "error", appearance: (_b = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _b === void 0 ? void 0 : _b.Alert }, errorMessage || constants_1.UNEXPECTED_ERROR))));
};
exports.ErrorMessage = ErrorMessage;


/***/ }),

/***/ "./src/components/ForgotPassword.tsx":
/*!*******************************************!*\
  !*** ./src/components/ForgotPassword.tsx ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const Alert_1 = __webpack_require__(/*! ../elements/Alert */ "./src/elements/Alert.tsx");
const AnchorButton_1 = __webpack_require__(/*! ../elements/AnchorButton */ "./src/elements/AnchorButton.tsx");
const Button_1 = __webpack_require__(/*! ../elements/Button */ "./src/elements/Button.tsx");
const Container_1 = __webpack_require__(/*! ../elements/Container */ "./src/elements/Container.tsx");
const H3_1 = __webpack_require__(/*! ../elements/H3 */ "./src/elements/H3.tsx");
const Image_1 = __webpack_require__(/*! ../elements/Image */ "./src/elements/Image.tsx");
const Input_1 = __webpack_require__(/*! ../elements/Input */ "./src/elements/Input.tsx");
const Label_1 = __webpack_require__(/*! ../elements/Label */ "./src/elements/Label.tsx");
const Paragraph_1 = __webpack_require__(/*! ../elements/Paragraph */ "./src/elements/Paragraph.tsx");
const useApi_1 = __webpack_require__(/*! ../useApi */ "./src/useApi.tsx");
const withConfig_1 = __webpack_require__(/*! ../withConfig */ "./src/withConfig.tsx");
const constants_1 = __webpack_require__(/*! ./constants */ "./src/components/constants.ts");
const ForgotPassword = ({ onRedirectToLogin, appearance, config }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    const { loginApi } = (0, useApi_1.useApi)();
    const [email, setEmail] = (0, react_1.useState)("");
    const [emailError, setEmailError] = (0, react_1.useState)(undefined);
    const [error, setError] = (0, react_1.useState)(undefined);
    const [passwordResetLoading, setPasswordResetLoading] = (0, react_1.useState)(false);
    const [magicLinkLoading, setMagicLinkLoading] = (0, react_1.useState)(false);
    const [successMessage, setSuccessMessage] = (0, react_1.useState)(undefined);
    const clearErrors = () => {
        setEmailError(undefined);
        setError(undefined);
    };
    function submitForgotPassword(e) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                e.preventDefault();
                clearErrors();
                setPasswordResetLoading(true);
                const response = yield loginApi.forgotPassword({ email, xCsrfToken: constants_1.X_CSRF_TOKEN });
                if (response.ok) {
                    setSuccessMessage(constants_1.FORGOT_PASSWORD_SUCCESS);
                }
                else {
                    response.error._visit({
                        badRequestForgotPassword: (err) => { var _a; return setError(((_a = err.email) === null || _a === void 0 ? void 0 : _a.join(", ")) || constants_1.BAD_REQUEST); },
                        _other: () => setError(constants_1.UNEXPECTED_ERROR),
                    });
                }
            }
            catch (e) {
                setError(constants_1.UNEXPECTED_ERROR);
                console.error(e);
            }
            finally {
                setPasswordResetLoading(false);
            }
        });
    }
    function submitMagicLink(e) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                e.preventDefault();
                clearErrors();
                setMagicLinkLoading(true);
                const response = yield loginApi.sendMagicLinkLogin({
                    email,
                    createIfDoesntExist: false,
                    xCsrfToken: constants_1.X_CSRF_TOKEN,
                });
                if (response.ok) {
                    setSuccessMessage(constants_1.MAGIC_LINK_SUCCESS);
                }
                else {
                    response.error._visit({
                        loginPasswordlessNotSupported: () => setError(constants_1.LOGIN_PASSWORDLESS_NOT_SUPPORTED),
                        badRequestLoginPasswordless: (err) => {
                            if (err.email || err.error) {
                                if (err.email) {
                                    setEmailError(err.email.join(", "));
                                }
                                if (err.error) {
                                    setError(err.error.join(", "));
                                }
                            }
                            else {
                                setError(constants_1.BAD_REQUEST);
                            }
                        },
                        _other: () => setError(constants_1.UNEXPECTED_ERROR),
                    });
                }
            }
            catch (e) {
                setError(constants_1.UNEXPECTED_ERROR);
                console.error(e);
            }
            finally {
                setMagicLinkLoading(false);
            }
        });
    }
    if (successMessage) {
        return (react_1.default.createElement("div", { "data-contain": "component" },
            react_1.default.createElement(Container_1.Container, { appearance: (_a = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _a === void 0 ? void 0 : _a.Container },
                ((_b = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _b === void 0 ? void 0 : _b.displayLogo) && (react_1.default.createElement("div", { "data-contain": "logo" },
                    react_1.default.createElement(Image_1.Image, { src: config.logoUrl, alt: config.siteDisplayName, appearance: (_c = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _c === void 0 ? void 0 : _c.Logo }))),
                react_1.default.createElement("div", { "data-contain": "header" },
                    react_1.default.createElement(H3_1.H3, { appearance: (_d = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _d === void 0 ? void 0 : _d.Header }, `Forgot Password`)),
                react_1.default.createElement("div", { "data-contain": "content" },
                    react_1.default.createElement(Paragraph_1.Paragraph, { appearance: (_e = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _e === void 0 ? void 0 : _e.SuccessMessage }, successMessage)))));
    }
    return (react_1.default.createElement("div", { "data-contain": "component" },
        react_1.default.createElement(Container_1.Container, { appearance: (_f = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _f === void 0 ? void 0 : _f.Container },
            ((_g = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _g === void 0 ? void 0 : _g.displayLogo) && (react_1.default.createElement("div", { "data-contain": "logo" },
                react_1.default.createElement(Image_1.Image, { src: config.logoUrl, alt: config.siteDisplayName, appearance: (_h = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _h === void 0 ? void 0 : _h.Logo }))),
            react_1.default.createElement("div", { "data-contain": "header" },
                react_1.default.createElement(H3_1.H3, { appearance: (_j = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _j === void 0 ? void 0 : _j.Header }, `Forgot Password`)),
            react_1.default.createElement("div", { "data-contain": "content" }, config.hasPasswordLogin ? (react_1.default.createElement(Paragraph_1.Paragraph, { appearance: (_k = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _k === void 0 ? void 0 : _k.InstructionsText }, constants_1.PASSWORDLESS_MESSAGE)) : (react_1.default.createElement(Paragraph_1.Paragraph, { appearance: (_l = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _l === void 0 ? void 0 : _l.InstructionsText }, constants_1.FORGOT_PASSWORD_MESSAGE))),
            react_1.default.createElement("div", { "data-contain": "form" },
                react_1.default.createElement("form", { onSubmit: submitForgotPassword },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Label_1.Label, { htmlFor: "email", appearance: (_m = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _m === void 0 ? void 0 : _m.EmailLabel }, `Email`),
                        react_1.default.createElement(Input_1.Input, { required: true, id: "email", type: "email", value: email, onChange: (e) => setEmail(e.target.value), appearance: (_o = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _o === void 0 ? void 0 : _o.EmailInput }),
                        emailError && (react_1.default.createElement(Alert_1.Alert, { appearance: (_p = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _p === void 0 ? void 0 : _p.ErrorMessage, type: "error" }, emailError))),
                    react_1.default.createElement(Button_1.Button, { loading: passwordResetLoading, appearance: (_q = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _q === void 0 ? void 0 : _q.SubmitButton, type: "submit" }, ((_r = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _r === void 0 ? void 0 : _r.resetPasswordButtonText) || "Reset Password"))),
            config.hasPasswordlessLogin && (react_1.default.createElement("div", { "data-contain": "form" },
                react_1.default.createElement(Button_1.Button, { loading: magicLinkLoading, onClick: submitMagicLink, appearance: (_s = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _s === void 0 ? void 0 : _s.MagicLinkButton }, ((_t = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _t === void 0 ? void 0 : _t.magicLinkButtonText) || "Send Magic Link"))),
            onRedirectToLogin && (react_1.default.createElement("div", { "data-contain": "link" },
                react_1.default.createElement(AnchorButton_1.AnchorButton, { onClick: onRedirectToLogin, appearance: (_u = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _u === void 0 ? void 0 : _u.RedirectToLoginLink }, `Back to login`))),
            error && (react_1.default.createElement(Alert_1.Alert, { appearance: (_v = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _v === void 0 ? void 0 : _v.ErrorMessage, type: "error" }, error)))));
};
exports["default"] = (0, withConfig_1.withConfig)(ForgotPassword);


/***/ }),

/***/ "./src/components/Loading.tsx":
/*!************************************!*\
  !*** ./src/components/Loading.tsx ***!
  \************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Loading = void 0;
const react_1 = __importDefault(__webpack_require__(/*! react */ "react"));
const Container_1 = __webpack_require__(/*! ../elements/Container */ "./src/elements/Container.tsx");
const Loader_1 = __webpack_require__(/*! ../elements/Loader */ "./src/elements/Loader.tsx");
const Loading = ({ appearance }) => {
    var _a, _b;
    return (react_1.default.createElement("div", { "data-contain": "component" },
        react_1.default.createElement(Container_1.Container, { appearance: (_a = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _a === void 0 ? void 0 : _a.Container },
            react_1.default.createElement(Loader_1.Loader, { appearance: (_b = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _b === void 0 ? void 0 : _b.Loader }))));
};
exports.Loading = Loading;


/***/ }),

/***/ "./src/components/Login.tsx":
/*!**********************************!*\
  !*** ./src/components/Login.tsx ***!
  \**********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const Alert_1 = __webpack_require__(/*! ../elements/Alert */ "./src/elements/Alert.tsx");
const AnchorButton_1 = __webpack_require__(/*! ../elements/AnchorButton */ "./src/elements/AnchorButton.tsx");
const Button_1 = __webpack_require__(/*! ../elements/Button */ "./src/elements/Button.tsx");
const Container_1 = __webpack_require__(/*! ../elements/Container */ "./src/elements/Container.tsx");
const H3_1 = __webpack_require__(/*! ../elements/H3 */ "./src/elements/H3.tsx");
const Image_1 = __webpack_require__(/*! ../elements/Image */ "./src/elements/Image.tsx");
const Input_1 = __webpack_require__(/*! ../elements/Input */ "./src/elements/Input.tsx");
const Label_1 = __webpack_require__(/*! ../elements/Label */ "./src/elements/Label.tsx");
const useApi_1 = __webpack_require__(/*! ../useApi */ "./src/useApi.tsx");
const withConfig_1 = __webpack_require__(/*! ../withConfig */ "./src/withConfig.tsx");
const constants_1 = __webpack_require__(/*! ./constants */ "./src/components/constants.ts");
const OrDivider_1 = __webpack_require__(/*! ./OrDivider */ "./src/components/OrDivider.tsx");
const SignInOptions_1 = __webpack_require__(/*! ./SignInOptions */ "./src/components/SignInOptions.tsx");
const Login = ({ onStepCompleted, onRedirectToSignup, onRedirectToForgotPassword, onRedirectToPasswordlessLogin, onRedirectToSSOLogin, appearance, testMode, config, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    const { loginApi } = (0, useApi_1.useApi)();
    const [email, setEmail] = (0, react_1.useState)("");
    const [password, setPassword] = (0, react_1.useState)("");
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [emailError, setEmailError] = (0, react_1.useState)(undefined);
    const [passwordError, setPasswordError] = (0, react_1.useState)(undefined);
    const [error, setError] = (0, react_1.useState)(undefined);
    const clearErrors = () => {
        setEmailError(undefined);
        setPasswordError(undefined);
        setError(undefined);
    };
    const login = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        if (testMode) {
            alert("You are currently in test mode. Remove the `overrideCurrentScreenForTesting` prop to log in.");
            return;
        }
        try {
            setLoading(true);
            clearErrors();
            const options = { email, password, xCsrfToken: constants_1.X_CSRF_TOKEN };
            const response = yield loginApi.login(options);
            if (response.ok) {
                onStepCompleted();
            }
            else {
                response.error._visit({
                    noAccountFoundWithCredentials: () => setError(constants_1.NO_ACCOUNT_FOUND_WITH_CREDENTIALS),
                    badRequestLogin: (err) => {
                        if (err.email || err.error || err.password) {
                            if (err.email) {
                                setEmailError(err.email.join(", "));
                            }
                            if (err.error) {
                                setError(err.error.join(", "));
                            }
                            if (err.password) {
                                setPasswordError(err.password.join(", "));
                            }
                        }
                        else {
                            setError(constants_1.BAD_REQUEST);
                        }
                    },
                    _other: () => setError(constants_1.UNEXPECTED_ERROR),
                });
            }
        }
        catch (e) {
            setError(constants_1.UNEXPECTED_ERROR);
            console.error(e);
        }
        finally {
            setLoading(false);
        }
    });
    return (react_1.default.createElement("div", { "data-contain": "component" },
        react_1.default.createElement(Container_1.Container, { appearance: (_a = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _a === void 0 ? void 0 : _a.Container },
            ((_b = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _b === void 0 ? void 0 : _b.displayLogo) !== false && (react_1.default.createElement("div", { "data-contain": "logo" },
                react_1.default.createElement(Image_1.Image, { src: config.logoUrl, alt: config.siteDisplayName, appearance: (_c = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _c === void 0 ? void 0 : _c.Logo }))),
            react_1.default.createElement("div", { "data-contain": "header" },
                react_1.default.createElement(H3_1.H3, { appearance: (_d = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _d === void 0 ? void 0 : _d.Header }, `Welcome`)),
            (config.hasPasswordlessLogin || config.hasAnyNonPasswordLogin) && (react_1.default.createElement(SignInOptions_1.SignInOptions, { config: config, onRedirectToPasswordlessLogin: onRedirectToPasswordlessLogin, onRedirectToSSOLogin: onRedirectToSSOLogin, appearance: appearance })),
            config.hasPasswordLogin && config.hasAnyNonPasswordLogin && ((_e = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _e === void 0 ? void 0 : _e.divider) !== false && (react_1.default.createElement(OrDivider_1.OrDivider, { appearance: (_f = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _f === void 0 ? void 0 : _f.Divider, options: (_g = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _g === void 0 ? void 0 : _g.divider })),
            config.hasPasswordLogin && (react_1.default.createElement("div", { "data-contain": "form" },
                react_1.default.createElement("form", { onSubmit: login },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Label_1.Label, { htmlFor: "email", appearance: (_h = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _h === void 0 ? void 0 : _h.EmailLabel }, `Email`),
                        react_1.default.createElement(Input_1.Input, { required: true, id: "email", type: "email", placeholder: "Email", value: email, onChange: (e) => setEmail(e.target.value), appearance: (_j = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _j === void 0 ? void 0 : _j.EmailInput }),
                        emailError && (react_1.default.createElement(Alert_1.Alert, { appearance: (_k = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _k === void 0 ? void 0 : _k.ErrorMessage, type: "error" }, emailError))),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Label_1.Label, { htmlFor: "password", appearance: (_l = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _l === void 0 ? void 0 : _l.PasswordLabel }, `Password`),
                        react_1.default.createElement(Input_1.Input, { required: true, type: "password", id: "password", placeholder: "Password", value: password, onChange: (e) => setPassword(e.target.value), appearance: (_m = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _m === void 0 ? void 0 : _m.PasswordInput }),
                        passwordError && (react_1.default.createElement(Alert_1.Alert, { appearance: (_o = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _o === void 0 ? void 0 : _o.ErrorMessage, type: "error" }, passwordError))),
                    react_1.default.createElement(Button_1.Button, { loading: loading, appearance: (_p = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _p === void 0 ? void 0 : _p.SubmitButton, type: "submit" }, ((_q = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _q === void 0 ? void 0 : _q.submitButtonText) || "Log In"),
                    error && (react_1.default.createElement(Alert_1.Alert, { appearance: (_r = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _r === void 0 ? void 0 : _r.ErrorMessage, type: "error" }, error))))),
            config.hasPasswordLogin &&
                ((config.allowPublicSignups && onRedirectToSignup) || onRedirectToForgotPassword) && (react_1.default.createElement("div", { "data-contain": `link${config.allowPublicSignups && onRedirectToSignup && onRedirectToForgotPassword ? "s" : ""}` },
                config.allowPublicSignups && onRedirectToSignup && (react_1.default.createElement(AnchorButton_1.AnchorButton, { onClick: onRedirectToSignup, appearance: (_s = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _s === void 0 ? void 0 : _s.RedirectToSignupLink }, `No account? Sign up`)),
                onRedirectToForgotPassword && (react_1.default.createElement(AnchorButton_1.AnchorButton, { onClick: onRedirectToForgotPassword, appearance: (_t = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _t === void 0 ? void 0 : _t.RedirectToForgotPasswordLink }, `Forgot Password?`)))))));
};
exports["default"] = (0, withConfig_1.withConfig)(Login);


/***/ }),

/***/ "./src/components/LoginManager.tsx":
/*!*****************************************!*\
  !*** ./src/components/LoginManager.tsx ***!
  \*****************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const js_apis_1 = __webpack_require__(/*! @propelauth/js-apis */ "./node_modules/@propelauth/js-apis/dist/browser/cjs/index.js");
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const additionalHooks_1 = __webpack_require__(/*! ../additionalHooks */ "./src/additionalHooks.ts");
const useLoginState_1 = __webpack_require__(/*! ../useLoginState */ "./src/useLoginState.ts");
const CompleteAccount_1 = __importDefault(__webpack_require__(/*! ./CompleteAccount */ "./src/components/CompleteAccount.tsx"));
const ConfirmEmail_1 = __importDefault(__webpack_require__(/*! ./ConfirmEmail */ "./src/components/ConfirmEmail.tsx"));
const CreateOrg_1 = __importDefault(__webpack_require__(/*! ./CreateOrg */ "./src/components/CreateOrg.tsx"));
const ErrorMessage_1 = __webpack_require__(/*! ./ErrorMessage */ "./src/components/ErrorMessage.tsx");
const Loading_1 = __webpack_require__(/*! ./Loading */ "./src/components/Loading.tsx");
const Login_1 = __importDefault(__webpack_require__(/*! ./Login */ "./src/components/Login.tsx"));
const UpdatePassword_1 = __importDefault(__webpack_require__(/*! ./UpdatePassword */ "./src/components/UpdatePassword.tsx"));
const VerifyMfa_1 = __importDefault(__webpack_require__(/*! ./VerifyMfa */ "./src/components/VerifyMfa.tsx"));
const LoginManager = ({ onLoginCompleted, onRedirectToSignup, onRedirectToForgotPassword, onRedirectToPasswordlessLogin, onRedirectToSSOLogin, loginAppearance, confirmEmailAppearance, verifyMfaAppearance, completeAccountAppearance, updatePasswordAppearance, createOrgAppearance, overrideCurrentScreenForTesting, }) => {
    const { refreshAuth } = (0, additionalHooks_1.useAuthRefresh)();
    const testMode = !!overrideCurrentScreenForTesting;
    const { loginStateLoading, loginStateError, loginState, getLoginState } = (0, useLoginState_1.useLoginState)({
        overrideCurrentScreenForTesting,
    });
    (0, react_1.useEffect)(() => {
        if (loginState === js_apis_1.PropelAuthFeV2.LoginStateEnum.Finished) {
            refreshAuth();
            onLoginCompleted();
        }
    }, [loginState]);
    if (loginStateLoading) {
        return react_1.default.createElement(Loading_1.Loading, { appearance: loginAppearance });
    }
    else if (loginStateError) {
        return react_1.default.createElement(ErrorMessage_1.ErrorMessage, { errorMessage: loginStateError, appearance: loginAppearance });
    }
    switch (loginState) {
        case js_apis_1.PropelAuthFeV2.LoginStateEnum.LoginRequired:
            return (react_1.default.createElement(Login_1.default, { onStepCompleted: () => getLoginState(), onRedirectToSignup: onRedirectToSignup, onRedirectToForgotPassword: onRedirectToForgotPassword, onRedirectToPasswordlessLogin: onRedirectToPasswordlessLogin, onRedirectToSSOLogin: onRedirectToSSOLogin, appearance: loginAppearance, testMode: testMode }));
        case js_apis_1.PropelAuthFeV2.LoginStateEnum.ConfirmEmailRequired:
            return react_1.default.createElement(ConfirmEmail_1.default, { appearance: confirmEmailAppearance, testMode: testMode });
        case js_apis_1.PropelAuthFeV2.LoginStateEnum.TwoFactorRequired:
            return (react_1.default.createElement(VerifyMfa_1.default, { onStepCompleted: () => getLoginState(), appearance: verifyMfaAppearance, testMode: testMode }));
        case js_apis_1.PropelAuthFeV2.LoginStateEnum.UserMetadataRequired:
            return (react_1.default.createElement(CompleteAccount_1.default, { onStepCompleted: () => getLoginState(), appearance: completeAccountAppearance, testMode: testMode }));
        case js_apis_1.PropelAuthFeV2.LoginStateEnum.UpdatePasswordRequired:
            return (react_1.default.createElement(UpdatePassword_1.default, { onStepCompleted: () => getLoginState(), appearance: updatePasswordAppearance, testMode: testMode }));
        case js_apis_1.PropelAuthFeV2.LoginStateEnum.OrgCreationRequired:
            return (react_1.default.createElement(CreateOrg_1.default, { onOrgCreatedOrJoined: () => getLoginState(), appearance: createOrgAppearance, testMode: testMode }));
        default:
            return react_1.default.createElement(Loading_1.Loading, { appearance: loginAppearance });
    }
};
exports["default"] = LoginManager;


/***/ }),

/***/ "./src/components/LoginPasswordless.tsx":
/*!**********************************************!*\
  !*** ./src/components/LoginPasswordless.tsx ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const Alert_1 = __webpack_require__(/*! ../elements/Alert */ "./src/elements/Alert.tsx");
const AnchorButton_1 = __webpack_require__(/*! ../elements/AnchorButton */ "./src/elements/AnchorButton.tsx");
const Button_1 = __webpack_require__(/*! ../elements/Button */ "./src/elements/Button.tsx");
const Container_1 = __webpack_require__(/*! ../elements/Container */ "./src/elements/Container.tsx");
const H3_1 = __webpack_require__(/*! ../elements/H3 */ "./src/elements/H3.tsx");
const Image_1 = __webpack_require__(/*! ../elements/Image */ "./src/elements/Image.tsx");
const Input_1 = __webpack_require__(/*! ../elements/Input */ "./src/elements/Input.tsx");
const Label_1 = __webpack_require__(/*! ../elements/Label */ "./src/elements/Label.tsx");
const Paragraph_1 = __webpack_require__(/*! ../elements/Paragraph */ "./src/elements/Paragraph.tsx");
const useApi_1 = __webpack_require__(/*! ../useApi */ "./src/useApi.tsx");
const withConfig_1 = __webpack_require__(/*! ../withConfig */ "./src/withConfig.tsx");
const constants_1 = __webpack_require__(/*! ./constants */ "./src/components/constants.ts");
const LoginPasswordless = ({ onRedirectToLogin, appearance, config }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const { loginApi } = (0, useApi_1.useApi)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [email, setEmail] = (0, react_1.useState)("");
    const [emailError, setEmailError] = (0, react_1.useState)(undefined);
    const [error, setError] = (0, react_1.useState)(undefined);
    const [submitted, setSubmitted] = (0, react_1.useState)(false);
    const clearErrors = () => {
        setEmailError(undefined);
        setError(undefined);
    };
    function loginPasswordless(e) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                e.preventDefault();
                clearErrors();
                setLoading(true);
                const response = yield loginApi.sendMagicLinkLogin({
                    email,
                    createIfDoesntExist: true,
                    xCsrfToken: constants_1.X_CSRF_TOKEN,
                });
                if (response.ok) {
                    setSubmitted(true);
                }
                else {
                    response.error._visit({
                        badRequestLoginPasswordless: (err) => {
                            if (err.email || err.error) {
                                if (err.email) {
                                    setEmailError(err.email.join(", "));
                                }
                                if (err.error) {
                                    setError(err.error.join(", "));
                                }
                            }
                            else {
                                setError(constants_1.BAD_REQUEST);
                            }
                        },
                        loginPasswordlessNotSupported: () => setError(constants_1.LOGIN_PASSWORDLESS_NOT_SUPPORTED),
                        _other: () => setError(constants_1.UNEXPECTED_ERROR),
                    });
                }
            }
            catch (e) {
                setError(constants_1.UNEXPECTED_ERROR);
                console.error(e);
            }
            finally {
                setLoading(false);
            }
        });
    }
    if (submitted) {
        return (react_1.default.createElement("div", { "data-contain": "component" },
            react_1.default.createElement(Container_1.Container, { appearance: (_a = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _a === void 0 ? void 0 : _a.Container }, config.allowPublicSignups ? (react_1.default.createElement(Paragraph_1.Paragraph, { appearance: (_b = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _b === void 0 ? void 0 : _b.SuccessMessage }, constants_1.PASSWORDLESS_LOGIN_SUBMITTED_PUBLIC)) : (react_1.default.createElement(Paragraph_1.Paragraph, { appearance: (_c = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _c === void 0 ? void 0 : _c.SuccessMessage }, constants_1.PASSWORDLESS_LOGIN_SUBMITTED)))));
    }
    return (react_1.default.createElement("div", { "data-contain": "component" },
        react_1.default.createElement(Container_1.Container, { appearance: (_d = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _d === void 0 ? void 0 : _d.Container },
            ((_e = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _e === void 0 ? void 0 : _e.displayLogo) && (react_1.default.createElement("div", { "data-contain": "logo" },
                react_1.default.createElement(Image_1.Image, { src: config.logoUrl, alt: config.siteDisplayName, appearance: (_f = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _f === void 0 ? void 0 : _f.Logo }))),
            react_1.default.createElement("div", { "data-contain": "header" },
                react_1.default.createElement(H3_1.H3, { appearance: (_g = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _g === void 0 ? void 0 : _g.Header }, `Sign in with Magic Link`)),
            react_1.default.createElement("div", { "data-contain": "content" },
                react_1.default.createElement(Paragraph_1.Paragraph, { appearance: (_h = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _h === void 0 ? void 0 : _h.Content }, "Enter your email address below. You'll receive a link that will log you in.")),
            react_1.default.createElement("div", { "data-contain": "form" },
                react_1.default.createElement("form", { onSubmit: loginPasswordless },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Label_1.Label, { htmlFor: "email", appearance: (_j = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _j === void 0 ? void 0 : _j.EmailLabel }, `Email`),
                        react_1.default.createElement(Input_1.Input, { required: true, id: "email", type: "email", value: email, onChange: (e) => setEmail(e.target.value), appearance: (_k = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _k === void 0 ? void 0 : _k.EmailInput }),
                        emailError && (react_1.default.createElement(Alert_1.Alert, { appearance: (_l = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _l === void 0 ? void 0 : _l.ErrorMessage, type: "error" }, emailError))),
                    react_1.default.createElement(Button_1.Button, { loading: loading, appearance: (_m = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _m === void 0 ? void 0 : _m.SubmitButton, type: "submit" }, ((_o = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _o === void 0 ? void 0 : _o.submitButtonText) || "Continue"),
                    error && (react_1.default.createElement(Alert_1.Alert, { appearance: (_p = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _p === void 0 ? void 0 : _p.ErrorMessage, type: "error" }, error)))),
            onRedirectToLogin && (react_1.default.createElement("div", { "data-contain": "link" },
                react_1.default.createElement(AnchorButton_1.AnchorButton, { onClick: onRedirectToLogin, appearance: (_q = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _q === void 0 ? void 0 : _q.RedirectToLoginLink }, `Back to login`))))));
};
exports["default"] = (0, withConfig_1.withConfig)(LoginPasswordless);


/***/ }),

/***/ "./src/components/LoginSSO.tsx":
/*!*************************************!*\
  !*** ./src/components/LoginSSO.tsx ***!
  \*************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const Alert_1 = __webpack_require__(/*! ../elements/Alert */ "./src/elements/Alert.tsx");
const AnchorButton_1 = __webpack_require__(/*! ../elements/AnchorButton */ "./src/elements/AnchorButton.tsx");
const Button_1 = __webpack_require__(/*! ../elements/Button */ "./src/elements/Button.tsx");
const Container_1 = __webpack_require__(/*! ../elements/Container */ "./src/elements/Container.tsx");
const H3_1 = __webpack_require__(/*! ../elements/H3 */ "./src/elements/H3.tsx");
const Image_1 = __webpack_require__(/*! ../elements/Image */ "./src/elements/Image.tsx");
const Input_1 = __webpack_require__(/*! ../elements/Input */ "./src/elements/Input.tsx");
const Label_1 = __webpack_require__(/*! ../elements/Label */ "./src/elements/Label.tsx");
const useApi_1 = __webpack_require__(/*! ../useApi */ "./src/useApi.tsx");
const withConfig_1 = __webpack_require__(/*! ../withConfig */ "./src/withConfig.tsx");
const constants_1 = __webpack_require__(/*! ./constants */ "./src/components/constants.ts");
const LoginSSO = ({ onRedirectToLogin, appearance, config }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { loginApi } = (0, useApi_1.useApi)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [orgName, setOrgName] = (0, react_1.useState)("");
    const [orgNameError, setOrgNameError] = (0, react_1.useState)(undefined);
    const [error, setError] = (0, react_1.useState)(undefined);
    const orgMetaname = config.orgsMetaname || "Organization";
    const clearErrors = () => {
        setOrgNameError(undefined);
        setError(undefined);
    };
    function loginSSO(e) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                e.preventDefault();
                clearErrors();
                setLoading(true);
                const response = yield loginApi.checkOrgNameForSamlLogin({
                    name: orgName,
                    xCsrfToken: constants_1.X_CSRF_TOKEN,
                });
                if (response.ok) {
                    window.location.replace(response.body.loginUrl);
                }
                else {
                    response.error._visit({
                        orgsNotEnabled: () => setError(constants_1.ORGS_NOT_ENABLED),
                        notFoundOrgName: () => setOrgNameError(constants_1.ORG_NAME_NOT_FOUND),
                        _other: () => setError(constants_1.UNEXPECTED_ERROR),
                    });
                }
            }
            catch (e) {
                setError(constants_1.UNEXPECTED_ERROR);
                console.error(e);
            }
            finally {
                setLoading(false);
            }
        });
    }
    return (react_1.default.createElement("div", { "data-contain": "component" },
        react_1.default.createElement(Container_1.Container, { appearance: (_a = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _a === void 0 ? void 0 : _a.Container },
            ((_b = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _b === void 0 ? void 0 : _b.displayLogo) && (react_1.default.createElement("div", { "data-contain": "logo" },
                react_1.default.createElement(Image_1.Image, { src: config.logoUrl, alt: config.siteDisplayName, appearance: (_c = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _c === void 0 ? void 0 : _c.Logo }))),
            react_1.default.createElement("div", { "data-contain": "header" },
                react_1.default.createElement(H3_1.H3, { appearance: (_d = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _d === void 0 ? void 0 : _d.Header }, `Login with SSO`)),
            react_1.default.createElement("div", { "data-contain": "form" },
                react_1.default.createElement("form", { onSubmit: loginSSO },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Label_1.Label, { htmlFor: "org_name", appearance: (_e = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _e === void 0 ? void 0 : _e.OrgNameLabel }, `Enter the name of your ${orgMetaname.toLowerCase()}:`),
                        react_1.default.createElement(Input_1.Input, { required: true, id: "org_name", type: "text", value: orgName, onChange: (e) => setOrgName(e.target.value), appearance: (_f = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _f === void 0 ? void 0 : _f.OrgNameInput }),
                        orgNameError && (react_1.default.createElement(Alert_1.Alert, { appearance: (_g = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _g === void 0 ? void 0 : _g.ErrorMessage, type: "error" }, orgNameError))),
                    react_1.default.createElement(Button_1.Button, { loading: loading, appearance: (_h = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _h === void 0 ? void 0 : _h.SubmitButton, type: "submit" }, ((_j = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _j === void 0 ? void 0 : _j.submitButtonText) || "Continue"),
                    error && (react_1.default.createElement(Alert_1.Alert, { appearance: (_k = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _k === void 0 ? void 0 : _k.ErrorMessage, type: "error" }, error)))),
            onRedirectToLogin && (react_1.default.createElement("div", { "data-contain": "link" },
                react_1.default.createElement(AnchorButton_1.AnchorButton, { onClick: onRedirectToLogin, appearance: (_l = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _l === void 0 ? void 0 : _l.RedirectToLoginLink }, `Back to login`))))));
};
exports["default"] = (0, withConfig_1.withConfig)(LoginSSO);


/***/ }),

/***/ "./src/components/OrDivider.tsx":
/*!**************************************!*\
  !*** ./src/components/OrDivider.tsx ***!
  \**************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.OrDivider = void 0;
const react_1 = __importDefault(__webpack_require__(/*! react */ "react"));
const Divider_1 = __webpack_require__(/*! ../elements/Divider */ "./src/elements/Divider.tsx");
const OrDivider = ({ appearance, options }) => {
    const innner = options === undefined ? "OR" : options === true ? null : options;
    return react_1.default.createElement(Divider_1.Divider, { appearance: appearance }, innner);
};
exports.OrDivider = OrDivider;


/***/ }),

/***/ "./src/components/SignInOptions.tsx":
/*!******************************************!*\
  !*** ./src/components/SignInOptions.tsx ***!
  \******************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SSOLogo = exports.PasswordlessLogo = exports.LinkedinLogo = exports.MicrosoftLogo = exports.SlackLogo = exports.GithubLogo = exports.GoogleLogo = exports.SignInOptions = void 0;
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const additionalHooks_1 = __webpack_require__(/*! ../additionalHooks */ "./src/additionalHooks.ts");
const Button_1 = __webpack_require__(/*! ../elements/Button */ "./src/elements/Button.tsx");
const constants_1 = __webpack_require__(/*! ./constants */ "./src/components/constants.ts");
const helpers_1 = __webpack_require__(/*! ./helpers */ "./src/components/helpers.ts");
const SignInOptions = ({ config, onRedirectToPasswordlessLogin, onRedirectToSSOLogin, appearance, }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { authUrl } = (0, additionalHooks_1.useAuthUrl)();
    const GOOGLE_LOGIN_PATH = "/google/login";
    const GITHUB_LOGIN_PATH = "/github/login";
    const SLACK_LOGIN_PATH = "/slack/login";
    const MICROSOFT_LOGIN_PATH = "/microsoft/login";
    const LINKEDIN_LOGIN_PATH = "/linkedin/login";
    function loginWithPasswordless() {
        onRedirectToPasswordlessLogin ? onRedirectToPasswordlessLogin() : console.error(constants_1.NO_PASSWORDLESS_URL);
    }
    function loginWithSSO() {
        onRedirectToSSOLogin ? onRedirectToSSOLogin() : console.error(constants_1.NO_SSO_URL);
    }
    function loginWithSocial(path) {
        const url = (0, helpers_1.withHttp)(authUrl);
        return window.location.replace(url + path);
    }
    (0, react_1.useEffect)(() => {
        if (config.hasPasswordlessLogin && !onRedirectToPasswordlessLogin) {
            console.error("Please specify an onRedirectToPasswordlessLogin function.");
        }
        if (config.hasSsoLogin && !onRedirectToSSOLogin) {
            console.error("Please specify an onRedirectToSSOLogin function.");
        }
    }, []);
    return (react_1.default.createElement("div", { "data-contain": "social_buttons" },
        config.hasGoogleLogin && (react_1.default.createElement(Button_1.Button, { onClick: () => loginWithSocial(GOOGLE_LOGIN_PATH), appearance: (_a = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _a === void 0 ? void 0 : _a.SocialButton },
            react_1.default.createElement(exports.GoogleLogo, null),
            react_1.default.createElement("span", null, "Sign in with Google"))),
        config.hasGithubLogin && (react_1.default.createElement(Button_1.Button, { onClick: () => loginWithSocial(GITHUB_LOGIN_PATH), appearance: (_b = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _b === void 0 ? void 0 : _b.SocialButton },
            react_1.default.createElement(exports.GithubLogo, null),
            react_1.default.createElement("span", null, "Sign in with Github"))),
        config.hasSlackLogin && (react_1.default.createElement(Button_1.Button, { onClick: () => loginWithSocial(SLACK_LOGIN_PATH), appearance: (_c = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _c === void 0 ? void 0 : _c.SocialButton },
            react_1.default.createElement(exports.SlackLogo, null),
            react_1.default.createElement("span", null, "Sign in with Slack"))),
        config.hasMicrosoftLogin && (react_1.default.createElement(Button_1.Button, { onClick: () => loginWithSocial(MICROSOFT_LOGIN_PATH), appearance: (_d = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _d === void 0 ? void 0 : _d.SocialButton },
            react_1.default.createElement(exports.MicrosoftLogo, null),
            react_1.default.createElement("span", null, "Sign in with Microsoft"))),
        config.hasLinkedinLogin && (react_1.default.createElement(Button_1.Button, { onClick: () => loginWithSocial(LINKEDIN_LOGIN_PATH), appearance: (_e = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _e === void 0 ? void 0 : _e.SocialButton },
            react_1.default.createElement(exports.LinkedinLogo, null),
            react_1.default.createElement("span", null, "Sign in with LinkedIn"))),
        config.hasPasswordlessLogin && (react_1.default.createElement(Button_1.Button, { onClick: () => loginWithPasswordless(), appearance: (_f = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _f === void 0 ? void 0 : _f.RedirectToPasswordlessLoginButton, disabled: !onRedirectToPasswordlessLogin },
            react_1.default.createElement(exports.PasswordlessLogo, null),
            react_1.default.createElement("span", null, "Sign in with Magic Link"))),
        config.hasSsoLogin && (react_1.default.createElement(Button_1.Button, { onClick: () => loginWithSSO(), appearance: (_g = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _g === void 0 ? void 0 : _g.RedirectToSSOLoginButton, disabled: !onRedirectToSSOLogin },
            react_1.default.createElement(exports.SSOLogo, null),
            react_1.default.createElement("span", null, "Sign in with SSO")))));
};
exports.SignInOptions = SignInOptions;
const GoogleLogo = () => {
    return (react_1.default.createElement("svg", { width: "92", height: "92", viewBox: "0 0 92 92" },
        react_1.default.createElement("path", { d: "M90.0004 47.0998C90.0004 43.9998 89.7004 40.7998 89.2004 37.7998H45.9004V55.4998H70.7004C69.7004 61.1998 66.4004 66.1998 61.5004 69.3998L76.3004 80.8998C85.0004 72.7998 90.0004 60.9998 90.0004 47.0998Z", fill: "#4280EF" }),
        react_1.default.createElement("path", { d: "M45.9004 91.8999C58.3004 91.8999 68.7004 87.7999 76.3004 80.7999L61.5004 69.3999C57.4004 72.1999 52.1004 73.7999 45.9004 73.7999C33.9004 73.7999 23.8004 65.6999 20.1004 54.8999L4.90039 66.5999C12.7004 82.0999 28.5004 91.8999 45.9004 91.8999Z", fill: "#34A353" }),
        react_1.default.createElement("path", { d: "M20.1004 54.7999C18.2004 49.0999 18.2004 42.8999 20.1004 37.1999L4.90039 25.3999C-1.59961 38.3999 -1.59961 53.6999 4.90039 66.5999L20.1004 54.7999Z", fill: "#F6B704" }),
        react_1.default.createElement("path", { d: "M45.9004 18.2999C52.4004 18.1999 58.8004 20.6999 63.5004 25.1999L76.6004 11.9999C68.3004 4.19989 57.3004 -0.000110182 45.9004 0.0998898C28.5004 0.0998898 12.7004 9.89989 4.90039 25.3999L20.1004 37.1999C23.8004 26.2999 33.9004 18.2999 45.9004 18.2999Z", fill: "#E54335" })));
};
exports.GoogleLogo = GoogleLogo;
const GithubLogo = () => {
    return (react_1.default.createElement("svg", { width: "32", height: "32", viewBox: "0 0 32 32" },
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 0C7.16 0 0 7.16 0 16C0 23.08 4.58 29.06 10.94 31.18C11.74 31.32 12.04 30.84 12.04 30.42C12.04 30.04 12.02 28.78 12.02 27.44C8 28.18 6.96 26.46 6.64 25.56C6.46 25.1 5.68 23.68 5 23.3C4.44 23 3.64 22.26 4.98 22.24C6.24 22.22 7.14 23.4 7.44 23.88C8.88 26.3 11.18 25.62 12.1 25.2C12.24 24.16 12.66 23.46 13.12 23.06C9.56 22.66 5.84 21.28 5.84 15.16C5.84 13.42 6.46 11.98 7.48 10.86C7.32 10.46 6.76 8.82 7.64 6.62C7.64 6.62 8.98 6.2 12.04 8.26C13.32 7.9 14.68 7.72 16.04 7.72C17.4 7.72 18.76 7.9 20.04 8.26C23.1 6.18 24.44 6.62 24.44 6.62C25.32 8.82 24.76 10.46 24.6 10.86C25.62 11.98 26.24 13.4 26.24 15.16C26.24 21.3 22.5 22.66 18.94 23.06C19.52 23.56 20.02 24.52 20.02 26.02C20.02 28.16 20 29.88 20 30.42C20 30.84 20.3 31.34 21.1 31.18C24.2763 30.1077 27.0363 28.0664 28.9917 25.3432C30.947 22.6201 31.9991 19.3524 32 16C32 7.16 24.84 0 16 0Z", fill: "black" })));
};
exports.GithubLogo = GithubLogo;
const SlackLogo = () => {
    return (react_1.default.createElement("svg", { width: "25", height: "25", viewBox: "0 0 25 25", fill: "none" },
        react_1.default.createElement("path", { d: "M9.12583 0.0617676C7.75125 0.0617676 6.63708 1.17843 6.63708 2.55552C6.63676 2.88267 6.70087 3.20669 6.82576 3.50907C6.95066 3.81145 7.13388 4.08626 7.36499 4.31783C7.59609 4.5494 7.87054 4.73318 8.17266 4.85868C8.47479 4.98418 8.79868 5.04894 9.12583 5.04927H11.615V2.55552C11.6156 1.89476 11.3536 1.26084 10.8868 0.79318C10.42 0.325523 9.78659 0.0624303 9.12583 0.0617676M9.12583 6.71177H2.48875C1.11417 6.71177 0 7.82843 0 9.20593C0 10.583 1.11417 11.6997 2.48875 11.6997H9.12625C10.5004 11.6997 11.615 10.583 11.615 9.20593C11.615 7.82843 10.5004 6.71177 9.12583 6.71177", fill: "#097EFF" }),
        react_1.default.createElement("path", { d: "M24.8884 9.20593C24.8884 7.82843 23.7739 6.71177 22.3993 6.71177C21.0247 6.71177 19.9105 7.82843 19.9105 9.20593V11.6997H22.3993C23.06 11.699 23.6935 11.4359 24.1603 10.9683C24.6271 10.5006 24.889 9.86669 24.8884 9.20593M18.2514 9.20593V2.55552C18.2519 1.89476 17.99 1.26084 17.5232 0.79318C17.0564 0.325523 16.4229 0.0624303 15.7622 0.0617676C14.3876 0.0617676 13.2734 1.17843 13.2734 2.55552V9.20552C13.2734 10.5834 14.3876 11.7001 15.7622 11.7001C16.4229 11.6994 17.0564 11.4363 17.5232 10.9687C17.99 10.501 18.2519 9.86711 18.2514 9.20635", fill: "#097EFF" }),
        react_1.default.createElement("path", { d: "M15.7622 25.0002C16.4229 24.9996 17.0564 24.7365 17.5232 24.2688C17.99 23.8012 18.2519 23.1672 18.2514 22.5065C18.2519 21.8457 17.99 21.2118 17.5232 20.7441C17.0564 20.2765 16.4229 20.0134 15.7622 20.0127H13.2734V22.5065C13.2734 23.8836 14.3876 25.0002 15.7622 25.0002ZM15.7622 18.3502H22.3997C23.7739 18.3502 24.8884 17.2336 24.8884 15.8561C24.889 15.1953 24.6271 14.5614 24.1603 14.0937C23.6935 13.6261 23.06 13.363 22.3993 13.3623H15.7622C14.3876 13.3623 13.2734 14.479 13.2734 15.8561C13.2731 16.1832 13.3372 16.5072 13.4621 16.8096C13.587 17.112 13.7702 17.3868 14.0013 17.6184C14.2324 17.8499 14.5069 18.0337 14.809 18.1592C15.1111 18.2847 15.435 18.3495 15.7622 18.3498", fill: "#ECB12F" }),
        react_1.default.createElement("path", { d: "M1.25576e-06 15.8561C-0.000327214 16.1832 0.0637857 16.5072 0.188679 16.8096C0.313573 17.112 0.496801 17.3868 0.727903 17.6184C0.959005 17.8499 1.23345 18.0337 1.53558 18.1592C1.83771 18.2847 2.1616 18.3495 2.48875 18.3498C3.14951 18.3491 3.78295 18.086 4.24975 17.6184C4.71654 17.1507 4.97847 16.5168 4.97792 15.8561V13.3623H2.48875C1.11417 13.3623 1.25576e-06 14.479 1.25576e-06 15.8561M6.63708 15.8561V22.5061C6.63708 23.8836 7.75125 25.0002 9.12583 25.0002C9.78659 24.9996 10.42 24.7365 10.8868 24.2688C11.3536 23.8012 11.6156 23.1672 11.615 22.5065V15.8561C11.6153 15.5289 11.5512 15.2048 11.4263 14.9024C11.3014 14.6 11.1181 14.3252 10.887 14.0936C10.6558 13.862 10.3813 13.6783 10.0791 13.5528C9.77696 13.4273 9.45303 13.3626 9.12583 13.3623C7.75125 13.3623 6.63708 14.479 6.63708 15.8561Z", fill: "#ECB12F" })));
};
exports.SlackLogo = SlackLogo;
const MicrosoftLogo = () => {
    return (react_1.default.createElement("svg", { width: "21", height: "21", viewBox: "0 0 21 21", fill: "none" },
        react_1.default.createElement("path", { d: "M0 0H10V10H0V0Z", fill: "#F35325" }),
        react_1.default.createElement("path", { d: "M11 0H21V10H11V0Z", fill: "#81BC06" }),
        react_1.default.createElement("path", { d: "M0 11H10V21H0V11Z", fill: "#05A6F0" }),
        react_1.default.createElement("path", { d: "M11 11H21V21H11V11Z", fill: "#FFBA08" })));
};
exports.MicrosoftLogo = MicrosoftLogo;
const LinkedinLogo = () => {
    return (react_1.default.createElement("svg", { width: "21", height: "22", viewBox: "0 0 21 22", fill: "none" },
        react_1.default.createElement("path", { d: "M0.882812 2.23542C0.882812 1.43471 1.54838 0.785208 2.36943 0.785208H19.5134C20.3344 0.785208 21 1.43471 21 2.23542V19.5798C21 20.3808 20.3344 21.03 19.5134 21.03H2.36943C1.54838 21.03 0.882812 20.3808 0.882812 19.5798V2.23542V2.23542Z", fill: "#006699" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.97986 17.7322V8.59051H3.94134V17.7322H6.97986V17.7322ZM5.46058 7.34237C6.52018 7.34237 7.17969 6.64039 7.17969 5.76312C7.15994 4.8661 6.52018 4.1836 5.48069 4.1836C4.4413 4.1836 3.76172 4.8661 3.76172 5.76312C3.76172 6.64039 4.42109 7.34237 5.44078 7.34237H5.46053H5.46058Z", fill: "white" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.66016 17.7322H11.6986V12.6271C11.6986 12.3539 11.7184 12.0809 11.7986 11.8856C12.0183 11.3397 12.5182 10.7743 13.3576 10.7743C14.4571 10.7743 14.897 11.6127 14.897 12.8416V17.7322H17.9352V12.4905C17.9352 9.68256 16.4362 8.37599 14.4371 8.37599C12.7979 8.37599 12.0783 9.29222 11.6784 9.91629H11.6987V8.59051H8.66024C8.70011 9.4483 8.66024 17.7322 8.66024 17.7322H8.66016Z", fill: "white" })));
};
exports.LinkedinLogo = LinkedinLogo;
const PasswordlessLogo = () => {
    return (react_1.default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", strokeWidth: "2", stroke: "#000000", fill: "none", strokeLinecap: "round", strokeLinejoin: "round" },
        react_1.default.createElement("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
        react_1.default.createElement("rect", { x: "3", y: "5", width: "18", height: "14", rx: "2" }),
        react_1.default.createElement("polyline", { points: "3 7 12 13 21 7" })));
};
exports.PasswordlessLogo = PasswordlessLogo;
const SSOLogo = () => {
    return (react_1.default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
        react_1.default.createElement("g", { clipPath: "url(#clip0_7_25)" },
            react_1.default.createElement("path", { d: "M16.5 0C12.36 0 9.00003 3.36 9.00003 7.5C9.00003 9.03 9.46503 10.44 10.245 11.625L0.435034 21.435C0.152578 21.7175 -0.00610352 22.1005 -0.00610352 22.5C-0.00610352 22.8995 0.152578 23.2825 0.435034 23.565C0.717489 23.8475 1.10058 24.0061 1.50003 24.0061C1.89949 24.0061 2.28258 23.8475 2.56503 23.565L4.50003 21.615L6.43503 23.55C6.70503 23.835 7.08003 24 7.50003 24C7.92003 24 8.29503 23.835 8.56503 23.565L11.565 20.565C11.835 20.295 12 19.92 12 19.5C12 19.08 11.835 18.705 11.565 18.435L9.61503 16.5L12.36 13.755C13.56 14.535 14.97 15 16.5 15C20.64 15 24 11.64 24 7.5C24 3.36 20.64 0 16.5 0ZM16.5 12C16.155 12 15.825 11.955 15.51 11.88C15.495 11.88 15.48 11.865 15.465 11.865C15.15 11.79 14.85 11.685 14.565 11.55C13.9636 11.2604 13.4339 10.8411 13.0137 10.3224C12.5936 9.80373 12.2935 9.19843 12.135 8.55C12.135 8.535 12.12 8.52 12.12 8.505C12.045 8.175 12 7.845 12 7.5C12 5.01 14.01 3 16.5 3C18.99 3 21 5.01 21 7.5C21 9.99 18.99 12 16.5 12Z", fill: "black" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "clip0_7_25" },
                react_1.default.createElement("rect", { width: "24", height: "24", fill: "white" })))));
};
exports.SSOLogo = SSOLogo;


/***/ }),

/***/ "./src/components/Signup.tsx":
/*!***********************************!*\
  !*** ./src/components/Signup.tsx ***!
  \***********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const Alert_1 = __webpack_require__(/*! ../elements/Alert */ "./src/elements/Alert.tsx");
const AnchorButton_1 = __webpack_require__(/*! ../elements/AnchorButton */ "./src/elements/AnchorButton.tsx");
const Button_1 = __webpack_require__(/*! ../elements/Button */ "./src/elements/Button.tsx");
const Container_1 = __webpack_require__(/*! ../elements/Container */ "./src/elements/Container.tsx");
const H3_1 = __webpack_require__(/*! ../elements/H3 */ "./src/elements/H3.tsx");
const Image_1 = __webpack_require__(/*! ../elements/Image */ "./src/elements/Image.tsx");
const Input_1 = __webpack_require__(/*! ../elements/Input */ "./src/elements/Input.tsx");
const Label_1 = __webpack_require__(/*! ../elements/Label */ "./src/elements/Label.tsx");
const useApi_1 = __webpack_require__(/*! ../useApi */ "./src/useApi.tsx");
const withConfig_1 = __webpack_require__(/*! ../withConfig */ "./src/withConfig.tsx");
const constants_1 = __webpack_require__(/*! ./constants */ "./src/components/constants.ts");
const OrDivider_1 = __webpack_require__(/*! ./OrDivider */ "./src/components/OrDivider.tsx");
const SignInOptions_1 = __webpack_require__(/*! ./SignInOptions */ "./src/components/SignInOptions.tsx");
const Signup = ({ onSignupCompleted, onRedirectToLogin, onRedirectToPasswordlessLogin, onRedirectToSSOLogin, appearance, config, }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    return (react_1.default.createElement("div", { "data-contain": "component" },
        react_1.default.createElement(Container_1.Container, { appearance: (_a = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _a === void 0 ? void 0 : _a.Container },
            ((_b = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _b === void 0 ? void 0 : _b.displayLogo) !== false && (react_1.default.createElement("div", { "data-contain": "logo" },
                react_1.default.createElement(Image_1.Image, { src: config.logoUrl, alt: config.siteDisplayName, appearance: (_c = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _c === void 0 ? void 0 : _c.Logo }))),
            react_1.default.createElement("div", { "data-contain": "header" },
                react_1.default.createElement(H3_1.H3, { appearance: (_d = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _d === void 0 ? void 0 : _d.Header }, `Create an account`)),
            react_1.default.createElement(SignInOptions_1.SignInOptions, { config: config, appearance: appearance, onRedirectToPasswordlessLogin: onRedirectToPasswordlessLogin, onRedirectToSSOLogin: onRedirectToSSOLogin }),
            config.hasPasswordLogin && config.hasAnyNonPasswordLogin && ((_e = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _e === void 0 ? void 0 : _e.divider) !== false && (react_1.default.createElement(OrDivider_1.OrDivider, { appearance: (_f = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _f === void 0 ? void 0 : _f.Divider, options: (_g = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _g === void 0 ? void 0 : _g.divider })),
            config.hasPasswordLogin && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(SignupForm, { config: config, onSignupCompleted: onSignupCompleted, appearance: appearance }),
                react_1.default.createElement(BottomLinks, { onRedirectToLogin: onRedirectToLogin, appearance: appearance }))))));
};
const SignupForm = ({ config, onSignupCompleted, appearance }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    const { userApi } = (0, useApi_1.useApi)();
    const [email, setEmail] = (0, react_1.useState)("");
    const [password, setPassword] = (0, react_1.useState)("");
    const [firstName, setFirstName] = (0, react_1.useState)("");
    const [lastName, setLastName] = (0, react_1.useState)("");
    const [username, setUsername] = (0, react_1.useState)("");
    const [emailError, setEmailError] = (0, react_1.useState)(undefined);
    const [firstNameError, setFirstNameError] = (0, react_1.useState)(undefined);
    const [lastNameError, setLastNameError] = (0, react_1.useState)(undefined);
    const [passwordError, setPasswordError] = (0, react_1.useState)(undefined);
    const [usernameError, setUsernameError] = (0, react_1.useState)(undefined);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(undefined);
    const clearErrors = () => {
        setEmailError(undefined);
        setFirstNameError(undefined);
        setLastNameError(undefined);
        setPasswordError(undefined);
        setUsernameError(undefined);
        setError(undefined);
    };
    const signup = (e) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            e.preventDefault();
            setLoading(true);
            clearErrors();
            const options = {
                email: email,
                password: password,
                xCsrfToken: constants_1.X_CSRF_TOKEN,
            };
            if (config.requireUsersToSetName) {
                options.firstName = firstName;
                options.lastName = lastName;
            }
            if (config.requireUsersToSetUsername) {
                options.username = username;
            }
            const response = yield userApi.signup(options);
            if (response.ok) {
                onSignupCompleted();
            }
            else {
                response.error._visit({
                    signupNotAllowed: () => setError(constants_1.SIGNUP_NOT_ALLOWED),
                    badRequestSignup: (err) => {
                        if (err.email || err.firstName || err.lastName || err.password || err.username) {
                            if (err.email) {
                                setEmailError(err.email.join(", "));
                            }
                            if (err.firstName) {
                                setFirstNameError(err.firstName.join(", "));
                            }
                            if (err.lastName) {
                                setLastNameError(err.lastName.join(", "));
                            }
                            if (err.password) {
                                setPasswordError(err.password.join(", "));
                            }
                            if (err.username) {
                                setUsernameError(err.username.join(", "));
                            }
                        }
                        else {
                            setError(constants_1.BAD_REQUEST);
                        }
                    },
                    _other: () => setError(constants_1.UNEXPECTED_ERROR),
                });
            }
        }
        catch (e) {
            setError(constants_1.UNEXPECTED_ERROR);
            console.error(e);
        }
        finally {
            setLoading(false);
        }
    });
    return (react_1.default.createElement("div", { "data-contain": "form" },
        react_1.default.createElement("form", { onSubmit: signup },
            config.requireUsersToSetName && (react_1.default.createElement("div", { "data-contain": "name_fields" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Label_1.Label, { htmlFor: "first_name", appearance: (_a = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _a === void 0 ? void 0 : _a.FirstNameLabel }, `First name`),
                    react_1.default.createElement(Input_1.Input, { required: true, id: "first_name", type: "text", value: firstName, placeholder: "First Name", onChange: (e) => setFirstName(e.target.value), appearance: (_b = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _b === void 0 ? void 0 : _b.FirstNameInput }),
                    firstNameError && (react_1.default.createElement(Alert_1.Alert, { appearance: (_c = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _c === void 0 ? void 0 : _c.ErrorMessage, type: "error" }, firstNameError))),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Label_1.Label, { htmlFor: "last_name", appearance: (_d = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _d === void 0 ? void 0 : _d.LastNameLabel }, `Last name`),
                    react_1.default.createElement(Input_1.Input, { required: true, type: "text", id: "last_name", value: lastName, placeholder: "Last Name", onChange: (e) => setLastName(e.target.value), appearance: (_e = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _e === void 0 ? void 0 : _e.LastNameInput }),
                    lastNameError && (react_1.default.createElement(Alert_1.Alert, { appearance: (_f = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _f === void 0 ? void 0 : _f.ErrorMessage, type: "error" }, lastNameError))))),
            react_1.default.createElement("div", null,
                react_1.default.createElement(Label_1.Label, { htmlFor: "email", appearance: (_g = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _g === void 0 ? void 0 : _g.EmailLabel }, `Email`),
                react_1.default.createElement(Input_1.Input, { required: true, id: "email", type: "email", value: email, placeholder: "Email", onChange: (e) => setEmail(e.target.value), appearance: (_h = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _h === void 0 ? void 0 : _h.EmailInput }),
                emailError && (react_1.default.createElement(Alert_1.Alert, { appearance: (_j = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _j === void 0 ? void 0 : _j.ErrorMessage, type: "error" }, emailError))),
            config.requireUsersToSetUsername && (react_1.default.createElement("div", null,
                react_1.default.createElement(Label_1.Label, { htmlFor: "username", appearance: (_k = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _k === void 0 ? void 0 : _k.UsernameLabel }, `Username`),
                react_1.default.createElement(Input_1.Input, { required: true, type: "text", id: "username", value: username, placeholder: "Username", onChange: (e) => setUsername(e.target.value), appearance: (_l = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _l === void 0 ? void 0 : _l.UsernameInput }),
                usernameError && (react_1.default.createElement(Alert_1.Alert, { appearance: (_m = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _m === void 0 ? void 0 : _m.ErrorMessage, type: "error" }, usernameError)))),
            react_1.default.createElement("div", null,
                react_1.default.createElement(Label_1.Label, { htmlFor: "password", appearance: (_o = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _o === void 0 ? void 0 : _o.PasswordLabel }, `Password`),
                react_1.default.createElement(Input_1.Input, { required: true, id: "password", type: "password", value: password, placeholder: "Password", onChange: (e) => setPassword(e.target.value), appearance: (_p = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _p === void 0 ? void 0 : _p.PasswordInput }),
                passwordError && (react_1.default.createElement(Alert_1.Alert, { appearance: (_q = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _q === void 0 ? void 0 : _q.ErrorMessage, type: "error" }, passwordError))),
            react_1.default.createElement(Button_1.Button, { loading: loading, appearance: (_r = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _r === void 0 ? void 0 : _r.SubmitButton, type: "submit" }, ((_s = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _s === void 0 ? void 0 : _s.submitButtonText) || "Sign Up"),
            error && (react_1.default.createElement(Alert_1.Alert, { appearance: (_t = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _t === void 0 ? void 0 : _t.ErrorMessage, type: "error" }, error)))));
};
const BottomLinks = ({ onRedirectToLogin, appearance }) => {
    var _a;
    return (react_1.default.createElement("div", { "data-contain": "link" }, onRedirectToLogin && (react_1.default.createElement(AnchorButton_1.AnchorButton, { onClick: onRedirectToLogin, appearance: (_a = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _a === void 0 ? void 0 : _a.RedirectToLoginLink }, `Already have an account? Log in`))));
};
exports["default"] = (0, withConfig_1.withConfig)(Signup);


/***/ }),

/***/ "./src/components/UpdatePassword.tsx":
/*!*******************************************!*\
  !*** ./src/components/UpdatePassword.tsx ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const Alert_1 = __webpack_require__(/*! ../elements/Alert */ "./src/elements/Alert.tsx");
const Button_1 = __webpack_require__(/*! ../elements/Button */ "./src/elements/Button.tsx");
const Container_1 = __webpack_require__(/*! ../elements/Container */ "./src/elements/Container.tsx");
const H3_1 = __webpack_require__(/*! ../elements/H3 */ "./src/elements/H3.tsx");
const Image_1 = __webpack_require__(/*! ../elements/Image */ "./src/elements/Image.tsx");
const Input_1 = __webpack_require__(/*! ../elements/Input */ "./src/elements/Input.tsx");
const Label_1 = __webpack_require__(/*! ../elements/Label */ "./src/elements/Label.tsx");
const useApi_1 = __webpack_require__(/*! ../useApi */ "./src/useApi.tsx");
const useRedirectFunctions_1 = __webpack_require__(/*! ../useRedirectFunctions */ "./src/useRedirectFunctions.tsx");
const withConfig_1 = __webpack_require__(/*! ../withConfig */ "./src/withConfig.tsx");
const constants_1 = __webpack_require__(/*! ./constants */ "./src/components/constants.ts");
const ErrorMessage_1 = __webpack_require__(/*! ./ErrorMessage */ "./src/components/ErrorMessage.tsx");
const Loading_1 = __webpack_require__(/*! ./Loading */ "./src/components/Loading.tsx");
const UpdatePassword = ({ onStepCompleted, appearance, testMode, config }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { userApi, loginApi } = (0, useApi_1.useApi)();
    const [currentPassword, setCurrentPassword] = (0, react_1.useState)("");
    const [password, setPassword] = (0, react_1.useState)("");
    const [optionsLoading, setOptionsLoading] = (0, react_1.useState)(false);
    const [optionsError, setOptionsError] = (0, react_1.useState)(undefined);
    const [hasPassword, setHasPassword] = (0, react_1.useState)(false);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(undefined);
    const { redirectToLoginPage } = (0, useRedirectFunctions_1.useRedirectFunctions)();
    (0, react_1.useEffect)(() => {
        let mounted = true;
        if (!testMode) {
            setOptionsError(undefined);
            setOptionsLoading(true);
            userApi
                .fetchPasswordOptions()
                .then((response) => {
                if (mounted) {
                    if (response.ok) {
                        setHasPassword(response.body.hasPassword);
                    }
                    else {
                        response.error._visit({
                            unauthorized: redirectToLoginPage,
                            _other: () => setOptionsError(constants_1.UNEXPECTED_ERROR),
                        });
                    }
                }
            })
                .catch((e) => {
                setOptionsError(constants_1.UNEXPECTED_ERROR);
                console.error(e);
            })
                .finally(() => setOptionsLoading(false));
        }
        return () => {
            mounted = false;
        };
    }, []);
    function handleSubmit(event) {
        return __awaiter(this, void 0, void 0, function* () {
            event.preventDefault();
            if (testMode) {
                alert("You are currently in test mode. Remove the `overrideCurrentScreenForTesting` prop to update your password.");
                return;
            }
            try {
                setError(undefined);
                setLoading(true);
                let options = {
                    password,
                    xCsrfToken: constants_1.X_CSRF_TOKEN,
                };
                if (hasPassword) {
                    options.currentPassword = currentPassword;
                }
                const res = yield userApi.updatePassword(options);
                if (res.ok) {
                    const status = yield loginApi.fetchLoginState();
                    if (status.ok) {
                        onStepCompleted();
                    }
                    else {
                        setError(constants_1.UNEXPECTED_ERROR);
                    }
                }
                else {
                    res.error._visit({
                        incorrectPassword: () => setError(constants_1.INCORRECT_PASSWORD),
                        badRequestUpdatePassword: (err) => {
                            if (err.currentPassword || err.password) {
                                if (err.currentPassword) {
                                    setError(err.currentPassword.join(", "));
                                }
                                if (err.password) {
                                    setError(err.password.join(", "));
                                }
                            }
                            else {
                                setError(constants_1.BAD_REQUEST);
                            }
                        },
                        unauthorized: redirectToLoginPage,
                        _other: () => setError(constants_1.UNEXPECTED_ERROR),
                    });
                }
            }
            catch (e) {
                setError(constants_1.UNEXPECTED_ERROR);
                console.error(e);
            }
            finally {
                setLoading(false);
            }
        });
    }
    if (optionsLoading) {
        return react_1.default.createElement(Loading_1.Loading, { appearance: appearance });
    }
    else if (optionsError) {
        return react_1.default.createElement(ErrorMessage_1.ErrorMessage, { errorMessage: optionsError, appearance: appearance });
    }
    return (react_1.default.createElement("div", { "data-contain": "component" },
        react_1.default.createElement(Container_1.Container, { appearance: (_a = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _a === void 0 ? void 0 : _a.Container },
            ((_b = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _b === void 0 ? void 0 : _b.displayLogo) && (react_1.default.createElement("div", { "data-contain": "logo" },
                react_1.default.createElement(Image_1.Image, { src: config.logoUrl, alt: config.siteDisplayName, appearance: (_c = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _c === void 0 ? void 0 : _c.Logo }))),
            react_1.default.createElement("div", { "data-contain": "header" },
                react_1.default.createElement(H3_1.H3, { appearance: (_d = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _d === void 0 ? void 0 : _d.Header }, `Update your password`)),
            react_1.default.createElement("div", { "data-contain": "form" },
                react_1.default.createElement("form", { onSubmit: handleSubmit },
                    hasPassword && (react_1.default.createElement("div", null,
                        react_1.default.createElement(Label_1.Label, { htmlFor: "current_password", appearance: (_e = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _e === void 0 ? void 0 : _e.CurrentPasswordLabel }, `Current Password`),
                        react_1.default.createElement(Input_1.Input, { id: "current_password", type: "password", value: currentPassword, onChange: (e) => setCurrentPassword(e.target.value), appearance: (_f = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _f === void 0 ? void 0 : _f.CurrentPasswordInput }))),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Label_1.Label, { htmlFor: "new_password", appearance: (_g = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _g === void 0 ? void 0 : _g.PasswordLabel }, `Password`),
                        react_1.default.createElement(Input_1.Input, { id: "new_password", type: "password", value: password, onChange: (e) => setPassword(e.target.value), appearance: (_h = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _h === void 0 ? void 0 : _h.PasswordInput })),
                    react_1.default.createElement(Button_1.Button, { loading: loading, appearance: (_j = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _j === void 0 ? void 0 : _j.SubmitButton, type: "submit" }, ((_k = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _k === void 0 ? void 0 : _k.SubmitButtonText) || "Continue"),
                    error && (react_1.default.createElement(Alert_1.Alert, { appearance: (_l = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _l === void 0 ? void 0 : _l.ErrorMessage, type: "error" }, error)))))));
};
exports["default"] = (0, withConfig_1.withConfig)(UpdatePassword);


/***/ }),

/***/ "./src/components/VerifyMfa.tsx":
/*!**************************************!*\
  !*** ./src/components/VerifyMfa.tsx ***!
  \**************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const Alert_1 = __webpack_require__(/*! ../elements/Alert */ "./src/elements/Alert.tsx");
const AnchorButton_1 = __webpack_require__(/*! ../elements/AnchorButton */ "./src/elements/AnchorButton.tsx");
const Button_1 = __webpack_require__(/*! ../elements/Button */ "./src/elements/Button.tsx");
const Container_1 = __webpack_require__(/*! ../elements/Container */ "./src/elements/Container.tsx");
const H3_1 = __webpack_require__(/*! ../elements/H3 */ "./src/elements/H3.tsx");
const Image_1 = __webpack_require__(/*! ../elements/Image */ "./src/elements/Image.tsx");
const Input_1 = __webpack_require__(/*! ../elements/Input */ "./src/elements/Input.tsx");
const Label_1 = __webpack_require__(/*! ../elements/Label */ "./src/elements/Label.tsx");
const useApi_1 = __webpack_require__(/*! ../useApi */ "./src/useApi.tsx");
const useRedirectFunctions_1 = __webpack_require__(/*! ../useRedirectFunctions */ "./src/useRedirectFunctions.tsx");
const withConfig_1 = __webpack_require__(/*! ../withConfig */ "./src/withConfig.tsx");
const constants_1 = __webpack_require__(/*! ./constants */ "./src/components/constants.ts");
const VerifyMfa = ({ onStepCompleted, appearance, testMode, config }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { mfaApi } = (0, useApi_1.useApi)();
    const { redirectToLoginPage } = (0, useRedirectFunctions_1.useRedirectFunctions)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [code, setCode] = (0, react_1.useState)("");
    const [useBackupCode, setUseBackupCode] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(undefined);
    const codeLabel = `Enter the 6 digit code generated by your authenticator app:`;
    const backupCodeLabel = `Enter an unused backup code:`;
    const inputLabel = useBackupCode ? backupCodeLabel : codeLabel;
    const codeButtonText = `Enter a code from your authenticator app`;
    const backupCodeButtonText = `Lost your device? Enter a backup code`;
    const buttonText = useBackupCode ? codeButtonText : backupCodeButtonText;
    function toggleCodeType(e) {
        e.preventDefault();
        setError(undefined);
        setCode("");
        setUseBackupCode(!useBackupCode);
    }
    function verifyMfa(e) {
        return __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            if (testMode) {
                alert("You are currently in test mode. Remove the `overrideCurrentScreenForTesting` prop to verify.");
                return;
            }
            try {
                setError(undefined);
                setLoading(true);
                if (useBackupCode) {
                    const backupResponse = yield mfaApi.mfaVerifyBackup({ code, xCsrfToken: constants_1.X_CSRF_TOKEN });
                    if (backupResponse.ok) {
                        onStepCompleted();
                    }
                    else {
                        backupResponse.error._visit({
                            incorrectMfaCode: () => setError(constants_1.INCORRECT_MFA_CODE),
                            mfaTimedOut: () => setError(constants_1.MFA_TIMED_OUT),
                            badRequestMfaVerify: (err) => { var _a; return setError(((_a = err.code) === null || _a === void 0 ? void 0 : _a.join(", ")) || constants_1.BAD_REQUEST); },
                            _other: () => setError(constants_1.UNEXPECTED_ERROR),
                        });
                    }
                }
                else {
                    const codeResponse = yield mfaApi.mfaVerify({ code, xCsrfToken: constants_1.X_CSRF_TOKEN });
                    if (codeResponse.ok) {
                        onStepCompleted();
                    }
                    else {
                        codeResponse.error._visit({
                            incorrectMfaCode: () => setError(constants_1.INCORRECT_MFA_CODE),
                            mfaTimedOut: () => setError(constants_1.MFA_TIMED_OUT),
                            badRequestMfaVerify: (err) => { var _a; return setError(((_a = err.code) === null || _a === void 0 ? void 0 : _a.join(", ")) || constants_1.BAD_REQUEST); },
                            _other: () => setError(constants_1.UNEXPECTED_ERROR),
                        });
                    }
                }
            }
            catch (e) {
                setError(constants_1.UNEXPECTED_ERROR);
                console.error(e);
            }
            finally {
                setLoading(false);
            }
        });
    }
    return (react_1.default.createElement("div", { "data-contain": "component" },
        react_1.default.createElement(Container_1.Container, { appearance: (_a = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _a === void 0 ? void 0 : _a.Container },
            ((_b = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _b === void 0 ? void 0 : _b.displayLogo) && (react_1.default.createElement("div", { "data-contain": "logo" },
                react_1.default.createElement(Image_1.Image, { src: config.logoUrl, alt: config.siteDisplayName, appearance: (_c = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _c === void 0 ? void 0 : _c.Logo }))),
            react_1.default.createElement("div", { "data-contain": "header" },
                react_1.default.createElement(H3_1.H3, { appearance: (_d = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _d === void 0 ? void 0 : _d.Header }, `Verify with ${useBackupCode ? "your backup code" : "2FA"}`)),
            react_1.default.createElement("div", { "data-contain": "form" },
                react_1.default.createElement("form", { onSubmit: verifyMfa },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Label_1.Label, { htmlFor: "code", appearance: (_e = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _e === void 0 ? void 0 : _e.CodeLabel }, inputLabel),
                        react_1.default.createElement(Input_1.Input, { id: "code", type: useBackupCode ? "text" : "number", placeholder: "123456", value: code, onChange: (e) => setCode(e.target.value), appearance: (_f = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _f === void 0 ? void 0 : _f.CodeInput })),
                    react_1.default.createElement(Button_1.Button, { loading: loading, appearance: (_g = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _g === void 0 ? void 0 : _g.SubmitButton, type: "submit" }, ((_h = appearance === null || appearance === void 0 ? void 0 : appearance.options) === null || _h === void 0 ? void 0 : _h.submitButtonText) || "Submit"),
                    error && (react_1.default.createElement(Alert_1.Alert, { appearance: (_j = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _j === void 0 ? void 0 : _j.ErrorMessage, type: "error" }, error)))),
            react_1.default.createElement("div", { "data-contain": "link" },
                react_1.default.createElement(AnchorButton_1.AnchorButton, { onClick: toggleCodeType, appearance: (_k = appearance === null || appearance === void 0 ? void 0 : appearance.elements) === null || _k === void 0 ? void 0 : _k.CodeOrBackupToggle }, buttonText)))));
};
exports["default"] = (0, withConfig_1.withConfig)(VerifyMfa);


/***/ }),

/***/ "./src/components/constants.ts":
/*!*************************************!*\
  !*** ./src/components/constants.ts ***!
  \*************************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NO_SSO_URL = exports.NO_PASSWORDLESS_URL = exports.MFA_TIMED_OUT = exports.INCORRECT_MFA_CODE = exports.ORGS_NOT_ENABLED = exports.INCORRECT_PASSWORD = exports.RATE_LIMIT_EMAIL_CONFIRMATION = exports.ORG_NAME_NOT_FOUND = exports.COMPLETE_ACCOUNT_TEXT = exports.RESEND_CONFIRM_EMAIL_MESSAGE = exports.PASSWORDLESS_LOGIN_SUBMITTED = exports.PASSWORDLESS_LOGIN_SUBMITTED_PUBLIC = exports.BAD_REQUEST = exports.X_CSRF_TOKEN = exports.SIGNUP_NOT_ALLOWED = exports.NO_ACCOUNT_FOUND_WITH_CREDENTIALS = exports.LOGIN_PASSWORDLESS_NOT_SUPPORTED = exports.ORG_CREATION_NOT_ENABLED = exports.PASSWORDLESS_MESSAGE = exports.FORGOT_PASSWORD_MESSAGE = exports.CONFIRM_EMAIL_MESSAGE = exports.FORGOT_PASSWORD_SUCCESS = exports.MAGIC_LINK_SUCCESS = exports.UNEXPECTED_ERROR = void 0;
exports.UNEXPECTED_ERROR = "An unexpected error occurred. Please try again.";
exports.MAGIC_LINK_SUCCESS = `If that email address is in our database, we will send you an email to login to your account.`;
exports.FORGOT_PASSWORD_SUCCESS = `If that email address is in our database, we will send you an email to reset your password.`;
exports.CONFIRM_EMAIL_MESSAGE = "You should receive an email with a link to confirm your email address within the next few minutes. If you do not receive an email, make sure to check your spam.";
exports.FORGOT_PASSWORD_MESSAGE = "Enter your email address and we will send you an email with a link that will let you reset your password.";
exports.PASSWORDLESS_MESSAGE = "You can choose between receiving an email to reset your password or receiving an email with a magic link that will log you in.";
exports.ORG_CREATION_NOT_ENABLED = "Organization creation not enabled.";
exports.LOGIN_PASSWORDLESS_NOT_SUPPORTED = "Passwordless login not supported.";
exports.NO_ACCOUNT_FOUND_WITH_CREDENTIALS = "No account found with those credentials.";
exports.SIGNUP_NOT_ALLOWED = "Signups are disabled.";
exports.X_CSRF_TOKEN = "-.-";
exports.BAD_REQUEST = "Invalid request";
exports.PASSWORDLESS_LOGIN_SUBMITTED_PUBLIC = `We sent you an email with a link that will sign you in. The link will expire in one hour, so be sure to use it soon. You can close this tab.`;
exports.PASSWORDLESS_LOGIN_SUBMITTED = `If an account already exists with that email address, we will send you a link to sign you in. The link will expire in one hour, so be sure to use it soon. You can close this tab.`;
exports.RESEND_CONFIRM_EMAIL_MESSAGE = "Confirmation email sent successfully.";
exports.COMPLETE_ACCOUNT_TEXT = "We need a little more information to complete your account.";
exports.ORG_NAME_NOT_FOUND = "Name not found.";
exports.RATE_LIMIT_EMAIL_CONFIRMATION = "Please wait, it may take a few minutes to receive your confirmation email";
exports.INCORRECT_PASSWORD = "Incorrect password";
exports.ORGS_NOT_ENABLED = "Organizations are not enabled.";
exports.INCORRECT_MFA_CODE = "Incorrect code";
exports.MFA_TIMED_OUT = "Code expired";
exports.NO_PASSWORDLESS_URL = `Passwordless login is enabled for your project. The LoginPasswordless component is used to handle those cases. Please implement onRedirectToPasswordlessLogin and have it redirect to the page with a LoginPasswordless component.`;
exports.NO_SSO_URL = `Login with SSO is enabled for your project. The LoginSSO component is used to handle those cases. Please implement onRedirectToSSOLogin and have it redirect to the page with a LoginSSO component.`;


/***/ }),

/***/ "./src/components/helpers.ts":
/*!***********************************!*\
  !*** ./src/components/helpers.ts ***!
  \***********************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.withHttp = exports.threeDaysFromNow = void 0;
function threeDaysFromNow() {
    return Math.round(Date.now() / 1000) + 24 * 60 * 60 * 3;
}
exports.threeDaysFromNow = threeDaysFromNow;
function withHttp(url) {
    if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
        return url;
    }
    else {
        return "https://" + url;
    }
}
exports.withHttp = withHttp;


/***/ }),

/***/ "./src/elements/Alert.tsx":
/*!********************************!*\
  !*** ./src/elements/Alert.tsx ***!
  \********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Alert = void 0;
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const AppearanceProvider_1 = __webpack_require__(/*! ../AppearanceProvider */ "./src/AppearanceProvider.tsx");
const ElementsProvider_1 = __webpack_require__(/*! ../ElementsProvider */ "./src/ElementsProvider.tsx");
const utils_1 = __webpack_require__(/*! ./utils */ "./src/elements/utils.ts");
exports.Alert = (0, react_1.forwardRef)((props, ref) => {
    var _a;
    const { elements } = (0, ElementsProvider_1.useElements)();
    const { appearance } = (0, AppearanceProvider_1.useAppearance)();
    const { classes, styles, Override } = (0, utils_1.mergeProps)({
        appearance: props.appearance,
        element: (_a = appearance.elements) === null || _a === void 0 ? void 0 : _a.Alert,
    });
    if (Override === null) {
        return null;
    }
    else if (Override) {
        return (react_1.default.createElement(Override, { type: props.type, className: classes, style: styles }, props.children));
    }
    return (react_1.default.createElement(elements.Alert, { ref: ref, type: props.type, className: classes, style: styles }, props.children));
});


/***/ }),

/***/ "./src/elements/AnchorButton.tsx":
/*!***************************************!*\
  !*** ./src/elements/AnchorButton.tsx ***!
  \***************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AnchorButton = void 0;
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const AppearanceProvider_1 = __webpack_require__(/*! ../AppearanceProvider */ "./src/AppearanceProvider.tsx");
const ElementsProvider_1 = __webpack_require__(/*! ../ElementsProvider */ "./src/ElementsProvider.tsx");
const utils_1 = __webpack_require__(/*! ./utils */ "./src/elements/utils.ts");
exports.AnchorButton = (0, react_1.forwardRef)((props, ref) => {
    var _a;
    const { elements } = (0, ElementsProvider_1.useElements)();
    const { appearance } = (0, AppearanceProvider_1.useAppearance)();
    const { classes, styles, Override } = (0, utils_1.mergeProps)({
        appearance: props.appearance,
        element: (_a = appearance.elements) === null || _a === void 0 ? void 0 : _a.AnchorButton,
    });
    if (Override === null) {
        return null;
    }
    else if (Override) {
        return (react_1.default.createElement(Override, { loading: props.loading, disabled: props.disabled, onClick: props.onClick, id: props.id, className: classes, style: styles }, props.children));
    }
    return (react_1.default.createElement(elements.AnchorButton, { ref: ref, loading: props.loading, disabled: props.disabled, onClick: props.onClick, id: props.id, className: classes, style: styles }, props.children));
});


/***/ }),

/***/ "./src/elements/Button.tsx":
/*!*********************************!*\
  !*** ./src/elements/Button.tsx ***!
  \*********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Button = void 0;
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const AppearanceProvider_1 = __webpack_require__(/*! ../AppearanceProvider */ "./src/AppearanceProvider.tsx");
const ElementsProvider_1 = __webpack_require__(/*! ../ElementsProvider */ "./src/ElementsProvider.tsx");
const utils_1 = __webpack_require__(/*! ./utils */ "./src/elements/utils.ts");
exports.Button = (0, react_1.forwardRef)((props, ref) => {
    var _a;
    const { elements } = (0, ElementsProvider_1.useElements)();
    const { appearance } = (0, AppearanceProvider_1.useAppearance)();
    const { classes, styles, Override } = (0, utils_1.mergeProps)({
        appearance: props.appearance,
        element: (_a = appearance.elements) === null || _a === void 0 ? void 0 : _a.Button,
    });
    if (Override === null) {
        return null;
    }
    else if (Override) {
        return (react_1.default.createElement(Override, { loading: props.loading, disabled: props.disabled, onClick: props.onClick, id: props.id, className: classes, style: styles }, props.children));
    }
    return (react_1.default.createElement(elements.Button, { ref: ref, loading: props.loading, disabled: props.disabled, onClick: props.onClick, id: props.id, className: classes, style: styles }, props.children));
});


/***/ }),

/***/ "./src/elements/Checkbox.tsx":
/*!***********************************!*\
  !*** ./src/elements/Checkbox.tsx ***!
  \***********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Checkbox = void 0;
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const AppearanceProvider_1 = __webpack_require__(/*! ../AppearanceProvider */ "./src/AppearanceProvider.tsx");
const ElementsProvider_1 = __webpack_require__(/*! ../ElementsProvider */ "./src/ElementsProvider.tsx");
const utils_1 = __webpack_require__(/*! ./utils */ "./src/elements/utils.ts");
exports.Checkbox = (0, react_1.forwardRef)((props, ref) => {
    var _a;
    const { elements } = (0, ElementsProvider_1.useElements)();
    const { appearance } = (0, AppearanceProvider_1.useAppearance)();
    const { classes, styles, Override } = (0, utils_1.mergeProps)({
        appearance: props.appearance,
        element: (_a = appearance.elements) === null || _a === void 0 ? void 0 : _a.Checkbox,
    });
    if (Override === null) {
        return null;
    }
    else if (Override) {
        return (react_1.default.createElement(Override, { id: props.id, label: props.label, required: props.required, disabled: props.disabled, checked: props.checked, onChange: props.onChange, className: classes, style: styles }));
    }
    return (react_1.default.createElement(elements.Checkbox, { ref: ref, id: props.id, label: props.label, required: props.required, disabled: props.disabled, checked: props.checked, onChange: props.onChange, className: classes, style: styles }));
});


/***/ }),

/***/ "./src/elements/Container.tsx":
/*!************************************!*\
  !*** ./src/elements/Container.tsx ***!
  \************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Container = void 0;
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const AppearanceProvider_1 = __webpack_require__(/*! ../AppearanceProvider */ "./src/AppearanceProvider.tsx");
const ElementsProvider_1 = __webpack_require__(/*! ../ElementsProvider */ "./src/ElementsProvider.tsx");
const utils_1 = __webpack_require__(/*! ./utils */ "./src/elements/utils.ts");
exports.Container = (0, react_1.forwardRef)((props, ref) => {
    var _a;
    const { elements } = (0, ElementsProvider_1.useElements)();
    const { appearance } = (0, AppearanceProvider_1.useAppearance)();
    const { classes, styles, Override } = (0, utils_1.mergeProps)({
        appearance: props.appearance,
        element: (_a = appearance.elements) === null || _a === void 0 ? void 0 : _a.Container,
    });
    if (Override === null) {
        return react_1.default.createElement(react_1.default.Fragment, null, props.children);
    }
    else if (Override) {
        return (react_1.default.createElement(Override, { className: classes, style: styles }, props.children));
    }
    return (react_1.default.createElement(elements.Container, { ref: ref, className: classes, style: styles }, props.children));
});


/***/ }),

/***/ "./src/elements/Divider.tsx":
/*!**********************************!*\
  !*** ./src/elements/Divider.tsx ***!
  \**********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Divider = void 0;
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const AppearanceProvider_1 = __webpack_require__(/*! ../AppearanceProvider */ "./src/AppearanceProvider.tsx");
const ElementsProvider_1 = __webpack_require__(/*! ../ElementsProvider */ "./src/ElementsProvider.tsx");
const utils_1 = __webpack_require__(/*! ./utils */ "./src/elements/utils.ts");
exports.Divider = (0, react_1.forwardRef)((props, ref) => {
    var _a;
    const { elements } = (0, ElementsProvider_1.useElements)();
    const { appearance } = (0, AppearanceProvider_1.useAppearance)();
    const { classes, styles, Override } = (0, utils_1.mergeProps)({
        appearance: props.appearance,
        element: (_a = appearance.elements) === null || _a === void 0 ? void 0 : _a.Divider,
    });
    if (Override === null) {
        return null;
    }
    else if (Override) {
        return (react_1.default.createElement(Override, { className: classes, style: styles }, props.children));
    }
    return (react_1.default.createElement(elements.Divider, { ref: ref, className: classes, style: styles }, props.children));
});


/***/ }),

/***/ "./src/elements/H3.tsx":
/*!*****************************!*\
  !*** ./src/elements/H3.tsx ***!
  \*****************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.H3 = void 0;
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const AppearanceProvider_1 = __webpack_require__(/*! ../AppearanceProvider */ "./src/AppearanceProvider.tsx");
const ElementsProvider_1 = __webpack_require__(/*! ../ElementsProvider */ "./src/ElementsProvider.tsx");
const utils_1 = __webpack_require__(/*! ./utils */ "./src/elements/utils.ts");
exports.H3 = (0, react_1.forwardRef)((props, ref) => {
    var _a;
    const { elements } = (0, ElementsProvider_1.useElements)();
    const { appearance } = (0, AppearanceProvider_1.useAppearance)();
    const { classes, styles, Override } = (0, utils_1.mergeProps)({
        appearance: props.appearance,
        element: (_a = appearance.elements) === null || _a === void 0 ? void 0 : _a.H3,
    });
    if (Override === null) {
        return null;
    }
    else if (Override) {
        return (react_1.default.createElement(Override, { className: classes, style: styles }, props.children));
    }
    return (react_1.default.createElement(elements.H3, { ref: ref, className: classes, style: styles }, props.children));
});


/***/ }),

/***/ "./src/elements/Image.tsx":
/*!********************************!*\
  !*** ./src/elements/Image.tsx ***!
  \********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Image = void 0;
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const AppearanceProvider_1 = __webpack_require__(/*! ../AppearanceProvider */ "./src/AppearanceProvider.tsx");
const ElementsProvider_1 = __webpack_require__(/*! ../ElementsProvider */ "./src/ElementsProvider.tsx");
const utils_1 = __webpack_require__(/*! ./utils */ "./src/elements/utils.ts");
exports.Image = (0, react_1.forwardRef)((props, ref) => {
    var _a;
    const { elements } = (0, ElementsProvider_1.useElements)();
    const { appearance } = (0, AppearanceProvider_1.useAppearance)();
    const { classes, styles, Override } = (0, utils_1.mergeProps)({
        appearance: props.appearance,
        element: (_a = appearance.elements) === null || _a === void 0 ? void 0 : _a.Image,
    });
    if (Override === null) {
        return null;
    }
    else if (Override) {
        return react_1.default.createElement(Override, { src: props.src, alt: props.alt, className: classes, style: styles });
    }
    return react_1.default.createElement(elements.Image, { ref: ref, src: props.src, alt: props.alt, className: classes, style: styles });
});


/***/ }),

/***/ "./src/elements/Input.tsx":
/*!********************************!*\
  !*** ./src/elements/Input.tsx ***!
  \********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Input = void 0;
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const AppearanceProvider_1 = __webpack_require__(/*! ../AppearanceProvider */ "./src/AppearanceProvider.tsx");
const ElementsProvider_1 = __webpack_require__(/*! ../ElementsProvider */ "./src/ElementsProvider.tsx");
const utils_1 = __webpack_require__(/*! ./utils */ "./src/elements/utils.ts");
exports.Input = (0, react_1.forwardRef)((props, ref) => {
    var _a;
    const { elements } = (0, ElementsProvider_1.useElements)();
    const { appearance } = (0, AppearanceProvider_1.useAppearance)();
    const { classes, styles, Override } = (0, utils_1.mergeProps)({
        appearance: props.appearance,
        element: (_a = appearance.elements) === null || _a === void 0 ? void 0 : _a.Input,
    });
    if (Override === null) {
        return null;
    }
    else if (Override) {
        return (react_1.default.createElement(Override, { id: props.id, type: props.type, required: props.required, disabled: props.disabled, value: props.value, placeholder: props.placeholder, onChange: props.onChange, className: classes, style: styles }));
    }
    return (react_1.default.createElement(elements.Input, { ref: ref, id: props.id, type: props.type, required: props.required, disabled: props.disabled, value: props.value, placeholder: props.placeholder, onChange: props.onChange, className: classes, style: styles }));
});


/***/ }),

/***/ "./src/elements/Label.tsx":
/*!********************************!*\
  !*** ./src/elements/Label.tsx ***!
  \********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Label = void 0;
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const AppearanceProvider_1 = __webpack_require__(/*! ../AppearanceProvider */ "./src/AppearanceProvider.tsx");
const ElementsProvider_1 = __webpack_require__(/*! ../ElementsProvider */ "./src/ElementsProvider.tsx");
const utils_1 = __webpack_require__(/*! ./utils */ "./src/elements/utils.ts");
exports.Label = (0, react_1.forwardRef)((props, ref) => {
    var _a;
    const { elements } = (0, ElementsProvider_1.useElements)();
    const { appearance } = (0, AppearanceProvider_1.useAppearance)();
    const { classes, styles, Override } = (0, utils_1.mergeProps)({
        appearance: props.appearance,
        element: (_a = appearance.elements) === null || _a === void 0 ? void 0 : _a.Label,
    });
    if (Override === null) {
        return null;
    }
    else if (Override) {
        return (react_1.default.createElement(Override, { htmlFor: props.htmlFor, className: classes, style: styles }, props.children));
    }
    return (react_1.default.createElement(elements.Label, { ref: ref, htmlFor: props.htmlFor, className: classes, style: styles }, props.children));
});


/***/ }),

/***/ "./src/elements/Loader.tsx":
/*!*********************************!*\
  !*** ./src/elements/Loader.tsx ***!
  \*********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Loader = void 0;
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const AppearanceProvider_1 = __webpack_require__(/*! ../AppearanceProvider */ "./src/AppearanceProvider.tsx");
const ElementsProvider_1 = __webpack_require__(/*! ../ElementsProvider */ "./src/ElementsProvider.tsx");
const utils_1 = __webpack_require__(/*! ./utils */ "./src/elements/utils.ts");
exports.Loader = (0, react_1.forwardRef)((props, ref) => {
    var _a;
    const { elements } = (0, ElementsProvider_1.useElements)();
    const { appearance } = (0, AppearanceProvider_1.useAppearance)();
    const { classes, styles, Override } = (0, utils_1.mergeProps)({
        appearance: props.appearance,
        element: (_a = appearance.elements) === null || _a === void 0 ? void 0 : _a.Loader,
    });
    if (Override === null) {
        return null;
    }
    else if (Override) {
        return react_1.default.createElement(Override, { className: classes, style: styles });
    }
    return react_1.default.createElement(elements.Loader, { ref: ref, className: classes, style: styles });
});


/***/ }),

/***/ "./src/elements/Paragraph.tsx":
/*!************************************!*\
  !*** ./src/elements/Paragraph.tsx ***!
  \************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Paragraph = void 0;
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const AppearanceProvider_1 = __webpack_require__(/*! ../AppearanceProvider */ "./src/AppearanceProvider.tsx");
const ElementsProvider_1 = __webpack_require__(/*! ../ElementsProvider */ "./src/ElementsProvider.tsx");
const utils_1 = __webpack_require__(/*! ./utils */ "./src/elements/utils.ts");
exports.Paragraph = (0, react_1.forwardRef)((props, ref) => {
    var _a;
    const { elements } = (0, ElementsProvider_1.useElements)();
    const { appearance } = (0, AppearanceProvider_1.useAppearance)();
    const { classes, styles, Override } = (0, utils_1.mergeProps)({
        appearance: props.appearance,
        element: (_a = appearance.elements) === null || _a === void 0 ? void 0 : _a.Paragraph,
    });
    if (Override === null) {
        return null;
    }
    else if (Override) {
        return (react_1.default.createElement(Override, { className: classes, style: styles }, props.children));
    }
    return (react_1.default.createElement(elements.Paragraph, { ref: ref, className: classes, style: styles }, props.children));
});


/***/ }),

/***/ "./src/elements/Select.tsx":
/*!*********************************!*\
  !*** ./src/elements/Select.tsx ***!
  \*********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Select = void 0;
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const AppearanceProvider_1 = __webpack_require__(/*! ../AppearanceProvider */ "./src/AppearanceProvider.tsx");
const ElementsProvider_1 = __webpack_require__(/*! ../ElementsProvider */ "./src/ElementsProvider.tsx");
const utils_1 = __webpack_require__(/*! ./utils */ "./src/elements/utils.ts");
exports.Select = (0, react_1.forwardRef)((props, ref) => {
    var _a;
    const { elements } = (0, ElementsProvider_1.useElements)();
    const { appearance } = (0, AppearanceProvider_1.useAppearance)();
    const { classes, styles, Override } = (0, utils_1.mergeProps)({
        appearance: props.appearance,
        element: (_a = appearance.elements) === null || _a === void 0 ? void 0 : _a.Select,
    });
    if (Override === null) {
        return null;
    }
    else if (Override) {
        return (react_1.default.createElement(Override, { value: props.value, onChange: props.onChange, options: props.options, disabled: props.disabled, id: props.id, className: classes, style: styles }));
    }
    return (react_1.default.createElement(elements.Select, { ref: ref, value: props.value, onChange: props.onChange, options: props.options, disabled: props.disabled, id: props.id, className: classes, style: styles }));
});


/***/ }),

/***/ "./src/elements/utils.ts":
/*!*******************************!*\
  !*** ./src/elements/utils.ts ***!
  \*******************************/
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.mergeProps = exports.joinStyles = exports.joinClasses = exports.getPropsFromAppearance = void 0;
function getPropsFromAppearance(appearance) {
    if (appearance === null) {
        return { classes: undefined, styles: undefined, Element: null };
    }
    switch (typeof appearance) {
        case "string":
            return { classes: appearance, styles: undefined, Element: undefined };
        case "object":
            return { classes: undefined, styles: appearance, Element: undefined };
        case "function":
            return { classes: undefined, styles: undefined, Element: appearance };
        default:
            return { classes: undefined, styles: undefined, Element: undefined };
    }
}
exports.getPropsFromAppearance = getPropsFromAppearance;
function joinClasses(x, y) {
    if (!x && !y) {
        return undefined;
    }
    if (!x) {
        return y;
    }
    if (!y) {
        return x;
    }
    return x + " " + y;
}
exports.joinClasses = joinClasses;
function joinStyles(x, y) {
    if (!x && !y) {
        return undefined;
    }
    if (!x) {
        return y;
    }
    if (!y) {
        return x;
    }
    return Object.assign(Object.assign({}, x), y);
}
exports.joinStyles = joinStyles;
function overrideElement(localElement, globalElement) {
    if (localElement === null) {
        return null;
    }
    else if (localElement) {
        return localElement;
    }
    else if (globalElement === null) {
        return null;
    }
    else if (globalElement) {
        return globalElement;
    }
    else {
        return undefined;
    }
}
function mergeProps({ appearance, element }) {
    const globalProps = getPropsFromAppearance(element);
    const localProps = getPropsFromAppearance(appearance);
    const classes = joinClasses(globalProps.classes, localProps.classes);
    const styles = joinStyles(globalProps.styles, localProps.styles);
    const Override = overrideElement(localProps.Element, globalProps.Element);
    return { classes, styles, Override };
}
exports.mergeProps = mergeProps;


/***/ }),

/***/ "./src/index.tsx":
/*!***********************!*\
  !*** ./src/index.tsx ***!
  \***********************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LoginSSO = exports.LoginPasswordless = exports.ForgotPassword = exports.LoginManager = exports.Signup = exports.withRequiredAuthInfo = exports.withAuthInfo = exports.useRedirectFunctions = exports.RedirectToSignup = exports.RedirectToLogin = exports.useLogoutFunction = exports.useAuthInfo = exports.useActiveOrg = exports.saveOrgSelectionToLocalStorage = exports.loadOrgSelectionFromLocalStorage = exports.BetaComponentLibraryProvider = exports.AuthProviderForTesting = exports.RequiredAuthProvider = exports.AuthProvider = exports.useOrgHelper = exports.useAccessHelper = void 0;
const ForgotPassword_1 = __importDefault(__webpack_require__(/*! ./components/ForgotPassword */ "./src/components/ForgotPassword.tsx"));
exports.ForgotPassword = ForgotPassword_1.default;
const LoginManager_1 = __importDefault(__webpack_require__(/*! ./components/LoginManager */ "./src/components/LoginManager.tsx"));
exports.LoginManager = LoginManager_1.default;
const LoginPasswordless_1 = __importDefault(__webpack_require__(/*! ./components/LoginPasswordless */ "./src/components/LoginPasswordless.tsx"));
exports.LoginPasswordless = LoginPasswordless_1.default;
const LoginSSO_1 = __importDefault(__webpack_require__(/*! ./components/LoginSSO */ "./src/components/LoginSSO.tsx"));
exports.LoginSSO = LoginSSO_1.default;
const Signup_1 = __importDefault(__webpack_require__(/*! ./components/Signup */ "./src/components/Signup.tsx"));
exports.Signup = Signup_1.default;
var additionalHooks_1 = __webpack_require__(/*! ./additionalHooks */ "./src/additionalHooks.ts");
Object.defineProperty(exports, "useAccessHelper", ({ enumerable: true, get: function () { return additionalHooks_1.useAccessHelper; } }));
Object.defineProperty(exports, "useOrgHelper", ({ enumerable: true, get: function () { return additionalHooks_1.useOrgHelper; } }));
var AuthContext_1 = __webpack_require__(/*! ./AuthContext */ "./src/AuthContext.tsx");
Object.defineProperty(exports, "AuthProvider", ({ enumerable: true, get: function () { return AuthContext_1.AuthProvider; } }));
Object.defineProperty(exports, "RequiredAuthProvider", ({ enumerable: true, get: function () { return AuthContext_1.RequiredAuthProvider; } }));
var AuthContextForTesting_1 = __webpack_require__(/*! ./AuthContextForTesting */ "./src/AuthContextForTesting.tsx");
Object.defineProperty(exports, "AuthProviderForTesting", ({ enumerable: true, get: function () { return AuthContextForTesting_1.AuthProviderForTesting; } }));
var BetaComponentLibraryProvider_1 = __webpack_require__(/*! ./BetaComponentLibraryProvider */ "./src/BetaComponentLibraryProvider.tsx");
Object.defineProperty(exports, "BetaComponentLibraryProvider", ({ enumerable: true, get: function () { return BetaComponentLibraryProvider_1.BetaComponentLibraryProvider; } }));
var useActiveOrg_1 = __webpack_require__(/*! ./useActiveOrg */ "./src/useActiveOrg.tsx");
Object.defineProperty(exports, "loadOrgSelectionFromLocalStorage", ({ enumerable: true, get: function () { return useActiveOrg_1.loadOrgSelectionFromLocalStorage; } }));
Object.defineProperty(exports, "saveOrgSelectionToLocalStorage", ({ enumerable: true, get: function () { return useActiveOrg_1.saveOrgSelectionToLocalStorage; } }));
Object.defineProperty(exports, "useActiveOrg", ({ enumerable: true, get: function () { return useActiveOrg_1.useActiveOrg; } }));
var useAuthInfo_1 = __webpack_require__(/*! ./useAuthInfo */ "./src/useAuthInfo.ts");
Object.defineProperty(exports, "useAuthInfo", ({ enumerable: true, get: function () { return useAuthInfo_1.useAuthInfo; } }));
var useLogoutFunction_1 = __webpack_require__(/*! ./useLogoutFunction */ "./src/useLogoutFunction.ts");
Object.defineProperty(exports, "useLogoutFunction", ({ enumerable: true, get: function () { return useLogoutFunction_1.useLogoutFunction; } }));
var useRedirectFunctions_1 = __webpack_require__(/*! ./useRedirectFunctions */ "./src/useRedirectFunctions.tsx");
Object.defineProperty(exports, "RedirectToLogin", ({ enumerable: true, get: function () { return useRedirectFunctions_1.RedirectToLogin; } }));
Object.defineProperty(exports, "RedirectToSignup", ({ enumerable: true, get: function () { return useRedirectFunctions_1.RedirectToSignup; } }));
Object.defineProperty(exports, "useRedirectFunctions", ({ enumerable: true, get: function () { return useRedirectFunctions_1.useRedirectFunctions; } }));
var withAuthInfo_1 = __webpack_require__(/*! ./withAuthInfo */ "./src/withAuthInfo.tsx");
Object.defineProperty(exports, "withAuthInfo", ({ enumerable: true, get: function () { return withAuthInfo_1.withAuthInfo; } }));
var withRequiredAuthInfo_1 = __webpack_require__(/*! ./withRequiredAuthInfo */ "./src/withRequiredAuthInfo.tsx");
Object.defineProperty(exports, "withRequiredAuthInfo", ({ enumerable: true, get: function () { return withRequiredAuthInfo_1.withRequiredAuthInfo; } }));


/***/ }),

/***/ "./src/useActiveOrg.tsx":
/*!******************************!*\
  !*** ./src/useActiveOrg.tsx ***!
  \******************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.loadOrgSelectionFromLocalStorage = exports.saveOrgSelectionToLocalStorage = exports.useActiveOrg = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const AuthContext_1 = __webpack_require__(/*! ./AuthContext */ "./src/AuthContext.tsx");
const ORG_SELECTION_LOCAL_STORAGE_KEY = "__last_selected_org";
function useActiveOrg() {
    const context = (0, react_1.useContext)(AuthContext_1.AuthContext);
    if (context === undefined) {
        throw new Error("useActiveOrg must be used within an AuthProvider or RequiredAuthProvider");
    }
    if (context.loading || !context.authInfo || !context.authInfo.orgHelper) {
        return null;
    }
    const proposedActiveOrgIdOrName = context.activeOrgFn();
    if (!proposedActiveOrgIdOrName) {
        return null;
    }
    const orgHelper = context.authInfo.orgHelper;
    return orgHelper.getOrg(proposedActiveOrgIdOrName) || orgHelper.getOrgByName(proposedActiveOrgIdOrName);
}
exports.useActiveOrg = useActiveOrg;
function saveOrgSelectionToLocalStorage(orgIdOrName) {
    if (localStorage) {
        localStorage.setItem(ORG_SELECTION_LOCAL_STORAGE_KEY, orgIdOrName);
    }
}
exports.saveOrgSelectionToLocalStorage = saveOrgSelectionToLocalStorage;
function loadOrgSelectionFromLocalStorage() {
    if (localStorage) {
        return localStorage.getItem(ORG_SELECTION_LOCAL_STORAGE_KEY);
    }
    return null;
}
exports.loadOrgSelectionFromLocalStorage = loadOrgSelectionFromLocalStorage;


/***/ }),

/***/ "./src/useApi.tsx":
/*!************************!*\
  !*** ./src/useApi.tsx ***!
  \************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useApi = exports.useLegacyApi = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const additionalHooks_1 = __webpack_require__(/*! ./additionalHooks */ "./src/additionalHooks.ts");
const AuthContext_1 = __webpack_require__(/*! ./AuthContext */ "./src/AuthContext.tsx");
const useLegacyApi = () => {
    const { authUrl } = (0, additionalHooks_1.useAuthUrl)();
    function apiUploadProfilePicture(formData) {
        return new Promise((resolve) => {
            const http = new XMLHttpRequest();
            http.onreadystatechange = function () {
                if (http.readyState === XMLHttpRequest.DONE) {
                    if (http.status >= 200 && http.status < 300) {
                        const jsonResponse = JSON.parse(http.response);
                        resolve({ success: true, pictureUrl: jsonResponse.picture_url });
                    }
                    else if (http.status === 400) {
                        const jsonResponseText = JSON.parse(http.responseText);
                        resolve({
                            success: false,
                            error_type: "bad_image",
                            message: jsonResponseText["file"],
                        });
                    }
                    else {
                        resolve({
                            success: false,
                            error_type: "unexpected_error",
                        });
                    }
                }
            };
            http.open("post", `${authUrl}/api/fe/v2/update_profile_image`);
            http.withCredentials = true;
            http.setRequestHeader("X-CSRF-Token", "-.-");
            http.send(formData);
        });
    }
    return { uploadProfilePicture: apiUploadProfilePicture };
};
exports.useLegacyApi = useLegacyApi;
const useApi = () => {
    const context = (0, react_1.useContext)(AuthContext_1.AuthContext);
    const legacyApi = (0, exports.useLegacyApi)();
    if (context === undefined) {
        throw new Error("useConfig must be used within an AuthProvider");
    }
    return {
        loginApi: context.api.login,
        mfaApi: context.api.mfa,
        orgApi: context.api.org,
        userApi: context.api.user,
        configApi: context.api.config,
        legacyApi: legacyApi,
    };
};
exports.useApi = useApi;


/***/ }),

/***/ "./src/useAuthInfo.ts":
/*!****************************!*\
  !*** ./src/useAuthInfo.ts ***!
  \****************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useAuthInfo = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const AuthContext_1 = __webpack_require__(/*! ./AuthContext */ "./src/AuthContext.tsx");
function useAuthInfo() {
    const context = (0, react_1.useContext)(AuthContext_1.AuthContext);
    if (context === undefined) {
        throw new Error("useAuthInfo must be used within an AuthProvider or RequiredAuthProvider");
    }
    const { loading, authInfo } = context;
    if (loading) {
        return {
            loading: true,
        };
    }
    else if (authInfo && authInfo.accessToken) {
        return {
            loading: false,
            isLoggedIn: true,
            accessToken: authInfo.accessToken,
            orgHelper: authInfo.orgHelper,
            accessHelper: authInfo.accessHelper,
            user: authInfo.user,
        };
    }
    return {
        loading: false,
        isLoggedIn: false,
        accessToken: null,
        user: null,
        orgHelper: null,
        accessHelper: null,
    };
}
exports.useAuthInfo = useAuthInfo;


/***/ }),

/***/ "./src/useLoginState.ts":
/*!******************************!*\
  !*** ./src/useLoginState.ts ***!
  \******************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLoginState = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const constants_1 = __webpack_require__(/*! ./components/constants */ "./src/components/constants.ts");
const useApi_1 = __webpack_require__(/*! ./useApi */ "./src/useApi.tsx");
const useLoginState = ({ overrideCurrentScreenForTesting }) => {
    const { loginApi } = (0, useApi_1.useApi)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(undefined);
    const [loginState, setLoginState] = (0, react_1.useState)(undefined);
    (0, react_1.useEffect)(() => {
        let mounted = true;
        setError(undefined);
        setLoading(true);
        loginApi
            .fetchLoginState()
            .then((response) => {
            if (mounted) {
                if (response.ok) {
                    setLoginState(response.body.loginState);
                }
                else {
                    setError(constants_1.UNEXPECTED_ERROR);
                }
            }
        })
            .catch((e) => {
            setError(constants_1.UNEXPECTED_ERROR);
            console.error(e);
        })
            .finally(() => setLoading(false));
        return () => {
            mounted = false;
        };
    }, [loginApi]);
    function getLoginState() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                setError(undefined);
                setLoading(true);
                const response = yield loginApi.fetchLoginState();
                if (response.ok) {
                    setLoginState(response.body.loginState);
                }
                else {
                    setError(constants_1.UNEXPECTED_ERROR);
                }
            }
            catch (e) {
                setError(constants_1.UNEXPECTED_ERROR);
                console.error(e);
            }
            finally {
                setLoading(false);
            }
        });
    }
    if (overrideCurrentScreenForTesting) {
        return {
            loginStateLoading: false,
            loginStateError: undefined,
            loginState: overrideCurrentScreenForTesting,
            getLoginState: () => setLoginState(overrideCurrentScreenForTesting),
        };
    }
    return {
        loginStateLoading: loading,
        loginStateError: error,
        loginState: loginState,
        getLoginState,
    };
};
exports.useLoginState = useLoginState;


/***/ }),

/***/ "./src/useLogoutFunction.ts":
/*!**********************************!*\
  !*** ./src/useLogoutFunction.ts ***!
  \**********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useLogoutFunction = void 0;
const react_1 = __webpack_require__(/*! react */ "react");
const AuthContext_1 = __webpack_require__(/*! ./AuthContext */ "./src/AuthContext.tsx");
function useLogoutFunction() {
    const context = (0, react_1.useContext)(AuthContext_1.AuthContext);
    if (context === undefined) {
        throw new Error("useLogoutFunction must be used within an AuthProvider or RequiredAuthProvider");
    }
    const { logout } = context;
    return logout;
}
exports.useLogoutFunction = useLogoutFunction;


/***/ }),

/***/ "./src/useRedirectFunctions.tsx":
/*!**************************************!*\
  !*** ./src/useRedirectFunctions.tsx ***!
  \**************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RedirectToLogin = exports.RedirectToSignup = exports.useRedirectFunctions = void 0;
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const AuthContext_1 = __webpack_require__(/*! ./AuthContext */ "./src/AuthContext.tsx");
function useRedirectFunctions() {
    const context = (0, react_1.useContext)(AuthContext_1.AuthContext);
    if (context === undefined) {
        throw new Error("useRedirectFunctions must be used within an AuthProvider or RequiredAuthProvider");
    }
    const { redirectToAccountPage, redirectToSignupPage, redirectToLoginPage, redirectToOrgPage, redirectToCreateOrgPage, } = context;
    return {
        redirectToSignupPage,
        redirectToLoginPage,
        redirectToAccountPage,
        redirectToOrgPage,
        redirectToCreateOrgPage,
    };
}
exports.useRedirectFunctions = useRedirectFunctions;
function RedirectToSignup(props) {
    const { redirectToSignupPage } = useRedirectFunctions();
    redirectToSignupPage();
    return react_1.default.createElement(react_1.default.Fragment, null, props.children);
}
exports.RedirectToSignup = RedirectToSignup;
function RedirectToLogin(props) {
    const { redirectToLoginPage } = useRedirectFunctions();
    redirectToLoginPage();
    return react_1.default.createElement(react_1.default.Fragment, null, props.children);
}
exports.RedirectToLogin = RedirectToLogin;


/***/ }),

/***/ "./src/withAuthInfo.tsx":
/*!******************************!*\
  !*** ./src/withAuthInfo.tsx ***!
  \******************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.withAuthInfo = void 0;
const hoist_non_react_statics_1 = __importDefault(__webpack_require__(/*! hoist-non-react-statics */ "./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js"));
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const AuthContext_1 = __webpack_require__(/*! ./AuthContext */ "./src/AuthContext.tsx");
function withAuthInfo(Component, args) {
    const displayName = `withAuthInfo(${Component.displayName || Component.name || "Component"})`;
    const WithAuthInfoWrapper = (props) => {
        const context = (0, react_1.useContext)(AuthContext_1.AuthContext);
        if (context === undefined) {
            throw new Error("withAuthInfo must be used within an AuthProvider or RequiredAuthProvider");
        }
        function displayLoading() {
            if (args && args.displayWhileLoading) {
                return args.displayWhileLoading;
            }
            else {
                return react_1.default.createElement(react_1.default.Fragment, null);
            }
        }
        const { loading, authInfo } = context;
        if (loading) {
            return displayLoading();
        }
        else if (authInfo) {
            const loggedInProps = Object.assign(Object.assign({}, props), { accessToken: authInfo.accessToken, isLoggedIn: !!authInfo.accessToken, orgHelper: authInfo.orgHelper, accessHelper: authInfo.accessHelper, user: authInfo.user });
            return react_1.default.createElement(Component, Object.assign({}, loggedInProps));
        }
        else {
            const notLoggedInProps = Object.assign(Object.assign({}, props), { accessToken: null, isLoggedIn: false, user: null, orgHelper: null, accessHelper: null });
            return react_1.default.createElement(Component, Object.assign({}, notLoggedInProps));
        }
    };
    WithAuthInfoWrapper.displayName = displayName;
    WithAuthInfoWrapper.WrappedComponent = Component;
    return (0, hoist_non_react_statics_1.default)(WithAuthInfoWrapper, Component);
}
exports.withAuthInfo = withAuthInfo;


/***/ }),

/***/ "./src/withConfig.tsx":
/*!****************************!*\
  !*** ./src/withConfig.tsx ***!
  \****************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.withConfig = void 0;
const hoist_non_react_statics_1 = __importDefault(__webpack_require__(/*! hoist-non-react-statics */ "./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js"));
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const ErrorMessage_1 = __webpack_require__(/*! ./components/ErrorMessage */ "./src/components/ErrorMessage.tsx");
const Loading_1 = __webpack_require__(/*! ./components/Loading */ "./src/components/Loading.tsx");
const ConfigProvider_1 = __webpack_require__(/*! ./ConfigProvider */ "./src/ConfigProvider.tsx");
function withConfig(Component, args) {
    const displayName = `withConfig(${Component.displayName || Component.name || "Component"})`;
    const WithConfigWrapper = (props) => {
        const context = (0, react_1.useContext)(ConfigProvider_1.ConfigContext);
        if (context === undefined) {
            throw new Error("useConfig must be used within an ConfigProvider");
        }
        const withConfigProps = Object.assign(Object.assign({}, props), { config: context.config, configLoading: context.loading, configError: context.error });
        if (context.config) {
            return react_1.default.createElement(Component, Object.assign({}, withConfigProps));
        }
        else if (context.error) {
            return react_1.default.createElement(ErrorMessage_1.ErrorMessage, { appearance: args === null || args === void 0 ? void 0 : args.appearance });
        }
        else {
            return react_1.default.createElement(Loading_1.Loading, { appearance: args === null || args === void 0 ? void 0 : args.appearance });
        }
    };
    WithConfigWrapper.displayName = displayName;
    WithConfigWrapper.WrappedComponent = Component;
    return (0, hoist_non_react_statics_1.default)(WithConfigWrapper, Component);
}
exports.withConfig = withConfig;


/***/ }),

/***/ "./src/withRequiredAuthInfo.tsx":
/*!**************************************!*\
  !*** ./src/withRequiredAuthInfo.tsx ***!
  \**************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.withRequiredAuthInfo = void 0;
const hoist_non_react_statics_1 = __importDefault(__webpack_require__(/*! hoist-non-react-statics */ "./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js"));
const react_1 = __importStar(__webpack_require__(/*! react */ "react"));
const AuthContext_1 = __webpack_require__(/*! ./AuthContext */ "./src/AuthContext.tsx");
const useRedirectFunctions_1 = __webpack_require__(/*! ./useRedirectFunctions */ "./src/useRedirectFunctions.tsx");
function withRequiredAuthInfo(Component, args) {
    const displayName = `withRequiredAuthInfo(${Component.displayName || Component.name || "Component"})`;
    const WithRequiredAuthInfoWrapper = (props) => {
        const context = (0, react_1.useContext)(AuthContext_1.AuthContext);
        if (context === undefined) {
            throw new Error("withRequiredAuthInfo must be used within an AuthProvider or RequiredAuthProvider");
        }
        function displayLoading() {
            if (args && args.displayWhileLoading) {
                return args.displayWhileLoading;
            }
            else {
                return react_1.default.createElement(react_1.default.Fragment, null);
            }
        }
        function displayLoggedOut() {
            if (args && args.displayIfLoggedOut) {
                return args.displayIfLoggedOut;
            }
            else {
                return react_1.default.createElement(useRedirectFunctions_1.RedirectToLogin, null);
            }
        }
        const { loading, authInfo } = context;
        if (loading) {
            return displayLoading();
        }
        else if (authInfo) {
            const loggedInProps = Object.assign(Object.assign({}, props), { accessToken: authInfo.accessToken, isLoggedIn: !!authInfo.accessToken, orgHelper: authInfo.orgHelper, accessHelper: authInfo.accessHelper, user: authInfo.user });
            return react_1.default.createElement(Component, Object.assign({}, loggedInProps));
        }
        else {
            return displayLoggedOut();
        }
    };
    WithRequiredAuthInfoWrapper.displayName = displayName;
    WithRequiredAuthInfoWrapper.WrappedComponent = Component;
    return (0, hoist_non_react_statics_1.default)(WithRequiredAuthInfoWrapper, Component);
}
exports.withRequiredAuthInfo = withRequiredAuthInfo;


/***/ }),

/***/ "react":
/*!**************************************************************************************!*\
  !*** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"} ***!
  \**************************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./src/index.tsx");
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=propelauth-react.js.map